var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 51,
    viewBox: "0 0 106 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.4411 42.2895C64.4411 42.2895 64.1443 24.5495 51.0571 23.4716C51.0571 23.4716 50.0418 20.4686 57.2888 20.889C64.5359 21.3094 68.2667 32.8474 64.4411 42.2895Z",
    fill: "#272525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.161 33.2676C104.161 33.2676 104.057 23.0731 99.4248 22.4551C99.4248 22.4551 99.0648 20.7292 101.635 20.971C104.206 21.2128 105.511 27.8384 104.161 33.2676Z",
    fill: "#272525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5126 42.0378C40.5126 42.0378 40.2331 44.2253 43.1224 46.9801C43.1224 46.9801 47.0696 49.381 50.3174 50.0148C50.3174 50.0148 53.9835 50.9331 56.6644 49.9452C59.3453 48.9574 44.0335 48.8879 44.886 34.0608C44.886 34.0608 45.8728 25.7993 53.3472 25.518C53.3472 25.518 57.9259 24.9537 60.5405 25.8705C60.5405 25.8705 59.2774 22.1277 51.3736 23.4001C43.4698 24.6724 39.2432 32.0851 40.5126 42.0378Z",
    fill: "url(#paint0_linear_49_3501)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5273 36.7781C65.5273 44.1845 60.2523 50.317 54.2178 50.317C48.1834 50.317 43.7562 44.1529 43.7562 36.7433C43.7562 29.3337 49.2823 23.4004 55.323 23.4004C61.3638 23.4004 65.5273 29.3685 65.5273 36.7781Z",
    fill: "url(#paint1_linear_49_3501)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.599 24.493C103.599 24.493 102.782 22.5663 101.267 22.3893C99.7509 22.2123 97.4157 22.157 96.661 23.1796C95.9063 24.2022 91.7665 28.0492 91.9086 32.078C92.0507 36.1068 92.4912 37.0694 93.0722 37.768C93.6533 38.4666 94.1774 39.083 94.9669 39.143C95.7563 39.2031 100.177 39.6172 100.177 39.6172C100.177 39.6172 101.77 39.3137 102.353 38.1473L103.599 24.493Z",
    fill: "url(#paint2_linear_49_3501)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.436 31.1727C104.113 35.6788 102.455 39.2334 100.732 39.1054C99.0096 38.9774 97.8807 35.2299 98.206 30.7285C98.5312 26.2272 100.186 22.6678 101.907 22.7974C103.628 22.927 104.76 26.6729 104.436 31.1727Z",
    fill: "url(#paint3_linear_49_3501)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8688 38.0979C62.111 43.456 57.8701 47.2793 53.3956 46.6471C48.9211 46.0149 45.9054 41.1563 46.6633 35.8014C47.4212 30.4465 51.6589 26.6137 56.1365 27.246C60.6142 27.8782 63.6235 32.7383 62.8688 38.0979Z",
    fill: "#272525"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.478 31.2746C103.254 34.6553 102.014 37.3296 100.707 37.2427C99.3997 37.1558 98.5124 34.3471 98.7334 30.9632C98.9545 27.5793 100.192 24.9113 101.506 24.9951C102.82 25.0789 103.697 27.8938 103.478 31.2746Z",
    fill: "#6D6E70"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2061 27.3339C51.7269 26.7017 47.486 30.5282 46.7329 35.8878C45.9798 41.2474 48.9907 46.0997 53.47 46.7335C57.9492 47.3673 62.1853 43.5345 62.9432 38.178C63.701 32.8216 60.6775 27.9646 56.2061 27.3339ZM50.3927 30.3796C50.4701 30.3623 52.0427 32.8074 52.0174 33.3273C52.0174 33.3273 50.0801 30.9233 49.8496 30.6515C49.8496 30.6515 50.3154 30.4018 50.3927 30.3796ZM47.9281 33.8157C47.9281 33.8157 49.578 34.4385 50.2743 34.7498C50.9706 35.0612 51.1869 35.665 51.0511 35.9337C50.7606 36.4963 50.0438 36.4189 50.0438 36.4189C49.1683 36.2896 48.2998 36.116 47.4418 35.8989C47.426 35.1165 47.9281 33.8157 47.9281 33.8157ZM47.4229 39.3476C48.4889 39.0999 49.5391 38.7885 50.568 38.4151C51.1869 38.1448 50.8569 38.6285 50.8569 38.6285C50.3738 39.1153 47.6771 40.3386 47.6771 40.3386L47.4229 39.3476ZM52.45 40.8033C52.1958 42.319 50.5096 43.9502 50.5096 43.9502C50.3517 43.9296 49.3602 43.2089 49.3602 43.2089C49.7122 42.9955 52.0585 40.2406 52.0585 40.2406C52.5653 40.3797 52.45 40.8065 52.45 40.8065V40.8033ZM54.8183 32.3174C54.8183 32.3174 54.6131 33.2041 54.1599 32.9022C54.1015 32.8611 53.7115 29.7411 53.4605 28.9777C53.4605 28.9777 54.4883 28.9603 54.6604 29.0188C54.6573 29.022 55.0851 31.3896 54.8152 32.3205L54.8183 32.3174ZM57.125 42.8817C57.0508 42.6272 56.3514 40.9203 56.1572 40.5899C55.963 40.2596 56.0625 40.0083 56.2677 39.8502C56.473 39.6922 56.4035 39.8502 56.8093 39.9482C57.215 40.0462 58.0724 41.9097 58.0724 41.9097C57.8782 42.4186 57.1219 42.8849 57.1219 42.8849L57.125 42.8817ZM59.5107 39.0884C59.5107 39.0884 58.6771 38.6806 58.0582 38.4562C57.4392 38.2318 57.1582 37.9599 57.2435 37.7955C57.4187 37.4462 59.8044 38.0864 59.8044 38.0864C59.7561 38.4364 59.6561 38.7773 59.5076 39.0979L59.5107 39.0884ZM59.8991 35.0976C59.8991 35.0976 58.6565 35.8372 57.9034 35.8752C57.9034 35.8752 57.0856 35.8372 57.4582 34.9269C57.4582 34.9269 59.2597 33.7051 59.5312 33.5281C59.5281 33.5281 59.9733 34.8289 59.8991 35.0976Z",
    fill: "url(#paint4_linear_49_3501)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.437 24.9728C100.128 24.8858 98.8856 27.557 98.6693 30.9409C98.453 34.3248 99.3277 37.1319 100.638 37.2188C101.949 37.3057 103.19 34.633 103.411 31.2507C103.632 27.8683 102.746 25.0581 101.437 24.9728ZM99.2014 30.2265C99.2014 30.2265 99.2014 30.6611 99.0293 30.6738C99.0293 30.6738 98.7546 30.6738 98.7546 30.6327C98.7546 30.5916 98.884 29.7002 98.884 29.7002C98.9931 29.7323 99.0861 29.8042 99.1449 29.9016C99.2036 29.999 99.2238 30.1149 99.2014 30.2265Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7266 30.5052C49.7518 30.4451 50.9897 29.1965 51.3165 29.0605C51.3165 29.0605 51.5233 29.4478 50.3944 30.3803L49.8623 30.6521L49.7266 30.5052Z",
    fill: "url(#paint5_linear_49_3501)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3161 29.0605C51.3161 29.0605 52.6234 30.8845 53.9907 35.4396L53.5249 34.8248C53.5249 34.8248 53.3671 34.858 53.0402 34.5924C52.5997 34.2416 52.0219 33.3501 52.0219 33.3501C52.0219 33.3501 52.0771 32.7985 50.4067 30.3803C50.4067 30.3803 51.2245 29.2881 51.3161 29.0605Z",
    fill: "url(#paint6_linear_49_3501)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4046 32.4214C48.4046 32.4214 47.1415 34.5567 47.1257 36.9038C47.1257 36.9038 47.3009 36.8279 47.3404 36.7284C47.4192 35.7238 47.6475 34.7366 48.0177 33.7996C48.0177 33.7996 48.3082 33.041 48.4046 32.8829C48.4248 32.7297 48.4248 32.5746 48.4046 32.4214Z",
    fill: "url(#paint7_linear_49_3501)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4039 32.4214C48.4039 32.4214 52.4411 35.1763 53.2337 35.9713C53.2337 35.9713 52.1679 35.3896 51.8127 35.4687C51.5711 35.5273 51.3328 35.5991 51.099 35.6836C51.0974 35.5679 51.0678 35.4542 51.0129 35.3524C50.9579 35.2506 50.8791 35.1636 50.7832 35.0988C50.4548 34.8681 47.9997 33.8202 47.9997 33.8202C47.9997 33.8202 48.3297 33.041 48.3913 32.845C48.4255 32.7063 48.4298 32.5619 48.4039 32.4214Z",
    fill: "url(#paint8_linear_49_3501)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4541 35.8989L47.3404 36.7319C47.286 36.8087 47.2118 36.8694 47.1257 36.9073C47.1257 36.9073 47.263 37.1412 50.0497 37.0654L52.8475 36.9863C52.8475 36.9863 51.4123 36.7761 51.3728 36.5232C51.3119 36.3245 51.1984 36.1459 51.0444 36.0064C51.0444 36.0064 50.7413 36.3336 50.5708 36.3525C50.4003 36.3715 49.3361 36.3826 47.4541 35.8989Z",
    fill: "url(#paint9_linear_49_3501)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4138 39.3848C47.4138 39.3848 47.6727 40.2588 47.7075 40.3331C47.8212 40.6695 47.914 41.0126 47.9853 41.3604C47.9706 41.4504 47.9261 41.5328 47.859 41.5944C47.859 41.5944 47.2875 39.7752 47.2748 39.4037L47.4138 39.3848Z",
    fill: "url(#paint10_linear_49_3501)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.85 38.3228C50.8838 38.3375 50.9152 38.3572 50.9431 38.3813C50.9558 38.405 52.2694 37.983 52.3752 37.9245C52.4809 37.866 52.732 37.6352 52.9325 37.5783C53.0457 37.5453 53.1557 37.5019 53.2609 37.4487L50.85 38.3228Z",
    fill: "url(#paint11_linear_49_3501)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9431 38.4514C51.3868 38.3019 51.8386 38.1773 52.2962 38.0784C52.4904 38.0547 52.7588 38.1131 52.8535 38.0784C52.9483 38.0436 53.2703 37.9029 53.3272 37.8682C51.6153 39.2533 49.8036 40.5101 47.9069 41.6283C47.9069 41.6283 48.1943 41.6678 47.7064 40.3259C47.6922 40.2927 51.0378 38.8355 50.9431 38.4514Z",
    fill: "url(#paint12_linear_49_3501)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3733 43.1953C49.3733 43.1953 50.4311 43.916 50.4785 43.9429L50.5274 43.965L50.3506 44.3254C50.3506 44.3254 51.5869 44.9055 51.8537 45.2737C52.1205 45.642 52.0258 45.691 52.04 45.7479C52.0542 45.8048 52.2484 45.9455 52.2484 45.9455C50.9913 45.4427 49.8905 44.6141 49.0591 43.5446L49.3733 43.1953Z",
    fill: "url(#paint13_linear_49_3501)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4329 40.5249C52.433 40.9713 52.3094 41.409 52.0761 41.7893C51.6409 42.5717 51.1152 43.3001 50.5098 43.9594L50.3519 44.3467C50.3519 44.3467 51.7255 44.9409 51.9308 45.3171C52.0495 45.4997 52.1315 45.7037 52.1724 45.9177C52.1724 45.9177 53.5934 42.4627 54.0386 39.1641C54.0386 39.1641 53.6218 39.9796 53.3881 40.3068C53.3881 40.3052 52.8529 40.8995 52.4329 40.5249Z",
    fill: "url(#paint14_linear_49_3501)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5547 39.678C52.5547 39.678 52.771 39.8361 52.7631 39.9467C52.7552 40.0574 52.3889 40.3893 52.3889 40.3893C52.3889 40.3893 52.1805 40.1996 52.0731 40.2597C51.8311 40.5028 51.6034 40.7598 51.3911 41.0294C51.3911 41.0294 52.5894 39.4915 53.0883 38.7866L52.5547 39.678Z",
    fill: "url(#paint15_linear_49_3501)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5785 38.7185C54.5785 38.7185 54.49 38.6158 54.5327 39.3792C54.5753 40.1426 54.6337 41.6709 54.1885 45.8325C54.1885 45.8325 54.1458 46.0332 54.1032 46.3367C54.1032 46.3367 55.3426 46.3525 56.0279 46.136C56.0279 46.136 56.0436 43.2689 54.9084 38.7596C54.9084 38.7596 54.9811 39.4803 54.6337 39.7079C54.6337 39.7111 54.5058 38.8607 54.5785 38.7185Z",
    fill: "url(#paint16_linear_49_3501)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0848 38.27C56.0848 38.27 56.3911 38.4802 56.6169 38.6588C56.6169 38.6588 60.1851 41.6334 60.8309 42.3431C60.0108 42.2192 59.176 42.2315 58.3599 42.3794C58.3599 42.3794 57.2958 40.2741 56.9074 40.0086C56.6974 39.9106 56.5016 39.8948 56.4053 39.811C56.4053 39.811 55.9727 40.1019 56.1037 40.4749C56.1037 40.4749 55.6869 39.8537 56.4053 39.5724C56.4053 39.5724 56.9074 39.6656 56.6974 39.2468C56.4874 38.8279 56.3232 38.3996 56.0848 38.27Z",
    fill: "url(#paint17_linear_49_3501)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3286 43.458C57.3286 43.458 58.2396 42.6109 58.3611 42.3817C58.3611 42.3817 59.569 42.1841 60.0837 42.3327C59.5276 43.2915 58.7179 44.078 57.7438 44.6055C57.7438 44.6055 57.3475 43.5639 57.3286 43.458Z",
    fill: "url(#paint18_linear_49_3501)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7559 44.6913L57.8916 45.2539C57.8916 45.2539 59.3442 44.7671 60.8583 42.4769L60.4668 42.3584L60.3326 42.4185L59.9837 42.7346C59.3875 43.5371 58.6282 44.204 57.7559 44.6913Z",
    fill: "url(#paint19_linear_49_3501)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1402 42.1489L58.3202 42.3908C58.3202 42.3908 57.6081 43.1905 57.3144 43.4007L57.2181 43.1462C57.2181 43.1462 58.0044 42.4318 58.1402 42.1489Z",
    fill: "#6D6E70"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.019 37.479C56.019 37.479 55.9511 37.6165 56.0869 37.6623C56.2227 37.7082 59.393 39.1512 59.5493 39.2287C59.5493 39.2287 59.6662 38.8477 59.753 38.4226C59.753 38.4226 59.5493 39.0311 59.4593 39.0311C59.3694 39.0311 58.4331 38.587 58.1631 38.47C57.8931 38.353 57.241 38.1539 57.2505 37.7904L56.6079 37.6465C56.6079 37.6465 55.9527 37.7951 56.019 37.479Z",
    fill: "url(#paint20_linear_49_3501)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1225 37.264C56.1707 37.2542 56.2205 37.2552 56.2683 37.2669C56.316 37.2787 56.3606 37.3009 56.3988 37.3319C56.4644 37.4133 56.5416 37.4846 56.6277 37.5437C56.6814 37.5674 57.2593 37.7808 57.2593 37.7808C57.2593 37.7808 57.3177 37.6875 57.6651 37.6923C58.3935 37.7534 59.1143 37.8858 59.817 38.0874C59.8087 38.2079 59.7854 38.3268 59.7476 38.4415L59.8723 38.0843C59.8723 38.0969 60.3097 38.2012 60.3097 38.2012L62.4348 38.236C62.4348 38.236 58.655 37.6038 58.2698 37.5516C57.8845 37.4995 56.1967 37.1628 56.1225 37.264Z",
    fill: "url(#paint21_linear_49_3501)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5084 38.3023C60.5084 38.3023 60.2179 39.4561 60.1579 39.5035L59.5485 39.2348C59.5485 39.2348 61.6657 40.2922 61.8078 40.4076C61.8078 40.4076 61.3578 40.1547 61.3578 40.0789C61.3578 40.003 61.8078 38.6232 61.8457 38.3608C61.8271 38.3081 61.8004 38.2585 61.7668 38.2138L60.3016 38.2012C60.3016 38.2012 60.4895 38.2344 60.5084 38.3023Z",
    fill: "url(#paint22_linear_49_3501)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0086 38.1304C60.0086 38.1304 59.786 39.0597 59.6833 39.2842C59.7591 39.332 59.8389 39.3733 59.9218 39.4075C59.9218 39.3916 60.1807 38.4591 60.2581 38.1983L60.0086 38.1304Z",
    fill: "url(#paint23_linear_49_3501)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5237 31.7896C61.5237 31.7896 62.2799 32.7948 62.512 34.7009C62.564 35.1073 62.5941 35.5162 62.602 35.9258L62.1378 35.6097C62.1378 35.6097 61.4194 32.4392 61.1305 32.3222C61.1305 32.3222 61.0137 32.338 61.0721 32.4392C61.0526 32.3957 61.0478 32.347 61.0583 32.3006C61.0688 32.2541 61.0942 32.2123 61.1305 32.1815C61.26 32.0788 61.4526 31.8164 61.5237 31.7896Z",
    fill: "url(#paint24_linear_49_3501)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4979 35.9665C62.4979 35.9665 61.9295 35.7752 61.8837 35.6899L62.0321 35.6188C62.0321 35.6188 61.5237 33.1136 61.0721 32.4419C61.0721 32.4419 61.0263 32.3549 61.0721 32.3123C61.1179 32.2696 61.4637 31.8618 61.4637 31.8618C61.4637 31.8618 59.6748 33.4424 58.7875 34.0161C58.2649 34.3487 57.76 34.7085 57.2749 35.094C56.8889 35.3247 56.5195 35.5825 56.1697 35.8653C56.1697 35.8653 56.9402 35.2537 57.1171 35.3912C57.1171 35.3912 57.2623 35.5065 57.0602 35.6093C57.056 35.7157 57.0773 35.8216 57.1223 35.9182C57.1674 36.0147 57.2349 36.099 57.3192 36.164C57.3192 36.164 57.496 36.2209 57.5418 36.164C57.5418 36.164 57.5418 36.3964 56.7397 36.6382C56.6368 36.6714 56.5311 36.6952 56.4239 36.7093C56.4239 36.7093 60.248 36.4185 61.6153 36.1261C61.6153 36.1261 61.7305 35.6899 61.8031 35.7484C61.8758 35.8068 62.0526 36.0281 61.9784 36.055L62.4979 35.9665ZM57.9097 35.8748C57.9097 35.8748 57.1202 35.8068 57.436 34.9913L59.5327 33.5388C59.5327 33.5388 59.708 33.6968 59.9227 35.0814C59.9227 35.0814 58.658 35.84 57.9097 35.8748Z",
    fill: "url(#paint25_linear_49_3501)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7031 29.2407C58.0465 30.9994 57.1808 32.6725 56.1249 34.2242C56.0381 34.4303 55.9935 34.6517 55.9938 34.8753C56.0238 35.1519 55.7759 35.5471 55.7601 35.5898C55.7601 35.5898 59.2542 32.0209 60.2125 30.2317C60.0404 30.3013 59.859 30.3455 59.6742 30.3629C59.7474 30.3273 59.8163 30.2833 59.8794 30.2317L58.7031 29.2407Z",
    fill: "url(#paint26_linear_49_3501)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4478 28.8306C53.4478 28.8306 54.523 28.788 54.594 28.8465C54.7977 29.6548 54.9168 30.4822 54.9493 31.3153C54.9493 31.3153 54.9619 32.654 54.4646 32.9306C54.4646 32.9306 54.8435 32.7125 54.9761 33.0033C54.9761 33.0033 55.1056 33.0317 55.1908 33.2799C55.2761 33.528 55.265 34.4605 55.2524 34.7229C55.2524 34.7229 56.9229 30.3985 56.9686 28.1842C56.9686 28.1842 56.3118 28.6916 55.0187 28.5762C55.0187 28.5762 56.0924 28.6189 56.5597 28.328C55.5195 28.0938 54.4398 28.0992 53.402 28.3438V28.5193C53.402 28.5193 54.3809 28.4023 54.6572 28.5193V28.7674C54.6572 28.7674 53.5062 28.7453 53.4478 28.8306Z",
    fill: "url(#paint27_linear_49_3501)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4942 32.9911C54.4752 33.0666 54.4848 33.1466 54.5211 33.2155C54.5811 33.2914 54.5811 33.4257 54.4753 33.4431C54.3695 33.4605 54.2637 33.3973 54.2511 33.4858C54.2379 33.758 54.2485 34.0309 54.2827 34.3013C54.3127 34.4373 54.1579 32.9626 54.1248 32.735C54.0916 32.5074 54.0916 33.1317 54.4942 32.9911Z",
    fill: "url(#paint28_linear_49_3501)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7101 34.3184C52.7101 34.3184 53.0511 34.7467 53.1253 34.8036C53.2148 34.894 53.2851 35.0015 53.3322 35.1197C53.3622 35.1861 53.4758 35.4358 53.5327 35.518C53.5895 35.6002 53.749 35.7772 53.749 35.7772C53.749 35.7772 52.7101 34.3516 52.7101 34.3184Z",
    fill: "url(#paint29_linear_49_3501)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0597 35.8882C52.8576 35.8724 52.4392 35.863 52.3618 36.3624C52.2939 36.7386 52.6665 36.9235 52.7786 36.9488C52.7786 36.9488 52.4392 36.9124 52.035 36.8302C52.2576 36.8929 52.4845 36.9394 52.7139 36.9693C52.7139 36.9693 52.5749 36.9915 52.1881 37.0073C52.1881 37.0073 53.0391 37.0974 53.2144 36.8192C53.295 36.7114 53.346 36.5843 53.3623 36.4507C53.3787 36.317 53.3598 36.1814 53.3075 36.0574L52.376 35.2671L52.9965 35.825L52.365 35.5532L53.0597 35.8882Z",
    fill: "url(#paint30_linear_49_3501)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0893 38.8406C53.2027 38.6649 53.344 38.509 53.5077 38.3791C53.5825 38.3556 53.6624 38.3542 53.738 38.3749C53.8136 38.3956 53.8816 38.4377 53.934 38.496C54.0249 38.6052 54.0716 38.7445 54.0651 38.8864C54.0631 38.9757 54.0525 39.0647 54.0335 39.1519C54.0177 39.1946 53.443 40.2141 53.443 40.2141L53.9972 39.1519C53.9972 39.1519 53.574 39.6087 53.2077 39.3021C53.1473 39.2436 53.1043 39.1696 53.0834 39.0881C53.0625 39.0066 53.0645 38.9209 53.0893 38.8406Z",
    fill: "url(#paint31_linear_49_3501)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8146 38.1748C55.6804 38.208 55.3409 38.4103 55.3899 38.7296C55.4114 38.9009 55.4678 39.0661 55.5556 39.2148C55.6215 39.2327 55.691 39.2323 55.7566 39.2136C55.8223 39.195 55.8816 39.1588 55.9283 39.1089C56.1351 38.9335 56.0656 38.9145 56.0861 38.8639C56.1067 38.8133 56.2709 38.4846 56.1461 38.3028C56.1461 38.3028 56.3845 38.4846 56.5345 38.6047C56.533 38.6047 56.0467 38.1195 55.8146 38.1748Z",
    fill: "url(#paint32_linear_49_3501)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.71 35.4609C56.5081 35.5916 56.3226 35.746 56.1574 35.9209C56.0421 36.0868 55.9995 36.395 56.1416 36.5215C56.2837 36.6479 56.4495 36.7981 56.6642 36.6416C56.7279 36.5644 56.7748 36.4748 56.802 36.3785C56.8292 36.2822 56.836 36.1812 56.8221 36.0821C56.8221 36.0821 56.7731 35.6901 56.53 35.6411C56.5816 35.5732 56.6422 35.5126 56.71 35.4609Z",
    fill: "url(#paint33_linear_49_3501)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M54.281 34.4501C54.281 34.4501 54.4389 34.1529 54.6773 34.1908C54.9157 34.2288 55.0641 34.4738 55.1399 34.6018C55.2157 34.7298 55.1983 34.7598 55.1983 34.7598L55.4146 34.2762C55.3383 34.5351 55.2395 34.7869 55.1194 35.0285C55.0742 35.1211 54.9996 35.196 54.9073 35.2415C54.815 35.287 54.7102 35.3005 54.6094 35.2798C54.352 35.2435 54.2289 34.7662 54.281 34.4501Z",
    fill: "url(#paint34_linear_49_3501)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1015 34.2788L55.9136 34.6344C55.8378 34.7688 55.6404 35.1481 55.6309 35.1797C55.6215 35.2113 55.4936 35.2904 55.4889 35.3488C55.4841 35.4073 55.4889 35.518 55.4889 35.518C55.4889 35.518 55.4083 35.4658 55.421 35.4405C55.4336 35.4152 56.1015 34.2788 56.1015 34.2788Z",
    fill: "url(#paint35_linear_49_3501)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7103 33.3583C59.7103 33.3583 60.0672 34.4394 60.0845 34.9484L60.0735 35.0084C60.162 34.9875 60.2475 34.9551 60.3277 34.912C60.3545 34.8741 60.0514 33.4089 59.914 33.1924L59.7103 33.3583Z",
    fill: "url(#paint36_linear_49_3501)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4086 34.862C60.4985 34.8548 60.5866 34.8323 60.6691 34.7956C60.7212 34.7498 60.5554 34.8177 60.5396 34.6123C60.462 34.0751 60.3357 33.546 60.1623 33.0317L59.9791 33.1677C59.9791 33.1677 60.4544 34.5823 60.4086 34.862Z",
    fill: "url(#paint37_linear_49_3501)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3337 44.9966C54.3337 44.9966 55.5352 45.349 55.7026 45.5924C55.8217 45.7671 55.9303 45.9486 56.0279 46.1362C56.0279 46.1362 54.8326 46.4523 54.1032 46.3369C54.1032 46.3306 54.3243 45.0914 54.3337 44.9966Z",
    fill: "url(#paint38_linear_49_3501)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7042 45.6357C55.7042 45.6357 54.7316 45.8618 54.1885 45.8333L54.1032 46.3375C54.7517 46.3948 55.4051 46.3267 56.0279 46.1368L55.7042 45.6357Z",
    fill: "url(#paint39_linear_49_3501)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2302 43.3364C49.4796 43.6857 50.3101 44.3243 50.3101 44.3243L50.4001 44.1362V44.1061C50.2422 44.1172 49.2302 43.3364 49.2302 43.3364Z",
    fill: "url(#paint40_linear_49_3501)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8796 45.2826C51.8528 45.232 51.8165 45.3569 51.7407 45.3158C50.8344 44.8204 49.995 44.2111 49.2429 43.5029C49.2429 43.5029 49.4876 44.1193 51.0191 45.153C50.3032 44.7466 49.6688 44.2106 49.1482 43.5725L49.1071 43.6136C49.1071 43.6136 50.0844 44.995 52.1733 45.9148C52.1251 45.8613 52.0803 45.8048 52.0391 45.7457C52.0249 45.7141 52.1117 45.7252 51.8796 45.2826Z",
    fill: "url(#paint41_linear_49_3501)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3975 39.6089L47.8601 41.2827L47.5033 39.8239L47.9186 41.1199C47.9186 41.1199 48.0117 41.436 47.8601 41.5941L47.3044 39.522L47.7433 41.0045L47.3975 39.6089Z",
    fill: "#EFEFF0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0344 36.0396C50.9477 36.1406 50.8538 36.2351 50.7534 36.3225C50.8029 36.3852 50.8276 36.4639 50.8228 36.5437C50.8027 36.667 50.7953 36.792 50.8007 36.9167C50.8228 36.9626 50.8228 36.9626 50.6823 37.01C50.6823 37.01 52.3149 36.9926 52.6448 36.9736C52.6448 36.9736 51.6328 36.8061 51.4307 36.5722C51.2286 36.3383 51.1686 36.087 51.0344 36.0396Z",
    fill: "url(#paint42_linear_49_3501)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 30.2997C58.7291 30.3647 59.1871 30.39 59.6448 30.3755C59.7259 30.3322 59.8044 30.2842 59.88 30.2317L58.7037 29.2407C58.7037 29.2407 58.4338 29.9788 58.2759 30.2997Z",
    fill: "url(#paint43_linear_49_3501)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6375 28.9453C54.6375 28.9453 55.5075 29.5775 55.569 30.6539C55.6306 31.7302 55.3638 32.4652 55.127 32.4367C55.127 32.4367 54.9028 32.2787 54.8728 32.3609C54.8303 32.4443 54.7736 32.5197 54.7054 32.5837C54.8716 31.8887 54.9333 31.1727 54.8886 30.4595C54.7986 29.3578 54.7733 29.3736 54.6375 28.9453Z",
    fill: "url(#paint44_linear_49_3501)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0068 30.9326C58.1239 31.2159 58.2179 31.5082 58.2878 31.8067L56.27 33.991C56.27 33.991 57.8836 31.127 58.0068 30.9326Z",
    fill: "url(#paint45_linear_49_3501)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1039 30.7198C58.2186 30.9644 58.3126 31.2182 58.385 31.4785C58.385 31.4785 58.6487 31.6808 58.4118 30.9632L58.2287 30.4385L58.1039 30.7198Z",
    fill: "url(#paint46_linear_49_3501)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0154 30.8952C58.0154 30.8952 58.2602 31.5274 58.306 31.7376C58.306 31.7376 58.4338 31.5258 58.0644 30.7798L58.0154 30.8952Z",
    fill: "url(#paint47_linear_49_3501)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5171 40.6139C52.5171 40.6139 52.5471 41.066 52.4903 41.1639C52.4903 41.1639 52.8645 41.1971 52.8376 41.4137C52.8108 41.6302 52.8803 41.8878 52.6198 42.362C52.3592 42.8362 51.8477 43.5585 51.8477 43.5585C51.8477 43.5585 52.3719 43.5142 52.1398 44.1101C52.0318 44.4091 51.8954 44.697 51.7324 44.9699L52.0387 45.3777L52.4792 45.0616C53.0429 43.5026 53.4987 41.9067 53.8434 40.2852C53.8434 40.2852 53.6381 40.5475 53.5639 40.4575C53.4897 40.3674 53.5323 40.1413 53.6965 39.8047C53.6965 39.8047 53.3808 40.4748 53.0981 40.5744C52.9104 40.6336 52.7112 40.6472 52.5171 40.6139Z",
    fill: "url(#paint48_linear_49_3501)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1631 33.5284C52.2303 33.5327 52.2967 33.5115 52.3491 33.469C52.4014 33.4266 52.4359 33.366 52.4457 33.2992C52.4931 33.0448 52.3478 32.52 52.3478 32.52C52.3478 32.52 52.6967 33.6074 53.0757 33.8097C53.4546 34.0121 53.4136 33.9283 53.2683 33.5189C53.2683 33.5189 53.5683 34.4325 53.6851 34.8782L53.8809 35.286L53.5193 34.8118C53.5193 34.8118 53.3046 34.8545 52.7046 34.3092L52.1631 33.5284Z",
    fill: "url(#paint49_linear_49_3501)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9984 35.2435V35.3162C51.0341 35.3875 51.0642 35.4615 51.0883 35.5375C51.1019 35.5848 51.1093 35.6337 51.1105 35.6829C51.2921 35.605 51.4795 35.541 51.671 35.4917C51.8288 35.468 51.5399 35.2609 51.5399 35.2609C51.5399 35.2609 51.9757 35.3889 52.2046 35.4806C52.4335 35.5723 52.994 35.8157 52.994 35.8157L51.2747 34.4849C51.2747 34.4849 51.5904 35.0317 50.9984 35.2435Z",
    fill: "url(#paint50_linear_49_3501)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8003 38.6803C50.8003 38.6803 51.0766 38.6313 51.0182 39.0122C51.0182 39.0122 51.8629 38.8637 51.9513 38.881C52.0397 38.8984 52.6934 38.3705 52.6934 38.3705L52.4455 38.4417L52.8528 38.0781C52.6827 38.0999 52.5108 38.1052 52.3397 38.0939C52.3397 38.0939 51.1271 38.3721 50.9424 38.4511C50.9424 38.4511 50.8571 38.6803 50.8003 38.6803Z",
    fill: "url(#paint51_linear_49_3501)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7609 41.3618C59.7609 41.3618 60.0609 41.5957 60.0387 41.7411C60.0234 41.8956 60.016 42.0507 60.0166 42.2058L59.9156 42.2279C59.9156 42.2279 60.5835 42.2501 60.7145 42.318C60.7145 42.318 59.9582 41.5088 59.7609 41.3618Z",
    fill: "url(#paint52_linear_49_3501)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7699 41.4067C59.7699 41.4067 59.7826 41.6454 59.7826 41.7481C59.7978 41.8794 59.7978 42.012 59.7826 42.1433C59.7486 42.1713 59.7095 42.1923 59.6673 42.2049C59.6673 42.2049 60.0383 42.2429 60.0162 42.2049C59.9941 42.167 60.0667 41.7845 59.9736 41.6375C59.9175 41.5509 59.8489 41.4731 59.7699 41.4067Z",
    fill: "url(#paint53_linear_49_3501)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9886 35.1082C59.931 35.1721 59.8782 35.2402 59.8307 35.3121C59.7976 35.3785 59.3997 36.1498 59.3792 36.1656C59.3587 36.1814 59.2908 36.4042 59.4092 36.4121C59.5276 36.42 59.7518 36.3979 59.815 36.2225C59.892 36.0013 59.9822 35.7849 60.0849 35.5744C60.1858 35.4371 60.2641 35.2845 60.317 35.1224C60.3173 35.0694 60.322 35.0165 60.3312 34.9644C60.3312 34.9644 60.257 35.1351 60.1844 35.1224C60.1436 35.1148 60.1046 35.0998 60.0692 35.0782L59.4092 36.3236C59.4092 36.3236 59.9586 35.1082 59.9886 35.1082Z",
    fill: "url(#paint54_linear_49_3501)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4303 32.9531C48.4303 32.9531 48.8913 33.2012 48.9529 33.2281C49.133 33.3399 49.3214 33.4377 49.5166 33.5205C49.6018 33.5284 50.197 33.6374 49.5955 33.2534C49.3666 33.1079 48.405 32.4204 48.405 32.4204C48.405 32.4204 48.5487 32.8709 48.4303 32.9531Z",
    fill: "url(#paint55_linear_49_3501)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4075 36.7021C47.4075 36.7021 47.2859 36.9756 47.2133 36.9882C47.2133 36.9882 49.0432 37.1052 49.5469 37.0594C49.5469 37.0594 48.1685 36.778 47.4075 36.7021Z",
    fill: "url(#paint56_linear_49_3501)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9061 38.289C61.9061 38.289 62.2961 38.2447 62.0482 39.1251C61.8003 40.0054 61.6945 40.2141 61.7071 40.2504C61.7198 40.2868 61.5493 40.2141 61.5493 40.2141L61.8492 40.429C62.1766 39.7497 62.3865 39.0197 62.4697 38.27C62.4697 38.27 62.0134 38.27 61.9061 38.289Z",
    fill: "url(#paint57_linear_49_3501)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8789 45.9708C55.8789 45.9708 54.6237 45.9218 54.158 45.9629L54.2116 45.8286C54.2116 45.8286 54.4485 45.8554 55.7037 45.6357C55.7829 45.7352 55.8424 45.849 55.8789 45.9708Z",
    fill: "url(#paint58_linear_49_3501)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4238 35.0215L61.81 35.6426C61.704 35.7768 61.6305 35.9337 61.5953 36.101L59.8696 36.3871C59.8696 36.3871 59.9011 35.8813 60.4238 35.0215Z",
    fill: "url(#paint59_linear_49_3501)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0512 35.5566C59.0512 35.5566 59.8075 35.2184 59.8801 35.152C59.9527 35.0856 59.5643 35.7637 59.4965 35.8933C59.4286 36.0229 59.7538 35.2247 59.0512 35.5566Z",
    fill: "url(#paint60_linear_49_3501)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7106 42.3014C59.8342 42.2967 59.9575 42.316 60.0737 42.3583C60.0385 42.3633 60.0055 42.3788 59.979 42.4026C59.4558 43.2912 58.7117 44.029 57.8191 44.5442C57.8191 44.5442 59.3048 43.4078 59.8543 42.3678C59.8543 42.3678 59.7832 42.2793 59.7106 42.3014Z",
    fill: "url(#paint61_linear_49_3501)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2526 35.2045C57.2905 35.2772 57.1863 35.5301 57.2905 35.7071C57.3584 35.8572 57.4724 35.9817 57.6158 36.0627C57.7563 36.1275 57.9489 36.1338 57.8699 36.2381C57.791 36.3425 57.101 36.5226 56.97 36.5685C56.8389 36.6143 57.4436 36.4104 57.5384 36.1591C57.504 36.1771 57.4658 36.1865 57.4271 36.1865C57.3883 36.1865 57.3501 36.1771 57.3158 36.1591C57.2116 36.0927 57 35.8225 57.0568 35.6043C57.0568 35.6043 57.1752 35.6549 57.18 35.5301C57.1847 35.4052 57.2226 35.391 57.1137 35.3862C56.9347 35.3835 56.7596 35.4389 56.6147 35.5443C56.6147 35.5443 57.0584 35.1586 57.2526 35.2045Z",
    fill: "url(#paint62_linear_49_3501)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 40.2754C58.5 40.2754 58.4353 41.1969 58.4337 41.4308C58.4321 41.6647 58.5537 42.0962 58.3374 42.3317L58.6532 42.2906C58.9247 42.259 59.5468 42.1974 59.6384 42.2053C59.6384 42.2053 59.7821 42.2053 59.7963 42.0757C59.8105 41.9461 59.7615 41.385 59.7615 41.385C59.7615 41.385 58.5206 40.2691 58.5 40.2754Z",
    fill: "url(#paint63_linear_49_3501)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1907 42.0456L58.3202 42.2701C58.3817 42.135 58.4145 41.9886 58.4165 41.8402C58.4039 41.6379 58.3881 40.5757 58.4039 40.4382C58.4171 40.3567 58.4245 40.2743 58.426 40.1917L58.2997 40.0747C58.2449 40.4569 58.2154 40.8424 58.2113 41.2285C58.2498 41.437 58.2578 41.6499 58.2349 41.8607C58.2018 42.0124 58.1907 42.0456 58.1907 42.0456Z",
    fill: "url(#paint64_linear_49_3501)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1412 40.8446C58.1412 40.8778 58.1523 41.6507 58.1412 41.7234L58.0876 41.8625L57.9044 41.51C57.9044 41.51 57.4102 40.4906 56.9318 40.0306C56.7519 39.9668 56.5762 39.8913 56.4061 39.8046C56.5348 39.8558 56.6741 39.8748 56.8118 39.8599C56.8769 39.8313 56.9325 39.7847 56.9722 39.7257C57.0118 39.6666 57.034 39.5976 57.036 39.5264C57.0222 39.3891 56.975 39.2573 56.8987 39.1424C56.7445 38.9678 56.58 38.8026 56.4061 38.6477L56.1992 38.3315L56.2229 38.3679L58.3007 40.0812C58.3007 40.0812 58.2123 40.1144 58.1412 40.8446Z",
    fill: "url(#paint65_linear_49_3501)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9321 28.8025C58.8627 28.7773 58.8184 28.7883 58.7032 29.1819C58.7032 29.1819 59.5131 29.8141 59.731 30.0117L59.9379 30.1855C59.884 30.2529 59.8123 30.3038 59.731 30.3325C59.5731 30.4052 59.6742 30.3625 59.6742 30.3625C59.9075 30.3006 60.1293 30.2013 60.331 30.0686C60.331 30.0686 59.12 28.8752 58.9321 28.8025Z",
    fill: "url(#paint66_linear_49_3501)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2191 28.1131L53.3391 28.3787L53.3991 28.5114V28.336C53.3991 28.336 55.3301 27.9393 56.5569 28.3202C56.6226 28.2992 56.6832 28.2644 56.7344 28.2181C56.7856 28.1717 56.8263 28.1149 56.8537 28.0515C56.8908 28.0648 56.9311 28.0661 56.9691 28.0553C57.007 28.0446 57.0406 28.0222 57.0652 27.9914C57.1505 27.884 55.1311 27.3055 53.2191 28.1131Z",
    fill: "url(#paint67_linear_49_3501)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5964 35.9575H52.6043L52.8537 36.0192L52.9595 36.4127L52.6943 36.7699L52.4653 36.7241C52.422 36.6686 52.3909 36.6046 52.374 36.5362C52.3571 36.4678 52.3549 36.3967 52.3674 36.3274C52.3674 36.3274 52.3564 36.1946 52.5964 35.9575Z",
    fill: "url(#paint68_linear_49_3501)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8803 36.2156C52.8498 36.1785 52.8094 36.1509 52.7638 36.136C52.7182 36.1212 52.6693 36.1197 52.6229 36.1318C52.5666 36.1454 52.5173 36.1794 52.4846 36.2273C52.4519 36.2752 52.4382 36.3335 52.4461 36.391C52.4461 36.4179 52.5029 36.6471 52.694 36.6107C52.6991 36.6125 52.7046 36.6125 52.7097 36.6107C52.7386 36.6088 52.7667 36.6005 52.7921 36.5866C52.8174 36.5727 52.8394 36.5534 52.8566 36.5301L52.7082 36.7024L52.5076 36.6929C52.5076 36.6929 52.4177 36.6423 52.4177 36.6265C52.3646 36.5103 52.3567 36.3784 52.3956 36.2567C52.465 36.0449 52.5961 36.0133 52.6198 36.018C52.6434 36.0227 52.8029 36.0876 52.8029 36.0876L52.8803 36.2156Z",
    fill: "url(#paint69_linear_49_3501)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0974 39.1758L53.3611 39.2232L53.5063 39.0478L53.6326 38.8897L53.5537 38.6779L53.5063 38.493L53.3911 38.4819C53.2779 38.6054 53.1724 38.7358 53.0753 38.8723C53.0663 38.974 53.0738 39.0765 53.0974 39.1758Z",
    fill: "url(#paint70_linear_49_3501)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3107 39.0788C53.2616 39.0631 53.2181 39.0336 53.1854 38.9938C53.1526 38.954 53.132 38.9056 53.1259 38.8544L53.1386 38.7959C53.1007 38.8386 53.0773 38.8922 53.0719 38.949C53.0665 39.0059 53.0794 39.063 53.1086 39.112C53.1086 39.112 53.1686 39.131 53.2096 39.1405C53.2544 39.1497 53.2998 39.1561 53.3454 39.1594C53.3454 39.1594 53.5033 39.0915 53.5033 39.0409C53.4411 39.0623 53.3763 39.0751 53.3107 39.0788Z",
    fill: "url(#paint71_linear_49_3501)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5067 38.7671C53.5067 38.7671 53.4483 38.609 53.2557 38.7671H53.1862L53.3915 38.5205C53.3915 38.5205 53.5162 38.5411 53.5067 38.598C53.502 38.6542 53.502 38.7108 53.5067 38.7671Z",
    fill: "url(#paint72_linear_49_3501)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M55.564 38.3203L55.6872 38.3503L55.804 38.7471L55.564 39.0632L55.4724 39.0426C55.4126 38.8983 55.3774 38.745 55.3682 38.589C55.3982 38.4847 55.504 38.333 55.564 38.3203Z",
    fill: "url(#paint73_linear_49_3501)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M55.727 38.5446C55.727 38.5446 55.6497 38.4292 55.5455 38.4513C55.4412 38.4735 55.4034 38.6094 55.4097 38.69C55.416 38.7706 55.4412 38.9777 55.5344 38.9381C55.5799 38.9198 55.6242 38.8987 55.667 38.8749C55.667 38.8749 55.6007 39.0203 55.5376 39.0014C55.4744 38.9824 55.4428 38.9713 55.4255 38.9208C55.3985 38.8167 55.3774 38.7111 55.3623 38.6047C55.3623 38.6047 55.4933 38.3549 55.5281 38.3518C55.5628 38.3486 55.686 38.3818 55.686 38.4087C55.7037 38.4527 55.7174 38.4981 55.727 38.5446Z",
    fill: "url(#paint74_linear_49_3501)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2676 35.7998L56.4034 35.8267C56.4034 35.8267 56.4492 36.0163 56.4492 36.029C56.4492 36.0416 56.4966 36.236 56.4966 36.236L56.3639 36.3941L56.255 36.5521H56.1555C56.1132 36.5007 56.0822 36.4409 56.0645 36.3766C56.0468 36.3123 56.0429 36.245 56.0529 36.1791C56.0854 36.0342 56.1601 35.9022 56.2676 35.7998Z",
    fill: "url(#paint75_linear_49_3501)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M56.406 35.9794C56.406 35.9794 56.2749 35.8861 56.2481 35.9035C56.212 35.9268 56.1816 35.958 56.1592 35.9946C56.1368 36.0313 56.1229 36.0725 56.1186 36.1153C56.1186 36.2181 56.1013 36.3034 56.1912 36.324C56.2227 36.3361 56.2574 36.3369 56.2894 36.3262C56.3213 36.3155 56.3486 36.2941 56.3665 36.2655C56.4139 36.1991 56.406 36.3856 56.2639 36.4788C56.2639 36.4788 56.1391 36.5389 56.0823 36.4298C56.0542 36.3582 56.0429 36.2811 56.0492 36.2044C56.0555 36.1276 56.0792 36.0534 56.1186 35.9873C56.1928 35.9035 56.2323 35.8182 56.2765 35.8371C56.3207 35.8561 56.3933 35.9114 56.406 35.9794Z",
    fill: "url(#paint76_linear_49_3501)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4018 34.3003L54.6544 34.3793L54.7571 34.795L54.5108 35.1222L54.4081 35.1C54.4081 35.1 54.2502 34.991 54.2818 34.452C54.2818 34.452 54.3734 34.3066 54.4018 34.3003Z",
    fill: "url(#paint77_linear_49_3501)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6495 34.5398C54.6159 34.5189 54.5782 34.5056 54.5389 34.5007C54.4997 34.4958 54.4599 34.4994 54.4221 34.5113C54.3754 34.5331 54.3379 34.5708 54.3165 34.6177C54.2951 34.6647 54.2911 34.7177 54.3053 34.7674C54.3353 34.8179 54.4221 34.9539 54.4885 34.9254C54.5385 34.8941 54.5851 34.8576 54.6274 34.8164C54.6274 34.8164 54.61 35.0187 54.5232 35.0282C54.4706 35.0319 54.4179 35.0319 54.3653 35.0282C54.3155 34.9514 54.2829 34.8647 54.2698 34.7741C54.2567 34.6835 54.2634 34.5912 54.2895 34.5034C54.2961 34.4716 54.3137 34.4432 54.339 34.423C54.3644 34.4028 54.396 34.3921 54.4285 34.3928C54.4761 34.3908 54.5231 34.4039 54.5628 34.4303C54.6025 34.4567 54.6329 34.495 54.6495 34.5398Z",
    fill: "url(#paint78_linear_49_3501)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6233 26.9346L100.155 25.9863C100.382 26.4095 100.517 26.8759 100.552 27.3551C100.65 28.3366 100.564 28.8613 100.552 29.3624C100.52 29.6436 100.511 29.9269 100.525 30.2095C100.525 30.2095 100.618 30.0847 100.667 30.0736C100.716 30.0625 100.7 29.9961 100.7 29.9961C100.667 29.9494 100.646 29.8951 100.638 29.8381C100.638 29.7733 100.796 28.5958 100.853 28.2275C100.91 27.8593 100.989 26.1807 100.728 25.4126C100.728 25.4126 101.044 25.0965 101.387 25.1502C101.729 25.2039 101.892 25.2893 101.919 25.3241C101.936 25.6162 101.936 25.9091 101.919 26.2013C101.857 26.6882 101.752 27.1686 101.603 27.6364C101.456 28.0347 101.088 29.258 100.961 29.533L100.828 29.9124L100.749 29.9993L100.76 30.0578C100.76 30.0578 100.875 30.1163 100.902 30.1337C100.929 30.151 100.934 30.0388 100.984 29.9408C101.035 29.8428 101.575 28.7396 101.711 28.4251C101.846 28.1106 102.41 26.9394 102.429 25.8251L102.486 25.8156C102.631 26.0654 102.76 26.324 102.873 26.5901C102.873 26.5901 102.476 25.0285 101.412 24.97C100.348 24.9115 99.257 26.8667 98.8859 29.2612C98.8859 29.2612 99.1859 28.1327 99.2128 28.0979C99.2128 28.0979 99.6643 28.64 99.7701 28.8155C99.7701 28.8155 100.233 29.7638 100.26 30.1242L100.321 30.524C100.359 30.4572 100.401 30.3923 100.446 30.3296C100.476 30.3012 100.378 30.1242 100.368 29.8555C100.324 29.2589 100.25 28.6649 100.146 28.0758C100.057 27.7597 99.7069 26.9836 99.6233 26.9346Z",
    fill: "url(#paint79_linear_49_3501)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M102.893 26.7056C102.893 26.7056 102.168 28.6117 101.554 29.4304C101.554 29.4304 101.08 30.1575 101.017 30.2602C101.017 30.2602 101.044 30.3471 101.074 30.4483C101.064 30.5443 101.06 30.641 101.063 30.7375C101.078 30.614 101.107 30.4925 101.15 30.3756C101.193 30.3045 101.991 29.5031 102.707 28.6291C102.936 28.3711 103.099 28.0606 103.18 27.725C103.18 27.725 103.054 26.9253 102.893 26.7056Z",
    fill: "url(#paint80_linear_49_3501)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M101.131 30.7826C101.131 30.7826 101.177 30.9406 101.279 30.8995C101.279 30.8995 102.628 30.7115 102.762 30.6656C102.896 30.6198 103.289 30.5502 103.386 30.4775C103.386 30.4775 103.386 31.4828 103.27 31.7151C103.27 31.7151 101.294 31.1888 101.148 31.1888C101.12 31.2278 101.101 31.2726 101.091 31.32C101.094 31.1402 101.108 30.9608 101.131 30.7826Z",
    fill: "url(#paint81_linear_49_3501)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M101.093 31.3145C101.093 31.3145 101.002 31.6069 100.972 31.7096C100.972 31.7096 101.044 31.7222 101.179 31.8834C101.313 32.0447 102.21 33.1368 102.314 33.3059C102.314 33.3059 102.788 34.1057 102.788 34.4123C102.788 34.4123 103.135 33.4466 103.135 33.2143C102.87 32.8441 102.55 32.516 102.188 32.2406C101.515 31.7017 101.171 31.599 101.138 31.512C101.117 31.4476 101.102 31.3815 101.093 31.3145Z",
    fill: "url(#paint82_linear_49_3501)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M100.858 31.9637C100.858 31.9637 100.684 32.0206 100.713 32.1518C100.741 32.283 100.83 32.852 100.871 33.1002C100.912 33.3483 101.235 34.7455 101.25 35.7507C101.25 35.7507 101.204 36.5805 101.191 36.7117C101.191 36.7117 101.235 36.9756 100.653 36.9014C100.783 36.3225 100.856 35.7322 100.871 35.1391C100.856 34.4104 100.626 32.9547 100.653 32.6339C100.674 32.4765 100.674 32.3171 100.653 32.1597C100.653 32.1597 100.577 32.0459 100.504 32.0301C100.432 32.0143 100.492 32.3462 100.492 32.5264C100.492 32.7066 100.504 34.156 100.504 34.4341C100.468 35.1728 100.327 35.9025 100.084 36.6011C99.6122 36.2421 99.2831 35.7266 99.1559 35.147C99.4286 34.7519 99.6568 34.3278 99.8364 33.8825C100.029 33.3278 100.219 32.0048 100.29 31.8721L100.275 31.5654C100.275 31.5654 100.056 32.0396 100.029 32.1487C100.002 32.2577 99.7496 32.92 99.5175 33.1981C99.2854 33.4763 98.8323 33.911 98.8323 33.911C98.8323 33.911 98.6886 32.7019 98.6886 32.5438C99.0361 32.3829 99.3635 32.1819 99.6643 31.9448C99.9533 31.6682 100.16 31.3331 100.275 31.3126L100.231 31.0818C100.231 31.0818 99.1686 31.0233 99.0975 31.036C98.9613 31.0448 98.8247 31.0448 98.6886 31.036C98.6886 31.036 98.3965 32.509 98.8796 34.7076C99.3707 36.9662 100.348 37.257 100.798 37.1953C100.798 37.1953 101.363 37.1811 102.034 36.296C102.034 36.296 102.601 35.3777 102.689 34.8956C102.466 35.3999 102.167 35.8669 101.802 36.2802C101.802 36.2802 101.846 34.9115 101.379 33.7513C101.381 33.7529 100.83 32.1645 100.858 31.9637Z",
    fill: "url(#paint83_linear_49_3501)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M100.146 26.1211L99.9877 26.2681C99.9877 26.2681 99.672 26.8481 99.6183 26.9335C99.6183 26.9335 100.141 27.8486 100.204 28.386C100.267 28.9234 100.345 29.5382 100.334 29.5872C100.376 29.7371 100.429 29.8839 100.491 30.0266C100.491 30.0266 100.518 29.151 100.542 28.8238C100.566 28.4966 100.539 27.0473 100.146 26.1211Z",
    fill: "url(#paint84_linear_49_3501)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1908 28.1782C99.3688 28.384 99.5349 28.5998 99.6882 28.8247C99.8287 29.0554 100.241 30.0765 100.249 30.3388C100.212 30.3181 100.17 30.3071 100.128 30.3071C100.086 30.3071 100.044 30.3181 100.007 30.3388C99.9528 30.3789 99.9118 30.4344 99.8893 30.4981C99.8668 30.5617 99.8638 30.6307 99.8808 30.696C99.878 30.7736 99.9038 30.8495 99.9533 30.9093C100.003 30.969 100.073 31.0084 100.149 31.02L100.233 31.0532L98.7266 31.0011L98.7361 30.6533C98.7361 30.6533 99.0424 30.7197 99.1245 30.5965C99.1958 30.4048 99.2213 30.1991 99.1987 29.9958C99.1845 29.9152 98.8829 29.6797 98.8829 29.6797L98.7771 30.4099C98.7771 30.4099 98.8656 29.1028 99.1908 28.1782Z",
    fill: "url(#paint85_linear_49_3501)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6896 32.5458C98.705 33.0044 98.753 33.4613 98.8333 33.913C99.097 33.6644 99.3385 33.3931 99.5548 33.1022C99.8216 32.7118 100.073 31.9136 100.186 31.6465C100.186 31.6465 99.9448 31.9025 99.8437 31.7935C99.691 31.9351 99.5297 32.0671 99.3606 32.1886C99.1435 32.3197 98.9195 32.439 98.6896 32.5458Z",
    fill: "url(#paint86_linear_49_3501)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M100.161 32.5927C100.264 32.5442 100.359 32.479 100.441 32.3999C100.466 32.728 100.47 33.0575 100.452 33.3862C100.418 33.8698 100.538 34.8798 100.063 36.5947C100.063 36.5947 99.5437 36.3497 99.1632 35.1516C99.1632 35.1516 99.7569 34.2033 99.8863 33.7402C100.016 33.2771 100.161 32.5927 100.161 32.5927Z",
    fill: "url(#paint87_linear_49_3501)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M100.69 32.2466C100.69 32.2466 100.864 33.07 100.899 33.2376C100.933 33.4051 101.12 34.4546 101.165 34.7802C101.211 35.1058 101.323 36.092 101.192 36.71C101.192 36.71 100.925 36.3765 100.75 36.3671C100.832 35.9226 100.868 35.4708 100.858 35.0188C100.815 34.4657 100.667 32.5896 100.673 32.4742C100.679 32.3588 100.69 32.2466 100.69 32.2466Z",
    fill: "url(#paint88_linear_49_3501)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 36.4087C100.75 36.4087 101.129 36.611 101.153 36.7248C100.994 36.7437 100.836 36.7717 100.679 36.8086C100.679 36.8086 100.75 36.4529 100.75 36.4087Z",
    fill: "url(#paint89_linear_49_3501)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M101.022 31.7739C100.981 31.8016 100.947 31.8381 100.921 31.8807C100.895 31.9233 100.879 31.971 100.874 32.0205C100.874 32.1153 100.953 32.6527 101.329 33.5283C101.705 34.4039 101.6 34.4387 101.6 34.4387C101.6 34.4387 102.548 34.3075 102.706 34.4039C102.706 34.4039 102.663 33.7923 101.916 32.8787C101.169 31.9652 101.022 31.7739 101.022 31.7739Z",
    fill: "url(#paint90_linear_49_3501)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M101.15 31.1895C101.118 31.2275 101.096 31.2725 101.085 31.3208C101.073 31.3691 101.074 31.4194 101.085 31.4676C101.085 31.4676 102.268 32.2832 102.617 32.6151C102.806 32.7936 102.976 32.9912 103.125 33.2046C103.201 33.3706 103.125 33.2283 103.125 33.2283C103.125 33.2283 103.307 32.122 103.342 31.8533C103.342 31.8533 102.71 31.8533 102.527 31.8628C102.527 31.8628 103.289 31.7837 103.326 31.7948C102.619 31.5309 101.891 31.3284 101.15 31.1895Z",
    fill: "url(#paint91_linear_49_3501)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M102.624 28.7663C102.624 28.7663 101.571 29.9312 101.236 30.26C101.19 30.3228 101.156 30.3942 101.137 30.4702C101.118 30.5461 101.114 30.6251 101.126 30.7025C101.15 30.9301 101.339 30.8716 101.51 30.8321C101.51 30.8321 103.104 30.6077 103.376 30.418C103.062 30.2641 102.736 30.1383 102.4 30.0418C101.95 29.9233 101.743 29.8506 101.743 29.8506C101.798 29.8314 101.857 29.8314 101.912 29.8506C102.029 29.8727 102.806 30.0908 102.872 30.0908C102.938 30.0908 102.961 30.0624 102.961 30.0118C102.914 29.8147 102.877 29.6153 102.852 29.4144C102.852 29.2184 102.893 28.5182 102.872 28.5024C102.852 28.4866 102.785 28.5688 102.624 28.7663Z",
    fill: "url(#paint92_linear_49_3501)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M102.407 26.4003C102.407 26.4003 102.551 26.6833 102.685 26.6548C102.685 26.6548 102.786 26.6453 102.78 26.6833C102.664 26.7841 102.518 26.8436 102.364 26.8524C102.364 26.8524 102.219 26.9172 102.391 26.8887C102.538 26.8574 102.681 26.808 102.816 26.7417C102.857 26.7212 102.867 26.7212 102.807 26.8223C102.747 26.9235 102.148 28.6779 101.193 29.8949L101.018 30.26C101.018 30.26 100.899 30.1573 100.931 30.0482C100.962 29.9392 101.273 29.3275 101.404 29.0778C101.536 28.8281 102.118 27.4625 102.194 27.2096C102.28 26.9218 102.339 26.6265 102.369 26.3276L102.407 26.4003Z",
    fill: "url(#paint93_linear_49_3501)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M100.821 25.7007C100.942 25.7264 101.065 25.737 101.188 25.7323C101.287 25.7086 101.044 25.9552 101.017 26.0721C100.99 26.1891 101.417 26.6458 101.273 27.3365C101.189 27.6849 101.122 28.0372 101.074 28.3923C101.063 28.5741 101.139 28.7574 101.118 28.9187C101.086 29.1309 101.033 29.3395 100.96 29.5414C100.96 29.5414 100.703 29.3976 100.703 29.3264C100.703 29.2964 100.918 28.0146 100.941 27.316C100.951 26.775 100.911 26.2343 100.821 25.7007Z",
    fill: "url(#paint94_linear_49_3501)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M100.757 25.4316C100.923 25.3882 101.094 25.3617 101.265 25.3525C101.39 25.3668 101.848 25.3525 101.848 25.3525C101.848 25.3525 101.76 25.5722 101.36 25.6686C100.961 25.7651 100.864 25.6924 100.83 25.6686L100.757 25.4316Z",
    fill: "url(#paint95_linear_49_3501)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M101.634 34.4657C101.634 34.4657 102.424 34.423 102.536 34.4436C102.536 34.4436 102.717 34.4357 102.76 34.5021C102.803 34.5684 102.487 35.305 101.961 36.0052C101.961 36.0131 101.952 36.0225 101.95 36.0289C101.949 36.0352 102.566 34.9225 102.661 34.5874C102.661 34.5874 102.645 34.4657 102.588 34.472C102.563 34.5985 102.516 34.7194 102.449 34.8292C102.267 35.2643 102.048 35.6826 101.794 36.0794L101.743 35.512C101.743 35.512 101.764 35.7523 101.81 35.7365C101.855 35.7207 102.441 34.51 102.441 34.51C102.441 34.51 102.048 35.0726 101.844 35.4393C101.844 35.4393 101.757 35.5547 101.778 35.1849C101.778 35.1849 102.002 34.668 102.034 34.5432C102.065 34.4183 102.012 34.4847 101.955 34.4847C101.898 34.4847 101.871 34.5953 101.852 34.7281C101.827 34.837 101.79 34.943 101.742 35.0442C101.742 35.0442 101.592 34.4768 101.634 34.4657Z",
    fill: "url(#paint96_linear_49_3501)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M101.81 27.1416C101.77 27.1495 101.724 27.355 101.644 27.5936C101.563 27.8323 100.957 29.544 100.914 29.6483C100.872 29.7526 100.756 29.9723 100.745 29.996C100.734 30.0198 100.712 30.0292 100.756 30.0545L100.899 30.1304L100.938 30.1146C100.938 30.1146 100.894 30.0577 100.993 29.8743C101.415 29.0721 101.79 28.2456 102.114 27.3992C102.211 27.1811 102.278 26.9509 102.313 26.7148C102.313 26.7148 102.155 27.3249 102.065 27.355C101.975 27.385 101.955 27.121 101.81 27.1416Z",
    fill: "url(#paint97_linear_49_3501)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M100.911 27.119C100.911 27.0906 100.623 27.3608 100.595 27.3608C100.567 27.3608 100.503 26.9657 100.472 26.8867C100.44 26.8076 100.156 25.9937 100.156 25.9937C100.156 25.9937 100.507 26.9894 100.552 27.6169C100.675 28.7343 100.503 29.0014 100.489 30.0288L100.525 30.2169C100.525 30.2169 100.655 30.0588 100.707 30.0588C100.68 29.9875 100.658 29.9146 100.639 29.8407C100.634 29.8012 100.966 27.6026 100.911 27.119Z",
    fill: "url(#paint98_linear_49_3501)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M100.064 27.9263C100.092 28.0344 100.11 28.145 100.116 28.2566C100.097 28.2993 99.8159 28.7482 99.8159 28.7482L99.2601 28.1681C99.5383 28.4745 99.7649 28.8242 99.9312 29.2033C100.146 29.7518 100.31 30.3097 100.31 30.5263C100.31 30.5263 100.41 30.3682 100.435 30.3319C100.435 30.3319 100.38 29.9336 100.339 29.5874C100.297 29.2413 100.255 28.2076 100.064 27.9263Z",
    fill: "url(#paint99_linear_49_3501)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M100.233 31.0898C100.233 31.0898 99.1273 31.1167 98.8858 31.1878C98.8144 31.2029 98.7507 31.243 98.7064 31.301C98.6621 31.359 98.64 31.431 98.6442 31.5039C98.6268 31.7963 98.6442 32.5534 98.6442 32.5534C98.8508 32.482 99.0501 32.3909 99.2394 32.2816C99.4605 32.1425 99.9578 31.594 100.105 31.4581C100.251 31.3222 100.285 31.319 100.285 31.319C100.285 31.319 100.267 31.123 100.233 31.0898Z",
    fill: "url(#paint100_linear_49_3501)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M100.268 31.5908C100.268 31.5908 100.11 32.0397 99.9317 32.506C99.6925 33.0642 99.3341 33.5632 98.8817 33.968L99.3743 33.5143L99.5875 34.3473L99.1391 35.1502C99.1391 35.1502 99.6996 34.2793 99.8432 33.8067C99.9869 33.3342 100.238 32.0018 100.279 31.8959C100.279 31.8959 100.345 31.6319 100.268 31.5908Z",
    fill: "url(#paint101_linear_49_3501)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M100.515 33.5063C100.515 33.5063 100.515 35.098 100.31 35.8266C100.31 35.8266 100.232 36.1664 100.164 36.3592L100.349 35.7634C100.349 35.7634 100.723 35.904 100.775 35.9119C100.828 35.9198 100.667 36.6421 100.7 36.5552C100.884 35.7246 100.91 34.8665 100.775 34.0263C100.775 34.0263 100.802 34.6696 100.709 34.5701C100.616 34.4705 100.477 34.4673 100.515 33.5063Z",
    fill: "url(#paint102_linear_49_3501)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M100.69 32.2466C100.69 32.2466 100.817 32.7871 100.871 32.972C100.968 33.3246 101.046 33.6824 101.103 34.0437C101.149 34.3598 101.247 34.7833 101.261 34.8703C101.261 34.8703 101.274 34.7122 101.383 34.6743C101.492 34.6364 101.604 34.57 101.604 34.57L101.424 33.8777C101.585 34.2952 101.685 34.7339 101.721 35.1801C101.728 35.481 101.753 35.7813 101.795 36.0794C101.795 36.0794 101.744 35.4472 101.698 35.4472C101.561 35.5002 101.44 35.5891 101.348 35.7048C101.302 35.9289 101.272 36.156 101.259 36.3844C101.272 35.9881 101.265 35.5914 101.237 35.1959C101.192 34.9588 100.851 32.5137 100.69 32.2466Z",
    fill: "url(#paint103_linear_49_3501)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M102.697 32.7863C102.713 32.8874 102.579 32.6029 102.539 32.7768C102.5 32.9507 102.481 33.2051 102.405 33.1862C102.329 33.1672 102.344 33.2715 102.025 32.8811C101.706 32.4907 101.218 31.9438 101.218 31.9438C101.218 31.9438 102.217 33.2083 102.383 33.4754C102.527 33.7205 102.65 33.9775 102.751 34.2435C102.779 34.3415 102.637 33.8373 102.637 33.8373C102.637 33.8373 102.743 34.204 102.811 34.0807C102.929 33.8287 103.017 33.5634 103.073 33.2905C103.057 33.2062 103.028 33.1251 102.986 33.0502C102.838 32.873 102.68 32.7046 102.513 32.546C102.586 32.6161 102.648 32.6972 102.697 32.7863Z",
    fill: "url(#paint104_linear_49_3501)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M103.073 30.643C102.985 30.6674 102.908 30.7196 102.853 30.7917C102.797 30.8638 102.767 30.952 102.766 31.0429C102.766 31.3369 102.694 31.4033 102.66 31.3954C102.627 31.3875 101.347 31.1772 101.239 31.1314C101.239 31.1314 101.167 31.0761 101.142 31.1093C101.116 31.1425 101.167 31.1883 101.167 31.1883C101.167 31.1883 102.724 31.525 103.024 31.6435C103.024 31.6435 103.181 31.7557 103.251 31.6435C103.32 31.5313 103.357 30.5103 103.357 30.5103C103.271 30.5723 103.175 30.6173 103.073 30.643Z",
    fill: "url(#paint105_linear_49_3501)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M103.11 28.2637C103.11 28.2637 103.227 28.2194 103.244 29.0935C103.263 29.4185 103.257 29.7445 103.227 30.0687H103.023C103.023 30.0687 103.404 30.3168 103.386 30.1272C103.369 29.9375 103.227 27.1858 103.11 28.2637Z",
    fill: "url(#paint106_linear_49_3501)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1983 30.5254C99.2686 30.5152 99.3402 30.5251 99.4051 30.5538C99.4588 30.5981 99.6499 30.9616 99.9672 30.9758L100.232 31.0564L98.7325 30.9664V30.6502C98.8101 30.684 98.8945 30.6986 98.9788 30.6929C99.0269 30.6869 99.0726 30.6682 99.1111 30.6387C99.1497 30.6093 99.1797 30.5702 99.1983 30.5254Z",
    fill: "url(#paint107_linear_49_3501)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M99.507 32.1054C99.507 32.1054 99.5591 32.0264 99.6301 32.0675C99.7012 32.1086 99.7785 32.1766 99.7391 32.3678C99.6996 32.5591 99.7391 32.6002 99.698 32.5654C99.657 32.5306 99.5591 32.4295 99.5591 32.4626C99.5817 32.5943 99.5714 32.7295 99.5291 32.8562C99.4572 33.0603 99.3717 33.2594 99.2733 33.4521C99.2733 33.4521 98.8833 33.8835 98.8328 33.9262C98.7517 33.4734 98.71 33.0144 98.7081 32.5543C98.9821 32.4189 99.2488 32.2691 99.507 32.1054Z",
    fill: "url(#paint108_linear_49_3501)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9648 33.5029C100.039 33.5426 100.101 33.6019 100.144 33.6743C100.187 33.7467 100.21 33.8296 100.21 33.9139C100.21 34.2015 99.8716 35.2747 99.7359 35.5402C99.6001 35.8058 99.5053 35.9543 99.5053 35.9543C99.3571 35.7022 99.241 35.4324 99.1596 35.1514C99.0191 34.6868 99.1864 35.1167 99.1864 35.1167C99.1864 35.1167 99.7185 34.2237 99.8448 33.8064C99.8464 33.8064 99.9648 33.5282 99.9648 33.5029Z",
    fill: "url(#paint109_linear_49_3501)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M101.029 32.6895C101.029 32.6895 101.476 32.8175 101.555 32.9597C101.634 33.102 101.596 33.2837 101.653 33.5682C101.71 33.8527 101.744 34.2874 101.902 34.3364C101.973 34.3658 102.051 34.3735 102.126 34.3585L101.602 34.4391C101.602 34.4391 101.11 32.9234 101.029 32.6895Z",
    fill: "url(#paint110_linear_49_3501)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5473 45.5408C44.5473 45.5408 42.3921 45.5692 41.9295 45.5993C41.4669 45.6293 28.0781 45.4839 21.7657 44.4645L21.1831 44.2321C21.1831 44.2321 11.3499 43.7327 3.11611 41.4314C3.11611 41.4314 1.89248 40.8482 1.72039 40.7012C1.54508 40.6845 1.36824 40.6951 1.1962 40.7328L0.760433 40.7012C0.760433 40.7012 0.177831 40.6158 0.20625 40.0895C0.23467 39.5632 -0.109523 36.7419 0.441503 35.7778C0.441503 35.7778 0.409926 34.1783 0.498342 33.8574C0.498342 33.8574 -0.0258441 33.4512 0.000996686 32.955C0.0278375 32.4587 -0.11426 27.6254 1.13621 25.4411C1.57513 23.8969 1.66355 22.5266 4.07764 20.6915C4.07764 20.6915 5.06286 19.4982 5.67546 19.2691C6.22964 18.7743 8.35954 17.3724 12.1062 16.59C12.1062 16.59 23.9177 13.7957 31.3384 12.89L31.861 12.4822C31.8749 12.2089 31.9603 11.944 32.1085 11.7141C32.2567 11.4842 32.4627 11.2972 32.7057 11.1719C33.5488 10.7341 34.0699 10.6788 34.0699 10.6788C34.0699 10.6788 39.8012 5.23228 46.6708 3.33879C49.197 2.72396 54.9631 1.35679 61.0386 0.745125C61.0386 0.745125 70.6112 -0.391282 77.2141 0.395827C83.8169 1.18294 91.1792 4.61903 97.7236 10.6788C97.7236 10.6788 100.431 13.4732 101.63 15.746C101.63 15.746 102.79 16.2392 103.314 16.9425C103.839 17.6458 105.673 21.5703 105.7 23.9569C105.727 26.3436 105.119 30.0736 104.74 32.7258C104.74 32.7258 104.331 33.3106 104.243 33.3359L104.154 33.3643C104.154 33.3643 105.733 23.056 102.032 21.3965C98.453 21.0804 97.6668 29.0273 96.0326 35.6371L95.9442 35.8995L64.5058 42.2738C64.5058 42.2738 66.1636 38.5185 65.3205 33.7389L65.2905 33.0134C65.2905 33.0134 65.0284 21.2748 56.4488 21.5656C47.7492 21.9449 45.3035 32.808 44.8678 42.7448L44.5473 45.5408Z",
    fill: "url(#paint111_linear_49_3501)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3027 18.7119C45.3027 18.7119 64.9691 14.7495 86.0376 15.2157L101.638 15.7405C101.638 15.7405 92.0768 2.36752 77.7643 0.810691C76.137 0.758828 74.5165 1.04346 73.004 1.6468C70.6799 2.61567 67.1622 7.41103 65.8612 14.2311C65.8107 14.4681 45.3027 18.7119 45.3027 18.7119Z",
    fill: "url(#paint112_linear_49_3501)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0902 12.4468C61.2971 12.6128 42.5322 14.1143 33.921 16.3523C32.8348 16.6368 31.8085 16.9371 30.8722 17.2548C30.8722 17.2548 35.2931 15.9161 34.2447 16.0315C33.1963 16.1469 13.2978 16.4977 11.8421 16.7301C11.8421 16.7301 24.3547 13.5848 31.338 12.8846C52.577 11.9537 60.7981 12.2161 61.0902 12.4468Z",
    fill: "url(#paint113_linear_49_3501)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4249 27.7985L65.3565 27.563C65.3565 27.563 65.6722 28.1083 66.0559 28.1842C66.4396 28.2601 67.7627 28.1842 67.7627 28.1842L68.6437 27.2359C68.6437 27.2359 68.5789 27.4066 68.6895 28.3328C69.0052 28.4118 85.9955 27.0984 88.3227 27.1758C90.65 27.2532 95.0913 28.3818 95.636 28.3818C96.1808 28.3818 97.2639 26.1816 97.2639 26.1816L95.9234 30.7004H93.3719L95.1545 31.9285L94.5135 32.7282L90.7115 32.3363C90.7115 32.3363 86.3128 31.527 86.0791 31.527C85.8455 31.527 67.2985 34.1602 66.678 34.4004C66.678 34.4004 65.5143 33.6228 65.5917 35.6412C65.5917 35.6412 64.9696 28.8844 64.4249 27.7985Z",
    fill: "url(#paint114_linear_49_3501)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M100.574 15.7863C100.574 15.7863 101.513 15.6756 102.235 17.4506C102.792 18.7261 102.014 19.4436 102.456 19.834C102.456 19.834 103.951 21.1095 104.283 23.0504C104.283 23.0504 104.535 24.7037 104.57 25.3422L104.695 27.2151L104.449 27.7652C104.449 27.7652 104.606 32.1907 104.246 33.3303L104.744 32.7202C104.744 32.7202 105.836 25.1589 105.781 23.7111C105.726 22.2633 103.951 17.3605 103.32 16.9322C103.32 16.9322 102.126 15.3974 100.574 15.7863Z",
    fill: "url(#paint115_linear_49_3501)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M97.653 27.8154L97.2835 29.0419C97.2835 29.0419 96.0441 30.5735 95.9241 30.6683C95.9241 30.6683 95.3826 32.3658 95.2389 32.7704C95.2311 32.797 95.2199 32.8225 95.2057 32.8463C95.1315 33.0202 96.5288 31.3116 97.0893 30.6509C97.0893 30.6509 97.5393 28.3196 97.653 27.8154Z",
    fill: "url(#paint116_linear_49_3501)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53321 29.1388C2.53321 29.1388 2.08323 30.1772 2.17164 33.8804C2.04586 33.9482 1.93976 34.0474 1.86367 34.1685C1.78758 34.2895 1.7441 34.4282 1.73745 34.5711C1.6964 35.0895 1.35063 38.4055 1.52273 38.5809C1.69482 38.7563 1.48168 38.965 2.73214 39.3554L2.68478 40.6909C2.68478 40.6909 1.35063 40.3005 1.22274 40.2168C1.09485 40.133 0.760132 40.6909 0.760132 40.6909C0.619254 40.6522 0.492313 40.5741 0.394167 40.4658C0.296021 40.3575 0.230733 40.2234 0.205949 40.0793C0.103322 39.564 -0.0261451 36.5041 0.403308 35.943L0.498041 33.8472C0.344272 33.7526 0.217621 33.6198 0.130453 33.4616C0.0432845 33.3034 -0.00142399 33.1253 0.000695231 32.9447C-0.0115684 31.0225 0.138433 29.1027 0.449096 27.2058C0.449096 27.2058 0.362258 28.1952 1.56851 28.6282C1.56851 28.6282 1.8685 28.7563 2.12586 26.2574C2.38163 24.4066 3.46 22.3804 3.46 22.3804C3.46 22.3804 1.28432 28.9206 2.53321 29.1388Z",
    fill: "url(#paint117_linear_49_3501)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M19.27 29.699C19.041 29.7243 26.1854 22.1867 26.9212 21.8374L28.3106 21.8548C28.3106 21.8548 23.1508 27.3314 22.9961 28.1548C22.9961 28.1548 19.6615 29.6611 19.27 29.699Z",
    fill: "url(#paint118_linear_49_3501)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5098 20.8479C60.5098 20.8479 62.7976 22.6702 62.8781 23.0606C62.9586 23.451 62.916 24.3804 63.036 24.5732C63.156 24.766 63.9296 26.247 64.0828 26.6279L64.5864 27.8323C64.5864 27.8323 62.8497 23.8335 60.7861 22.7445C58.7225 21.6555 57.251 18.7489 60.5098 20.8479Z",
    fill: "url(#paint119_linear_49_3501)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2502 12.6543L63.3988 12.5342C63.3988 12.5342 38.4368 13.8761 29.3267 17.7215C29.3267 17.7215 26.45 18.741 24.4401 20.3721C22.4302 22.0032 22.5218 21.8847 22.5218 21.8847L26.9427 21.7993L28.5215 21.5938L29.6267 20.6629L39.8894 20.1887C39.8894 20.1887 42.2766 18.7331 43.4687 18.4991C44.6607 18.2652 49.5221 17.1889 53.5324 16.5772C57.5427 15.9655 62.9914 15.4123 63.1083 15.3554C63.2251 15.2985 66.0734 14.1606 66.0734 14.1606L66.2502 12.6543Z",
    fill: "url(#paint120_linear_49_3501)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1315 17.3132L46.0062 18.7689C46.0062 18.7689 63.4432 15.7579 67.6904 15.7579C67.9793 15.1763 60.3786 13.2291 48.7439 14.4003C37.1092 15.5714 34.1315 17.3132 34.1315 17.3132Z",
    fill: "url(#paint121_linear_49_3501)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2702 29.699L15.5504 35.5644C15.5504 35.5644 16.092 35.6419 16.6367 37.1181C17.1814 38.5943 18.1098 41.2275 17.6424 41.3144L18.1855 43.0989C18.1855 43.0989 19.6792 43.3312 21.7648 44.4581C26.1762 44.9623 42.3517 45.9533 44.5464 45.5345C44.0222 37.7393 47.0457 28.109 47.903 27.7992C43.0086 28.1153 41.0744 27.7992 41.0744 27.7992C41.0744 27.7992 38.7424 25.4679 37.9704 24.6919C36.8083 25.547 30.3744 29.7354 19.2702 29.699Z",
    fill: "url(#paint122_linear_49_3501)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M74.36 0.692524C74.36 0.692524 70.5564 0.923282 67.2219 6.51998C66.0648 8.37167 65.2005 10.3912 64.6594 12.5071C63.8084 12.5071 63.3963 12.5418 63.3963 12.5418C63.3963 12.5418 66.9819 3.49482 70.0875 1.5555C70.0875 1.5555 53.7952 1.32316 46.2703 3.57385C60.7785 0.00340986 71.1548 -0.52291 77.2161 0.398545C74.8999 0.460187 74.36 0.692524 74.36 0.692524Z",
    fill: "url(#paint123_linear_49_3501)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9966 28.1546C22.9966 28.1546 31.6804 28.4233 36.5749 25.395C36.5749 25.395 30.7552 29.5898 19.2705 29.7052C22.2972 28.6509 22.9966 28.1546 22.9966 28.1546Z",
    fill: "url(#paint124_linear_49_3501)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3985 12.5342C63.3985 12.5342 43.6626 13.5109 28.3744 18.0914C28.3744 18.0914 54.3405 12.4204 63.6495 14.5178L64.8147 14.6758L63.3985 12.5342Z",
    fill: "url(#paint125_linear_49_3501)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56897 28.628C1.56897 28.628 -0.62724 28.3593 1.13636 25.4385C1.04005 27.019 1.97 27.1771 1.97 27.1771L1.56897 28.628Z",
    fill: "url(#paint126_linear_49_3501)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M44.546 45.5405L43.6744 45.5689C43.6744 45.5689 43.965 32.6954 46.349 28.2699C48.7331 23.8444 52.4577 19.9989 56.5328 19.7666C57.7548 20.2313 56.8801 21.5147 56.8801 21.5147C56.8801 21.5147 55.3091 21.3977 53.1587 22.5626C51.0083 23.7274 46.9901 27.3974 46.0538 32.9941C45.1175 38.5908 44.546 45.041 44.546 45.5405Z",
    fill: "url(#paint127_linear_49_3501)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1102 38.5718L64.5024 42.2734L95.9551 35.8991L94.4773 34.0894C94.4773 34.0894 90.6312 35.1942 68.1102 38.5718Z",
    fill: "url(#paint128_linear_49_3501)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M100.388 15.6763C99.5555 15.6257 98.3792 15.2922 98.3792 15.21C98.3792 15.1278 98.1945 14.8101 97.934 14.3723C97.6735 13.9345 98.0792 13.993 98.0792 13.993C99.0676 13.876 98.9239 13.5568 98.1377 12.305C97.3514 11.0532 96.7419 10.9346 96.4514 10.8746C96.1609 10.8145 96.3062 11.1401 96.3062 11.1401C97.5251 13.2628 97.4682 13.7606 97.5566 13.9645C97.6451 14.1684 97.9072 14.6347 97.8724 14.837C97.8377 15.0393 98.1882 15.4692 98.1882 15.4692L86.3198 15.2116L100.388 15.6763Z",
    fill: "url(#paint129_linear_49_3501)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3558 31.381C86.3558 31.381 92.3776 30.5038 93.2492 30.2446C93.2492 30.2446 94.1523 30.0107 94.2091 29.7515C93.9105 30.0399 93.6295 30.346 93.3676 30.6682L95.1501 31.9136L94.4507 32.6881L90.8066 32.3404L86.07 31.5248C86.1458 31.5549 66.751 34.2038 66.751 34.2038L86.3558 31.381Z",
    fill: "url(#paint130_linear_49_3501)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7552 34.2046C66.7552 34.2046 67.2984 33.3495 68.1889 33.2341C68.1889 33.2341 88.5942 29.6605 93.0908 29.817C94.3744 30.0904 92.775 30.3196 92.3566 30.4018C91.9382 30.484 66.7552 34.2046 66.7552 34.2046Z",
    fill: "url(#paint131_linear_49_3501)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2705 29.698L19.3352 29.6727L22.9966 28.1538C22.9966 28.1538 19.6226 29.2934 19.2705 29.698Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4424 28.1844L87.0032 27.1761L88.7858 27.2171C90.5746 27.2551 95.417 28.4168 95.7912 28.382L97.419 26.1692C99.65 18.7486 70.4424 28.1844 70.4424 28.1844Z",
    fill: "url(#paint132_linear_49_3501)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7197 27.7623L98.6549 24.3468C98.9176 23.2488 99.4064 22.2179 100.09 21.32C100.943 20.2548 102.616 20.4175 102.754 20.4634C102.798 20.3796 102.092 19.651 102.136 19.5404C102.588 18.4925 102.957 16.5247 99.547 16.2702C88.8612 15.4705 62.9551 18.9872 56.5844 19.8802C56.5844 19.8802 62.8493 18.5999 65.7197 27.7623Z",
    fill: "url(#paint133_linear_49_3501)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.89 20.1863C59.6932 19.5279 59.4046 18.9006 59.0327 18.3229C58.4911 17.5468 58.3775 17.2323 59.23 17.0031C60.1979 16.8451 67.5617 16.1781 67.5617 16.1781L80.6822 15.6217L98.3118 15.5949C98.3118 15.5949 73.1478 14.0143 55.2339 17.3888C48.8727 18.4003 46.6638 27.7129 46.6638 27.7129V27.6022C46.6638 27.6022 48.1906 24.7193 50.3094 22.516C52.4804 20.259 55.8923 18.7875 59.89 20.1863Z",
    fill: "url(#paint134_linear_49_3501)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5656 27.6974H47.0698L46.6625 27.7211C46.6625 27.7211 44.4663 31.3152 44.2358 37.0194C44.2358 37.0194 45.802 30.4918 45.7468 32.1197C45.6994 33.4015 45.292 37.4936 45.292 37.4936C45.292 37.4936 47.2609 27.8728 48.0345 27.6626L47.5656 27.6974Z",
    fill: "url(#paint135_linear_49_3501)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M101.741 20.0674C100.952 20.0674 99.1232 20.4278 97.3202 29.1382C96.0081 35.748 95.9513 35.8934 95.9513 35.8934C95.9513 35.8934 98.1049 25.8744 99.0032 24.1848C99.9016 22.4952 100.607 21.2165 102.032 21.3904C103.456 21.5642 104.305 25.0872 104.365 26.573C104.422 27.6224 104.267 33.227 104.267 33.227L104.698 28.5218C104.698 28.5218 104.765 20.0406 101.741 20.0674Z",
    fill: "url(#paint136_linear_49_3501)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4952 12.846C31.4952 12.846 39.6422 5.92168 44.9156 4.09774C50.1891 2.2738 63.5747 1.27332 70.2455 1.50724C70.2455 1.50724 67.0246 2.98346 63.4168 12.4983C63.4168 12.5062 52.1642 11.139 31.4952 12.846Z",
    fill: "#282828"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M86.119 3.182C83.0086 1.72632 75.9668 -0.0217544 72.5075 2.1341C69.0482 4.28996 66.5315 12.169 66.5315 12.169L66.3389 14.0877L72.0686 13.7985C72.0686 13.7985 80.8566 13.5061 85.0753 13.4824C89.9903 13.3955 97.6589 13.9897 97.6589 13.9897C96.3216 8.64593 89.2325 4.644 86.119 3.182Z",
    fill: "url(#paint137_linear_49_3501)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7662 20.6889C29.7662 20.6889 27.0284 22.32 23.0134 28.0906C24.1186 28.206 31.6829 28.6106 37.97 24.5913C41.4009 22.32 42.7413 20.2827 42.7413 20.2827L29.7662 20.6889Z",
    fill: "#434244"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91231 21.833L3.46391 22.3767C3.46391 22.3767 2.00345 27.7948 2.44712 29.064C2.44712 29.064 2.80394 29.4259 8.00316 29.8906C8.00316 29.8906 15.9765 30.7646 17.4306 29.8321L25.4023 21.9089C25.4023 21.9089 4.43491 22.2455 3.91231 21.833Z",
    fill: "url(#paint138_linear_49_3501)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93127 27.217C1.93127 27.217 -0.0470506 26.7871 2.24705 22.4375C3.48646 20.7289 3.87328 20.8475 3.87328 20.8475C3.87328 20.8475 2.01022 26.6322 1.93127 27.217Z",
    fill: "#434244"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0.458985 33.894C0.458985 33.894 0.301098 35.2154 0.458985 35.8365C0.143211 36.5335 -0.200984 37.2321 1.07948 38.2073C1.31315 35.5678 1.35105 34.403 1.35105 34.403C1.04311 34.2526 0.745146 34.0826 0.458985 33.894Z",
    fill: "#272525"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36053 34.103C1.91529 34.5329 1.83635 34.8633 1.7574 35.9159C1.67846 36.9685 1.4211 38.4716 1.91529 38.9505C3.07102 39.5559 15.3878 42.1654 17.6361 41.3214C17.8698 41.2423 17.8698 40.931 17.5966 40.1533C17.4608 39.7677 17.224 38.6518 16.9193 37.6102C16.6146 36.5687 16.2277 35.5713 15.4636 35.5713C14.1926 35.5255 3.06155 34.2848 2.36053 34.103Z",
    fill: "#272525"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7998 36.4195C17.7998 36.4195 18.7692 40.6538 19.2366 41.0774C19.2366 41.0774 27.1862 41.3145 29.9034 40.6143C32.6207 39.9141 36.7305 38.9832 37.4283 35.4854C37.4283 35.2547 36.8852 35.2926 35.761 35.3716C34.6369 35.4506 17.9924 36.459 17.7998 36.4195Z",
    fill: "#050505"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5984 13.5282C66.5984 13.5282 68.8989 7.00211 69.7736 5.75032C70.6483 4.49853 72.3598 2.43119 73.7586 1.96493C75.1575 1.49867 83.3266 0.0414132 92.9324 7.78764C92.9324 7.78764 94.996 9.97352 96.0996 12.0108C94.5603 10.2643 94.2966 10.4493 92.0277 10.0699C91.3962 9.9672 86.208 9.60842 85.016 10.002C84.6528 10.0747 85.0728 10.0778 84.7255 10.149C84.4097 10.2138 83.1908 10.405 82.7471 10.3513C81.0577 10.149 79.7189 10.3766 78.8757 10.4967C73.7034 11.2427 69.2257 11.66 66.5984 13.5282Z",
    fill: "url(#paint139_linear_49_3501)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0054 3.24602C82.8934 1.78876 75.8517 0.0406844 72.3892 2.19654C68.9267 4.3524 66.4116 12.2251 66.4116 12.2251L66.2158 14.1359L71.9455 13.8467C71.9455 13.8467 80.7351 13.5559 84.9523 13.5306C89.8705 13.4405 97.5517 13.9668 97.5517 13.9668C96.2144 8.6325 89.1189 4.70012 86.0054 3.24602ZM84.9002 13.1102C80.9183 13.1355 72.6197 13.4042 72.6197 13.4042L67.2074 13.6744L67.3858 11.9137C67.3858 11.9137 69.7541 4.67799 73.0318 2.69916C76.3095 0.72032 82.9471 2.32141 85.8885 3.66171C88.83 5.002 95.5307 8.61354 96.7954 13.5101C96.7985 13.5101 89.5452 13.0296 84.9033 13.1102H84.9002Z",
    fill: "url(#paint140_linear_49_3501)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0151 3.49808C72.0151 3.49808 74.475 1.17469 79.9095 2.319L80.1179 2.24472L81.5089 2.51499V2.63194C81.5089 2.63194 89.1964 3.79681 95.1519 10.5931C95.1519 10.5931 96.3361 12.0077 96.6266 13.2911L97.1002 13.3891C97.1002 13.3891 96.7103 10.6295 91.0658 6.57381C85.4213 2.51815 81.771 2.33796 80.92 2.1483C80.069 1.95863 74.8997 0.667335 72.0151 3.49808Z",
    fill: "#272525"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2987 6.18548C83.2987 6.18548 83.1803 6.30402 83.3855 6.68177C83.5908 7.05952 84.5192 9.59471 84.7244 10.1479C85.4223 8.98146 86.8796 8.02049 90.0231 8.31289C90.0231 8.31289 87.339 6.04165 86.7912 5.92627L83.2987 6.18548Z",
    fill: "url(#paint141_linear_49_3501)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5308 6.5939L80.0133 6.47852C80.0133 6.47852 81.6443 11.6611 81.7501 12.3044C81.3459 12.4198 80.3859 12.4498 80.3859 12.4498L81.0522 12.2744L80.528 12.0689C80.528 12.0689 80.7096 7.64338 78.5308 6.5939Z",
    fill: "url(#paint142_linear_49_3501)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3086 7.43795L73.9536 6.94482C73.9536 6.94482 73.2273 7.49643 73.1642 7.76038C72.2327 7.84731 71.7669 8.13972 71.039 9.44682L70.7233 9.50688L69.356 8.22664L69.0923 7.78725L69.3086 7.43795Z",
    fill: "url(#paint143_linear_49_3501)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3884 9.50391C91.5535 10.5442 91.6064 11.5992 91.5463 12.6508C91.9694 12.7206 92.3992 12.7397 92.8268 12.7077C92.8268 12.7077 92.6689 12.145 92.4447 11.4543C92.1858 10.6435 91.8968 9.69041 91.3884 9.50391Z",
    fill: "url(#paint144_linear_49_3501)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8474 8.58213L56.0694 6.43734C56.0694 6.43734 57.6783 6.5132 58.2798 6.13071L58.5103 5.97266C58.5103 5.97266 62.1844 6.20183 64.0174 8.50152L63.3133 9.56364C63.3133 9.56364 61.1281 9.26334 59.966 10.1089C59.3345 7.76657 58.2798 8.03842 57.7477 7.96414C57.2157 7.88985 55.1473 8.19648 54.8474 8.58213Z",
    fill: "url(#paint145_linear_49_3501)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4788 9.23242C64.4788 9.25613 64.2815 9.31777 64.2815 9.31777L64.0052 9.74294L64.4599 9.91363L64.6841 9.37941L64.4788 9.23242Z",
    fill: "url(#paint146_linear_49_3501)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2346 6.81755C52.0094 6.58837 52.5446 5.20856 52.5446 5.20856C46.818 4.55896 40.6794 9.01766 38.1769 11.0882C37.2469 11.8121 36.6927 12.3036 36.6927 12.3036C38.5147 11.9996 40.3522 11.7975 42.1967 11.6983L42.8488 11.6698C43.2098 11.6572 43.5782 11.6482 43.954 11.6429L43.9698 11.624C47.3312 11.4944 50.6326 11.4122 50.6326 11.4122C50.6326 11.4122 51.4773 9.73207 53.2346 6.81755Z",
    fill: "url(#paint147_linear_49_3501)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2683 5.1952C50.2683 5.1952 52.0304 4.03193 52.6714 3.77272C53.3124 3.51351 55.5497 2.23011 55.6933 2.20166C54.446 2.20166 47.8385 2.99193 44.7833 4.09831C41.7282 5.20469 35.5912 9.37099 31.5003 12.8545L36.6901 12.3045C36.6901 12.3045 40.8204 8.72139 44.6034 6.90061C47.8321 5.34694 50.2683 5.1952 50.2683 5.1952Z",
    fill: "#282828"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6909 12.3051L34.9178 12.392C34.9178 12.392 40.7597 7.09243 43.8748 5.86752C43.8748 5.86752 44.0816 4.87652 42.3354 5.6336C40.5891 6.39068 36.5757 8.69036 32.1248 12.7113L36.6909 12.3051Z",
    fill: "url(#paint148_linear_49_3501)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0136 4.81733C53.0136 4.81733 52.1121 6.27301 52.8652 6.33307C53.6183 6.39313 54.7914 6.33307 54.7914 6.33307C54.7914 6.33307 54.8483 4.52651 53.0136 4.81733Z",
    fill: "url(#paint149_linear_49_3501)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8704 4.49902C57.8704 4.49902 58.3441 5.78084 58.1862 5.86777C58.0283 5.9547 55.9158 6.24552 55.7705 6.21707C55.69 6.20127 55.1595 5.23082 55.1863 4.80881C55.2148 4.46584 55.7737 4.65076 55.9458 4.6144C56.331 4.52747 57.8704 4.49902 57.8704 4.49902Z",
    fill: "url(#paint150_linear_49_3501)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2339 6.81706C53.4556 6.81255 53.677 6.79619 53.897 6.76807L51.3898 11.3311L50.6351 11.4133L53.2339 6.81706Z",
    fill: "url(#paint151_linear_49_3501)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4636 22.3807C3.48255 22.3253 3.37203 22.4549 4.05568 22.5071C4.82617 22.5656 6.58187 22.5735 10.5859 22.6225C18.5355 22.7205 23.6763 22.6414 23.6763 22.6414C23.6763 22.6414 24.0663 22.3253 17.2835 29.3682C17.2835 29.3682 16.9361 29.7207 15.3888 29.7523C13.8415 29.7839 10.0633 29.4852 8.34705 29.3682C7.02237 29.2813 4.38882 29.139 2.9631 28.8182C2.60154 28.736 2.48944 28.4721 2.50049 28.2919C2.5068 28.2919 2.44681 25.9416 3.4636 22.3807Z",
    fill: "#262525"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3458 22.0315C21.3458 22.0315 20.6464 22.0315 20.4995 22.3476C20.1838 22.5815 20.3243 22.5815 19.9169 22.61C21.9253 22.5815 23.6904 22.5531 23.6904 22.5531L25.3309 21.9414L21.3458 22.0315Z",
    fill: "url(#paint152_linear_49_3501)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6763 22.6412L25.402 21.9126C25.402 21.9126 17.926 29.4012 17.4287 29.8358C16.2082 30.4681 12.67 30.1709 11.3643 30.1425C11.3643 30.1425 16.0061 30.1567 16.1214 29.9228C16.1214 29.9228 16.9298 29.5988 17.1098 29.485C17.7445 29.0772 23.6763 22.6412 23.6763 22.6412Z",
    fill: "url(#paint153_linear_49_3501)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00673 29.1571C5.00673 29.1571 2.88472 28.8947 2.85473 28.9327C2.82473 28.9706 2.73631 29.1097 2.83262 29.1777C2.9792 29.2393 3.13309 29.2818 3.2905 29.3041C2.45527 29.146 2.39685 29.0686 2.38738 28.7888C2.38738 28.7888 2.14739 28.2752 3.10577 23.769C3.10577 23.8086 2.05897 28.3336 2.62263 28.7699C3.34733 28.9153 3.25102 28.9453 5.00673 29.1571Z",
    fill: "url(#paint154_linear_49_3501)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85629 28.9321C2.85629 28.9321 2.72051 29.1091 2.83419 29.1471C2.83419 29.1471 2.91471 29.3051 7.59764 29.8077C10.0875 30.1026 12.5962 30.2083 15.102 30.1239C15.102 30.1239 15.9625 30.0527 16.1235 29.92C16.2814 29.833 16.8482 29.6039 16.913 29.5722C15.9246 29.7034 15.2978 29.8631 8.85126 29.3984L2.85629 28.9321Z",
    fill: "url(#paint155_linear_49_3501)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91167 21.833L3.46327 22.383C3.46327 22.383 2.99908 23.9889 2.85541 24.9198C3.23276 23.3772 3.54222 22.3672 3.54222 22.3672C3.54222 22.3672 3.42696 22.5822 7.55728 22.5648L19.8441 22.5932C19.9597 22.6077 20.0771 22.5928 20.1855 22.55C20.2939 22.5072 20.3899 22.4378 20.4646 22.3483C20.555 22.2435 20.667 22.1596 20.793 22.1023C20.9189 22.045 21.0557 22.0157 21.194 22.0164H10.4119C9.4093 22.0084 4.48164 22.078 3.91167 21.833Z",
    fill: "url(#paint156_linear_49_3501)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91187 21.833C3.91187 21.833 3.50295 22.2898 3.54242 22.3562C3.58189 22.4225 3.70031 22.4257 3.94977 22.4557C4.19923 22.4858 9.19477 22.5869 9.51529 22.5806C9.8358 22.5743 9.2674 22.0495 9.2674 22.0495C9.2674 22.0495 4.16607 22.0116 3.91187 21.833Z",
    fill: "url(#paint157_linear_49_3501)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71664 28.9319C4.12141 28.8908 3.43776 28.8307 3.36513 28.6284C3.2925 28.4261 3.10146 28.2475 3.45197 26.0348C3.80248 23.822 4.05668 22.507 4.05668 22.507C3.87766 22.4963 3.70004 22.4688 3.52617 22.4248C3.16303 23.7224 2.88673 24.6075 2.73674 25.9194C2.58675 27.2312 2.12887 28.6569 2.96883 28.8181C5.00716 29.1563 12.862 29.9245 15.9314 29.689C15.9329 29.689 10.579 29.5578 4.71664 28.9319Z",
    fill: "url(#paint158_linear_49_3501)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4781 35.2668C12.296 35.3253 15.8153 35.7726 15.8153 35.7726C16.4563 35.8785 17.5852 40.6865 17.5852 40.6865C17.6136 41.3187 17.4889 41.3187 17.4889 41.3187C12.0165 41.3456 4.49637 39.8741 3.02644 39.4679C1.55651 39.0617 1.54388 38.7108 1.58967 37.4432C1.63545 36.1756 1.86439 34.6472 1.97965 34.4133C2.05012 34.2734 2.16996 34.1647 2.31595 34.1083C2.35858 34.0735 9.23929 35.1088 11.4781 35.2668Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0.570699 33.9863C0.817784 34.1284 1.05514 34.2868 1.28119 34.4605C1.32698 34.5332 1.0791 38.2111 1.0791 38.2111C1.0791 38.2111 -0.362414 37.4208 0.447547 35.9019C0.489662 35.806 0.50017 35.6992 0.477546 35.5969C0.477546 35.5969 0.234399 34.4083 0.570699 33.9863Z",
    fill: "#434244"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81256 37.9541L4.97045 34.7124C4.97045 34.7124 2.77898 34.2936 2.51846 34.3031C2.25795 34.3126 2.07164 34.0328 1.92481 35.3431C1.77797 36.6533 1.54746 38.2845 1.78902 38.6827C1.89481 38.8661 2.04322 39.0621 2.54688 39.1964L4.81256 37.9541Z",
    fill: "url(#paint159_linear_49_3501)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81294 37.9531C4.86189 37.9926 9.47851 38.9836 17.2576 39.5669C17.2576 39.5669 17.6823 40.6148 17.6618 40.9641C17.6413 41.3134 17.2576 41.2154 16.9071 41.2154C16.5566 41.2154 11.04 41.198 2.53937 39.1954L4.81294 37.9531Z",
    fill: "url(#paint160_linear_49_3501)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3051 36.6892C18.3051 36.6892 17.9025 36.5675 18.2182 37.6375C18.534 38.7075 19.1214 40.8697 19.3535 40.8697C19.5856 40.8697 20.5739 40.375 20.5739 40.375L19.5287 36.6465L18.3051 36.6892Z",
    fill: "url(#paint161_linear_49_3501)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5704 40.3797C20.5704 40.3797 30.8726 40.6958 34.3066 39.1279C34.3066 39.1279 32.3883 40.3797 28.2832 40.7606C24.1782 41.1415 19.5536 40.9566 19.5536 40.9566L20.5704 40.3797Z",
    fill: "url(#paint162_linear_49_3501)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44961 34.7596C3.44961 34.7596 2.49123 34.6996 2.40282 34.8023C2.35326 34.8539 2.32265 34.9207 2.31598 34.992C2.31598 34.992 5.7895 36.0288 11.3645 36.405L16.4563 36.7985L16.2669 36.3465C16.2669 36.3465 7.45047 35.7064 3.44961 34.7596Z",
    fill: "url(#paint163_linear_49_3501)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17262 36.0874C3.17262 36.0874 2.2253 36.1664 2.2253 36.2455C2.22305 36.3101 2.21619 36.3746 2.20477 36.4383C2.20477 36.4383 5.48093 37.3866 11.5517 38.0315C11.5517 38.0315 15.8967 38.4977 17.1377 38.4598L16.9941 37.9856C16.9941 37.9856 5.88828 37.1638 3.17262 36.0874Z",
    fill: "url(#paint164_linear_49_3501)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18532 37.479C3.18532 37.479 2.08959 37.479 2.14801 37.7951C2.14801 37.7951 4.47684 38.8904 9.84658 39.4563C9.84658 39.4563 16.1905 40.2623 17.583 40.2039L17.4678 39.7376C17.4678 39.7376 6.24991 38.9015 3.18532 37.479Z",
    fill: "url(#paint165_linear_49_3501)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40422 34.8027C2.40422 34.8027 3.87099 35.2927 8.7197 35.8759C8.7197 35.8759 14.8394 36.584 16.4704 36.6235L16.6125 36.8843C16.6125 36.8843 16.0899 36.9807 8.62339 36.1857C8.62339 36.1857 4.55938 35.661 2.30791 34.9924C2.31738 34.9924 2.27159 34.8343 2.40422 34.8027Z",
    fill: "url(#paint166_linear_49_3501)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22516 36.2437C2.22516 36.2437 5.49816 37.0719 7.81436 37.3658C7.81436 37.3658 14.8988 38.3711 17.095 38.2525L17.1376 38.458C17.1376 38.458 7.94383 38.1119 2.20463 36.4365C2.20463 36.4365 2.1478 36.2737 2.22516 36.2437Z",
    fill: "url(#paint167_linear_49_3501)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2001 37.6699C2.2001 37.6699 3.91633 38.2674 6.82461 38.7336C9.73289 39.1999 11.877 39.448 17.4741 39.9301L17.5309 40.1324C17.5309 40.1324 5.6894 39.5508 2.18273 37.8612C2.18273 37.8612 2.08326 37.7316 2.2001 37.6699Z",
    fill: "url(#paint168_linear_49_3501)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32123 34.1445C2.32123 34.1445 2.11124 34.1445 2.00546 34.4401C1.89968 34.7357 1.72916 35.9384 1.67548 36.4948C1.67548 36.4948 1.90915 34.4101 2.1965 34.3216C2.1965 34.3216 2.1965 34.1983 6.14368 34.7957C6.14368 34.7957 13.0986 35.5085 15.8758 35.9321C16.3574 36.1344 16.4142 36.6592 16.5958 37.1776C16.6811 37.4178 17.4973 39.8866 17.6221 40.3655C17.7468 40.8444 17.7689 41.1368 17.6521 41.2317C17.6521 41.2317 14.4943 41.7438 7.66413 40.2976C7.66413 40.2976 8.39831 40.5916 15.6153 41.3787C15.6153 41.3787 16.8784 41.4213 17.1942 41.3929C17.51 41.3644 17.7468 41.3486 17.8163 41.1305C17.8857 40.9124 17.12 38.4436 16.7379 37.2566C16.7379 37.2566 16.4932 35.9922 15.8253 35.7836C15.1574 35.5749 11.5766 35.292 11.5766 35.292C11.5766 35.292 2.87226 34.2568 2.36386 34.1556L2.32123 34.1445Z",
    fill: "#7F8081"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75045 36.5483C1.75045 36.5483 1.5452 38.5303 1.76624 38.7469C1.98728 38.9634 2.38831 39.4028 7.46438 40.2642C7.46438 40.2642 2.92513 39.7252 1.92255 38.9508C1.92255 38.9508 1.61782 38.8638 1.5752 38.1953L1.75045 36.5483Z",
    fill: "#7F8081"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8837 22.5961C6.8837 22.5961 5.63639 26.2314 6.22058 29.0226L4.6717 28.9214C4.59627 27.8879 4.61106 26.8498 4.71591 25.8188C4.82328 24.7883 4.97643 23.6661 5.48798 22.5771L6.8837 22.5961Z",
    fill: "url(#paint169_linear_49_3501)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21181 22.6064C7.70391 23.5454 7.31665 24.5448 7.05923 25.581C6.77745 26.7316 6.61867 27.9088 6.58557 29.093L8.12971 29.1689C8.12971 29.1689 8.87651 22.9194 9.57595 22.6286C8.41706 22.6128 8.21181 22.6064 8.21181 22.6064Z",
    fill: "url(#paint170_linear_49_3501)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4292 22.6572C11.4292 22.6572 10.3966 24.6819 8.98669 29.2829L10.5577 29.384C10.5577 29.384 11.895 23.5155 12.7239 22.6699C11.8034 22.6699 11.4292 22.6572 11.4292 22.6572Z",
    fill: "url(#paint171_linear_49_3501)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2348 22.7157C15.2206 22.7599 14.0696 24.2014 13.3276 25.7187C12.5855 27.236 11.8876 29.4883 11.8876 29.4883L13.4886 29.5467C13.4886 29.5467 15.4954 23.5043 16.6716 22.7346C15.7132 22.6856 15.2348 22.7157 15.2348 22.7157Z",
    fill: "url(#paint172_linear_49_3501)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0063 22.7307C18.8052 24.0478 17.7595 25.4987 16.8896 27.055L15.6549 29.6597L17.1106 29.4843C17.1106 29.4843 20.3978 22.9915 21.1825 22.688C20.4578 22.7149 20.0063 22.7307 20.0063 22.7307Z",
    fill: "url(#paint173_linear_49_3501)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48709 22.5766C5.48709 22.5766 4.80344 24.38 4.68503 26.1075C4.61267 27.0437 4.60792 27.9839 4.67082 28.9208H4.84291C4.84291 28.9208 4.66766 25.9289 5.05448 24.5507C5.46341 23.1013 5.63551 22.5513 5.63551 22.5513L5.48709 22.5766Z",
    fill: "url(#paint174_linear_49_3501)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29719 22.6132C8.29719 22.6132 7.61354 24.0705 7.32303 24.8718C7.03252 25.6732 6.69306 29.1029 6.69306 29.1029L6.57465 29.0871C6.57465 29.0871 6.73253 27.2379 7.01041 25.7822C7.28829 24.3265 8.20878 22.6006 8.20878 22.6006L8.29719 22.6132Z",
    fill: "url(#paint175_linear_49_3501)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4292 22.6572C10.8482 23.8476 10.3425 25.0734 9.91507 26.3272C9.33563 28.118 8.98669 29.2829 8.98669 29.2829L9.11616 29.3113C9.11616 29.3113 10.1945 25.6128 10.4393 25.0612L11.516 22.6699L11.4292 22.6572Z",
    fill: "url(#paint176_linear_49_3501)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2617 22.6392C15.2206 22.6392 13.1949 25.5157 12.5444 27.4977C11.894 29.4797 11.8876 29.4797 11.8876 29.4797L12.006 29.5161C12.006 29.5161 12.805 26.9287 13.1365 26.3029C13.4681 25.677 15.1606 22.7972 15.3643 22.6392H15.2617Z",
    fill: "url(#paint177_linear_49_3501)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0552 22.6699C20.0552 22.6699 18.2727 24.5508 17.1375 26.6608C16.0023 28.7708 15.6549 29.6638 15.6549 29.6638L15.7402 29.6812C15.7402 29.6812 17.3869 26.3447 17.649 25.9527C17.9111 25.5607 20.1484 22.6778 20.1484 22.6778L20.0552 22.6699Z",
    fill: "url(#paint178_linear_49_3501)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1192 40.7313C1.1192 40.7313 1.27709 40.3804 1.39077 40.3804C1.50445 40.3804 4.07485 41.4299 9.77141 42.2059C15.468 42.9819 18.651 43.2174 19.4294 43.4498C20.0215 43.6513 20.5922 43.9113 21.133 44.2258C21.133 44.2258 9.69247 43.5446 3.137 41.4314C3.137 41.4314 1.85653 40.7708 1.70338 40.7328C1.5093 40.7109 1.3134 40.7104 1.1192 40.7313Z",
    fill: "#262525"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1373 38.4574V38.252L20.0026 38.0512C20.0026 38.0512 35.9381 37.1772 36.8696 36.7979C36.8403 36.887 36.7877 36.9665 36.7171 37.0283C36.6466 37.09 36.5607 37.1316 36.4686 37.1487C36.1481 37.2025 31.6104 37.8457 19.1373 38.4574Z",
    fill: "url(#paint179_linear_49_3501)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3976 39.7643L19.7281 40.0014L19.785 40.1769C19.785 40.1769 33.0475 39.5652 34.4495 39.0373L34.9232 38.8081C34.9232 38.8081 21.5628 39.9414 20.3976 39.7643Z",
    fill: "url(#paint180_linear_49_3501)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0316 36.71C18.0316 36.6681 18.0482 36.6279 18.0779 36.5983C18.1075 36.5686 18.1476 36.552 18.1895 36.552C18.3474 36.5314 33.2188 35.6574 34.3856 35.6036C35.5523 35.5499 37.2954 35.3887 37.3349 35.5088C37.3349 35.5088 31.2436 35.934 30.4479 35.9703C29.6521 36.0067 18.3079 36.5946 18.1706 36.7479C18.0332 36.9013 18.1137 37.3912 18.1137 37.3912L18.0316 36.71Z",
    fill: "#7F8081"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2465 37.9038C18.2465 37.9038 19.0754 40.978 19.3075 41.0048C19.5396 41.0317 25.9846 41.2103 29.0823 40.7156C29.0823 40.7156 19.7133 41.2103 19.3502 40.8736C18.987 40.537 18.2465 37.9038 18.2465 37.9038Z",
    fill: "#7F8081"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0.521159 33.9907C0.489919 34.1527 0.474582 34.3173 0.475371 34.4823C0.625653 34.4114 0.785079 34.362 0.949032 34.3353C0.949032 34.3353 0.551158 34.0255 0.521159 33.9907Z",
    fill: "#272525"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0.464858 34.8398C0.451969 35.2143 0.480565 35.5891 0.550119 35.9573C0.550119 35.9573 0.550119 35.834 0.651166 35.7992C0.825343 35.7627 1.00139 35.7358 1.17851 35.7186C0.839258 35.5253 0.584649 35.2118 0.464858 34.8398Z",
    fill: "#272525"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0.533294 36.0576C0.533294 36.0576 0.23331 36.2599 0.277518 37.0992C0.368113 37.3712 0.518048 37.6195 0.716444 37.8262C0.81797 37.933 0.928943 38.0303 1.04801 38.1171L1.16168 37.1434C1.16168 37.1434 0.60908 36.6898 0.533294 36.0576Z",
    fill: "#272525"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1373 38.2522C19.1373 38.2522 35.6918 37.3117 36.778 36.9419C36.778 36.9419 36.4544 37.2738 33.8729 37.4666C31.2915 37.6595 21.1899 38.415 19.1373 38.4576V38.2522Z",
    fill: "url(#paint181_linear_49_3501)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8139 40.0476C19.8139 40.0476 27.012 39.6809 29.1655 39.4865C31.3191 39.2921 34.45 39.0376 34.45 39.0376L34.2053 39.1751C34.2053 39.1751 27.1083 39.8737 19.7855 40.1772L19.8139 40.0476Z",
    fill: "url(#paint182_linear_49_3501)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39064 24.0986C3.39064 24.0986 3.01172 24.8288 2.85541 25.2635C2.85541 25.2635 3.38433 24.2836 3.43801 24.2203C3.49169 24.1571 3.37643 24.1413 3.39064 24.0986Z",
    fill: "url(#paint183_linear_49_3501)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06098 26.4443C2.8211 26.9845 2.6288 27.5445 2.48627 28.1181L3.04203 26.7162L3.06098 26.4443Z",
    fill: "url(#paint184_linear_49_3501)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45667 24.0161C3.45667 24.0161 3.37142 24.1742 3.43773 24.22C3.50404 24.2658 7.18439 24.525 8.13487 24.5361C8.13487 24.5361 10.7795 24.6041 10.8474 24.6199C10.9153 24.6357 21.3105 24.7242 21.7163 24.6878L21.9389 24.4697C21.9389 24.4697 3.84981 24.0161 3.45667 24.0161Z",
    fill: "#434244"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06057 26.4441L3.04163 26.716C3.04163 26.716 3.38108 26.9246 7.00617 27.1396C7.00617 27.1396 10.6565 27.315 11.7428 27.3498C12.829 27.3845 18.543 27.5489 19.1208 27.4778L19.3924 27.1728C19.3924 27.1728 10.9123 26.8566 10.6407 26.8345C10.3692 26.8124 3.35424 26.3572 3.06057 26.4441Z",
    fill: "#434244"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4571 24.0161C3.4571 24.0161 7.39165 24.3322 10.8573 24.3891C14.3229 24.446 21.9394 24.4761 21.9394 24.4761L21.7167 24.6942C21.7167 24.6942 9.08577 24.623 6.14118 24.4476C6.14118 24.4476 3.07028 24.4002 3.4571 24.0161Z",
    fill: "url(#paint185_linear_49_3501)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06057 26.4443C3.06057 26.4443 6.56251 26.8648 10.557 27.0023C10.557 27.0023 18.3851 27.2283 19.3893 27.173L19.1177 27.478C19.1177 27.478 11.7601 27.369 7.33615 27.1398C7.33615 27.1398 3.3274 26.8237 3.04163 26.7162L3.06057 26.4443Z",
    fill: "url(#paint186_linear_49_3501)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0798 2.24756C80.0798 2.24756 81.4835 5.62043 82.0676 7.23891C82.6518 8.85738 83.457 12.2666 83.5533 12.7929L85.448 12.8277C85.448 12.8277 83.6623 6.35538 81.4345 2.51783L80.0798 2.24756Z",
    fill: "url(#paint187_linear_49_3501)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4238 8.04814C81.707 5.80694 80.0791 2.24756 80.0791 2.24756L79.9323 2.32659C79.9323 2.32659 81.4196 5.82749 82.0022 7.35271C82.5848 8.87793 83.3442 12.7724 83.3442 12.7724L83.5527 12.7929C83.2752 11.1894 82.8982 9.60472 82.4238 8.04814Z",
    fill: "url(#paint188_linear_49_3501)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0824 38.5305V38.5146L68.2766 33.9311L68.2403 32.3774C68.2403 32.3663 68.4645 31.4986 68.6161 29.3523C68.7661 23.4078 67.5535 16.3254 67.5267 16.1516L66.1973 14.1364L66.4388 12.1022C66.4972 11.8004 66.6772 11.391 66.952 10.6687C67.4899 9.32757 68.1008 8.01693 68.7819 6.74263C69.4655 5.44501 70.2376 3.97352 71.4754 2.88295C72.8364 1.68332 74.6079 1.1001 76.8767 1.1001C77.9581 1.11084 79.0364 1.21662 80.0992 1.41621C81.1365 1.60745 84.6874 2.59529 85.9616 3.16587C88.1954 4.19833 90.3125 5.4668 92.277 6.94968C93.576 7.9319 94.7476 9.07236 95.7648 10.3447C97.3152 12.3346 97.5631 13.7239 97.5631 13.7381L98.4157 15.7549C99.3093 18.2505 98.1236 23.509 97.3389 26.4219C96.2653 30.4318 94.8806 33.9453 94.4559 34.1761C93.6112 34.636 68.3793 38.4862 68.1251 38.5257L68.0824 38.5305ZM68.2403 32.3806L68.3177 33.9342L68.1598 38.502C68.8735 38.3945 93.6096 34.6091 94.4433 34.1555C94.8664 33.9248 96.2384 30.4239 97.3168 26.4109C98.1062 23.5011 99.2841 18.2458 98.3952 15.7596L97.541 13.7413C97.541 13.7239 97.2884 12.3377 95.7443 10.3526C94.3233 8.51916 91.4576 5.78956 85.9553 3.18325C84.6827 2.6111 81.1381 1.62484 80.0992 1.44466C79.0378 1.24278 77.9603 1.13698 76.8799 1.12855C71.7675 1.12855 70.1965 4.11893 68.8056 6.76002C68.1271 8.02854 67.5198 9.33399 66.9867 10.6703C66.7025 11.4131 66.4657 11.9078 66.4578 12.1196L66.2146 14.1364L67.5409 16.1421C67.5535 16.2164 68.7819 23.3588 68.6271 29.3491C68.4772 31.456 68.2514 32.3347 68.2387 32.3806H68.2403Z",
    fill: "#272525"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4234 22.4051L3.43287 22.3593C3.4455 22.3024 3.63181 21.0348 4.02021 20.7234L4.03442 20.7424C3.69339 21.0158 3.52761 22.0763 3.46919 22.3229L3.90811 21.8108V21.8361C5.21068 22.2945 26.8017 21.8551 27.0244 21.8551H28.4927L29.8158 20.5906L39.8227 20.2287C39.9127 20.1797 42.3284 18.8362 43.312 18.4569C44.2956 18.0776 62.7321 15.2279 63.2421 15.1473L63.321 12.5299H63.3336C63.4363 12.5299 65.8962 12.5141 66.2072 12.6658L66.1961 12.68C65.9056 12.5315 63.531 12.522 63.3431 12.522L63.2658 15.1583C63.0747 15.1899 44.3193 18.1139 43.3294 18.4948C42.3394 18.8757 39.8637 20.2777 39.8369 20.2777L29.8347 20.6791L28.5164 21.8582H27.0354C26.8207 21.8582 5.30068 22.3087 3.91917 21.8582L3.4234 22.4051Z",
    fill: "#272525"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2897 27.8696C41.2997 27.8696 40.5434 27.7874 40.4424 27.4887C40.2845 27.0319 37.9872 24.7212 37.962 24.699L37.9778 24.6816C38.0725 24.7796 40.3129 27.0177 40.4645 27.4839C40.6161 27.9502 42.5502 27.8601 44.2538 27.7858L47.8994 27.6278V27.6515L44.2506 27.8095C43.578 27.838 42.8896 27.8696 42.2897 27.8696Z",
    fill: "#272525"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3717 35.5491H86.3465C86.637 34.5154 86.6401 31.2737 86.6401 31.2421L86.5833 30.2543C86.5833 30.2274 86.9875 28.0415 86.9322 27.629C86.877 27.2165 86.9875 20.6493 86.9875 20.5813L86.6401 18.3686C86.6401 18.3401 86.3007 15.3419 86.1886 15.1696C86.0765 14.9973 84.9776 13.4974 84.9776 13.4831L84.8576 12.9631L84.5039 12.7308C83.8724 8.98808 80.7147 2.432 80.7147 2.36562V2.35613H80.6862L80.8962 2.12854L80.5804 1.56429L80.5947 1.55322L80.9104 2.13328L80.6783 2.3672C80.7999 2.62167 83.8124 9.03866 84.4961 12.7276L84.8244 12.96L84.9618 13.4816C85.0076 13.5432 86.0781 14.9973 86.1918 15.168C86.3054 15.3387 86.6465 18.2532 86.6654 18.3781L87.0175 20.5908C87.0175 20.6588 86.9054 27.237 86.9591 27.6385C87.0128 28.0399 86.6291 30.1752 86.6117 30.2637L86.6686 31.25C86.6607 31.269 86.6591 34.5122 86.3717 35.5491Z",
    fill: "#272525"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M103.783 23.7918V23.7681C104.188 23.7444 105.452 23.6195 105.52 23.5721C105.588 23.5247 105.635 22.6238 105.13 20.9595C105.653 22.6775 105.634 23.5263 105.536 23.5942C105.438 23.6622 103.84 23.7855 103.783 23.7918Z",
    fill: "#272525"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0462 28.1182C23.0462 28.1182 28.6591 23.729 42.6637 20.4589C42.6637 20.4589 31.6116 20.3814 29.8243 20.6896C29.8243 20.6896 23.9746 25.5577 23.0462 28.1182Z",
    fill: "#272525"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1386 20.6511C35.1386 20.6511 36.4964 21.0779 35.9123 23.5261C35.9123 23.5261 35.0628 25.8558 35.5649 25.8179C35.5649 25.8179 37.5038 25.388 42.354 20.7286L42.1235 20.3809L35.1386 20.6511Z",
    fill: "url(#paint189_linear_49_3501)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2338 22.3211C28.2338 22.3211 29.0501 21.9354 30.2863 23.0212C31.1784 23.6787 31.101 24.6144 31.101 24.9179C31.101 25.2214 32.8473 25.1139 32.8473 25.1139L33.1978 24.7598L33.4283 24.842L34.3993 24.567L35.5203 24.4532C35.5203 24.4532 36.9602 21.1135 35.1351 20.6457L34.0125 20.5698L29.8206 20.6836L28.1122 22.084L28.2338 22.3211Z",
    fill: "#A4A6A8"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7178 25.7556C25.7336 25.4569 25.1999 25.8979 24.9884 25.9532C24.9229 25.9657 24.8552 25.9605 24.7925 25.938C24.7297 25.9155 24.6741 25.8765 24.6315 25.8251C24.6315 25.8251 27.1277 22.7605 28.1161 22.0903L28.2345 22.3211C28.4299 22.2335 28.6433 22.1935 28.8571 22.2045C29.0709 22.2155 29.2791 22.2771 29.4645 22.3843C30.156 22.7384 30.8175 23.5428 30.8175 23.5428C30.9849 24.0065 31.0699 24.496 31.0686 24.989C31.0686 24.989 31.0686 25.9879 30.9439 27.3456C30.9439 27.3456 28.195 28.0031 26.1662 27.9352C26.1662 27.9352 25.6483 27.2065 25.7178 25.7556Z",
    fill: "#7F8081"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3118 22.1628C32.3118 22.1628 32.5754 21.1987 33.158 20.8541C33.158 20.8541 33.6317 20.4447 34.5553 20.617C35.479 20.7893 35.6748 21.1734 35.6748 21.1734L35.8042 21.2176L35.8784 21.9589L35.5863 22.0474C35.6161 22.6251 35.501 23.201 35.2516 23.7228L35.0179 23.6627C35.0179 23.6627 34.7274 24.1132 34.6532 24.2017L34.8458 24.3471C34.8458 24.3471 34.6532 24.551 34.568 24.551C34.4827 24.551 33.4328 24.8481 33.4328 24.8481C33.4328 24.8481 32.9244 24.6079 32.877 24.5794C32.8296 24.551 32.7191 24.7549 32.5754 24.8134C32.4318 24.8718 32.0797 25.0014 31.8918 24.9572C31.7212 24.8951 31.5613 24.8065 31.4181 24.6948C31.4181 24.6948 30.8355 23.5458 31.3281 22.7444C31.8207 21.9431 32.3118 22.1628 32.3118 22.1628Z",
    fill: "#EFEFF0"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6262 24.7876C26.6262 24.7876 26.1194 25.7786 26.8583 27.661C26.8664 27.684 26.8697 27.7084 26.868 27.7328C26.8664 27.7571 26.8599 27.7808 26.8488 27.8026C26.8377 27.8243 26.8223 27.8435 26.8036 27.8591C26.7849 27.8748 26.7632 27.8864 26.7399 27.8934C26.5507 27.9303 26.3577 27.9441 26.1652 27.9344C25.8218 27.2618 25.6669 26.5086 25.7168 25.7549C25.7168 25.7549 25.1121 26.1073 24.7031 25.8355L25.401 24.9046C25.401 24.9046 24.801 25.6806 25.4215 25.4878C25.8609 25.3267 26.2686 25.0897 26.6262 24.7876Z",
    fill: "#EFEFF0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8665 22.7488C27.8665 22.7488 28.7759 22.3205 29.1864 22.556C29.5969 22.7915 30.1937 23.0017 30.4669 24.9047C30.4502 25.4584 30.3911 26.0101 30.29 26.5548L30.0216 27.4873L30.2695 27.4478C30.2695 27.4478 30.7163 26.2244 30.6958 25.2145L30.6769 24.9236C30.7898 24.8724 30.9078 24.8332 31.0289 24.8067C31.1047 24.8067 30.8711 23.6624 30.7558 23.4506C30.6405 23.2388 29.6664 21.87 28.3117 22.2652L28.1759 22.0312L27.497 22.5939C27.497 22.5939 27.8128 22.4201 27.8665 22.4359C27.9201 22.4517 27.8665 22.7488 27.8665 22.7488Z",
    fill: "#EFEFF0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6256 24.7874C26.6256 24.7874 27.5619 23.7474 28.3402 23.4297L28.3545 23.5877H28.9102L28.956 24.1741H29.1644L29.177 24.3733L29.3839 24.3986L29.3697 24.6673C29.3697 24.6673 28.9102 24.7937 28.7381 25.1114C28.6884 25.2073 28.6638 25.3144 28.6665 25.4224C28.6693 25.5305 28.6994 25.6361 28.7539 25.7294L28.7208 26.0771L28.626 26.0471L28.4508 26.4422L28.356 26.3948L28.1208 27.174L27.9755 27.095L27.8666 27.3795L27.7087 27.2989L27.6298 27.4901L27.3929 27.4253L27.2666 27.8362L26.9635 27.8552C26.9635 27.8552 26.1582 26.4153 26.6256 24.7874Z",
    fill: "url(#paint190_linear_49_3501)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9862 20.6826C29.9862 20.6826 28.7089 21.8127 28.5147 22.1225L28.4957 22.211L28.7168 22.1999C28.7483 22.1999 28.7389 22.1146 28.7389 22.1146C28.7389 22.1146 29.9767 20.7869 30.0525 20.7585C30.1283 20.73 29.9862 20.6826 29.9862 20.6826Z",
    fill: "#EFEFF0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3631 20.7256C30.3631 20.7256 29.299 21.6739 29.1 22.1196L29.1395 22.1971L29.3969 22.2951V22.137C29.5198 21.801 29.7282 21.503 30.0016 21.2725L30.6331 20.7525L30.3631 20.7256Z",
    fill: "#EFEFF0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9684 20.7024C30.9684 20.7024 29.9264 21.5623 29.7338 22.1249L29.7511 22.4537L29.9453 22.588C29.9303 22.4441 29.9303 22.2989 29.9453 22.155C29.9753 22.117 30.7348 20.8494 31.4247 20.6851L30.9684 20.7024Z",
    fill: "#EFEFF0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9137 20.6435C31.2719 20.9798 30.7399 21.4932 30.3806 22.1229V22.2399L30.3238 22.3552C30.3238 22.3552 30.2369 22.3647 30.2369 22.4137C30.2369 22.4627 30.2654 22.7535 30.2559 22.793C30.2464 22.8326 30.3332 22.8895 30.3332 22.8895L30.3727 22.5496L30.4375 22.4216L30.5259 22.5101L30.5543 22.3379L30.6332 22.2493L30.6901 22.0265C30.6901 22.0265 31.6579 20.7779 32.1868 20.6514C32.7158 20.525 32.1379 20.634 32.1379 20.634L31.9137 20.6435Z",
    fill: "#EFEFF0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M33.06 20.584L32.8926 20.742C32.8926 20.742 32.2074 21.0297 31.9674 21.3016C31.7274 21.5734 31.3675 21.9195 31.2506 22.4079L31.0391 22.5849L30.9806 22.6513C30.9806 22.6513 30.8227 22.6687 30.807 22.6987C30.7969 22.7398 30.7901 22.7815 30.7864 22.8236L30.7612 22.6513L30.8496 22.4648L31.0075 22.3494C31.0075 22.3494 31.2696 21.6335 31.7969 21.2431C32.3243 20.8527 32.5863 20.7009 32.5863 20.7009L32.6653 20.614L33.06 20.584Z",
    fill: "#EFEFF0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M36.225 20.7003C36.2455 20.7288 36.4571 21.2266 36.4886 21.244C36.5202 21.2614 36.3908 21.293 36.3908 21.293L36.4886 21.6423C36.4886 21.6423 40.4532 21.5538 40.9758 21.7103L41.1605 21.8177C41.1605 21.8177 41.9073 21.1191 41.9831 21.0591C42.0544 21.0007 42.12 20.9356 42.1789 20.8647C42.1789 20.8647 42.0826 20.5833 42.021 20.5754C41.9594 20.5675 40.7863 20.4854 40.5053 20.4854C40.2243 20.4854 36.225 20.7003 36.225 20.7003Z",
    fill: "url(#paint191_linear_49_3501)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M36.691 22.0687C36.691 22.0687 36.6247 23.1467 36.5157 23.2826C36.5157 23.2826 38.4372 23.2541 38.8067 23.3031C38.96 23.3481 39.1065 23.4135 39.2425 23.4975C39.2425 23.4975 40.5308 22.437 40.5908 22.3706C40.5127 22.3302 40.4533 22.2611 40.425 22.1778C40.395 22.0482 39.9514 22.0308 39.4777 22.0102C39.004 21.9897 36.691 22.0687 36.691 22.0687Z",
    fill: "url(#paint192_linear_49_3501)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4569 23.7293C36.4569 23.7293 36.3243 24.3521 36.2548 24.5639C36.1854 24.7757 36.0006 25.3115 36.0606 25.381C36.1039 25.4241 36.1588 25.4538 36.2185 25.4663C36.2185 25.4663 37.9742 24.6429 38.5063 24.0202C38.5063 24.0202 38.5189 23.7894 38.14 23.7404C37.7611 23.6914 36.4569 23.7293 36.4569 23.7293Z",
    fill: "url(#paint193_linear_49_3501)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3385 20.6483L35.6543 20.8806C35.6543 20.8806 35.9874 21.448 36.0032 21.7831C36.019 22.1182 36.1469 22.4374 35.9306 23.3431C35.7143 24.2487 35.4064 25.0611 35.4222 25.382C35.438 25.7028 35.4111 25.8751 35.5611 25.8182C35.7111 25.7613 36.439 25.4389 36.439 25.4389C36.439 25.4389 35.8074 25.6854 35.8579 25.4389C35.9085 25.1923 36.0758 24.2724 36.1911 23.8236L36.2779 23.645L36.8305 23.6039C36.8305 23.6039 38.0936 23.558 38.5041 23.7066L38.7978 23.8378L39.2383 23.498C39.2383 23.498 39.0441 23.283 37.8173 23.283C36.5905 23.283 36.3205 23.3431 36.3205 23.3431C36.3205 23.3431 36.3363 22.5244 36.3774 22.5133C36.4184 22.5022 36.6111 22.4106 36.6111 22.4106L36.5384 22.047C36.5384 22.047 36.9742 22.017 37.031 22.017C37.0879 22.017 40.1035 21.84 40.454 21.9743C40.8045 22.1087 40.8298 22.1624 40.8298 22.1624L41.1535 21.8179C40.9424 21.7511 40.7272 21.6983 40.5093 21.6598C40.2598 21.6345 36.5953 21.7056 36.5953 21.7056C36.5381 21.5601 36.4673 21.4204 36.3837 21.2884C36.3205 21.2236 35.9416 20.6293 35.9416 20.6293L42.1087 20.4238L35.228 20.555L35.3385 20.6483Z",
    fill: "#EFEFF0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4297 25.845C25.3481 26.1936 25.3336 26.5546 25.3871 26.9087C25.4327 27.1429 25.5009 27.3721 25.5908 27.5931L25.766 27.563C25.766 27.563 25.4503 26.6321 25.6618 26.1073L25.7171 25.7549L25.4297 25.845Z",
    fill: "#EFEFF0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4864 26.5884C24.5464 26.5489 24.3838 27.7248 24.6443 28.0725C24.6443 28.0725 24.5132 28.2211 24.4532 28.191C24.3932 28.161 23.1728 28.2068 23.1586 28.1183C23.1443 28.0298 23.8027 27.0483 24.4864 26.5884Z",
    fill: "#EFEFF0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5117 26.4291C31.5117 26.4291 31.5701 26.9665 31.6996 27.085L32.0359 27.0977L31.9191 26.897C31.9191 26.897 32.1512 27.1119 32.2348 27.085C32.3185 27.0582 32.148 26.7326 32.148 26.7326C32.148 26.7326 32.3817 27.0692 32.4638 27.0487C32.5459 27.0282 32.4638 26.3643 32.4638 26.3643C32.4638 26.3643 32.5806 26.8906 32.7259 26.8906C32.8552 26.8803 32.9829 26.8549 33.1064 26.8148C33.1064 26.8148 32.8585 26.7136 32.8696 26.6109C32.8806 26.5082 32.9311 25.7969 32.8901 25.7511C32.849 25.7052 32.4954 25.288 32.4954 25.288L32.3043 25.2121L32.2175 25.2263C32.1689 25.1976 32.1153 25.1783 32.0596 25.1694C32.0028 25.1694 31.3491 25.288 31.3491 25.288C31.3491 25.288 31.1012 26.4228 31.0696 26.6836C31.0696 26.6836 31.1581 26.7721 31.2275 26.7563C31.297 26.7405 31.5117 26.4291 31.5117 26.4291Z",
    fill: "#EFEFF0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8682 26.4337H33.2471L33.4539 26.5665C33.4539 26.5665 33.7918 26.6107 33.855 26.6107C33.9809 26.5526 34.0996 26.48 34.2086 26.3942L34.4423 25.8015L34.6728 25.7572C34.6728 25.7572 34.6728 25.065 34.5876 25.0428C34.5116 25.028 34.4344 25.0206 34.357 25.0207L33.9797 24.7046L33.435 24.9353L33.2013 24.7662L33.0561 24.9148L33.1824 25.1661L33.2029 25.547L33.1413 25.8631L32.9313 26.067L32.8682 26.4337Z",
    fill: "#EFEFF0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5017 27.2437L25.1143 27.0557L25.4032 27.6389L24.6043 27.8538L24.5017 27.2437Z",
    fill: "#EFEFF0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4554 26.9403L24.9211 26.7633L24.9069 26.6036L25.0838 26.5151L24.4712 26.6779L24.4554 26.9403Z",
    fill: "#EFEFF0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M29.652 24.9443L29.6789 25.4675L30.042 25.4975L29.9994 25.0012L29.652 24.9443Z",
    fill: "#EFEFF0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4907 26.1397C29.4907 26.1397 29.3012 27.5527 29.3328 27.6397C29.3643 27.7266 28.3744 27.8847 28.3744 27.8847L28.8402 25.8916L29.4907 26.1397Z",
    fill: "#EFEFF0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1351 22.6124C35.1351 23.4975 34.5873 24.2151 33.9115 24.2151C33.2357 24.2151 32.6895 23.4975 32.6895 22.6124C32.6895 21.7273 33.2373 21.0098 33.9115 21.0098C34.5857 21.0098 35.1351 21.7289 35.1351 22.6124Z",
    fill: "#E0E0E0"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9968 23.6074C32.9968 24.1938 32.5752 24.668 32.0495 24.668C31.5237 24.668 31.11 24.1938 31.11 23.6074C31.11 23.021 31.53 22.5469 32.0495 22.5469C32.5689 22.5469 32.9968 23.021 32.9968 23.6074Z",
    fill: "#E0E0E0"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7031 25.8945C25.598 26.1841 25.5676 26.4957 25.6147 26.8002C25.7031 27.2554 25.8247 27.7485 25.8247 27.7485C25.8294 27.8011 25.8294 27.854 25.8247 27.9066C25.8205 27.9428 25.8265 27.9795 25.8421 28.0125L25.94 27.916L26.0189 27.6157C26.0189 27.6157 25.6242 26.5267 25.7031 25.8945Z",
    fill: "#272525"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3927 26.2916L24.8474 26.0008C24.8474 26.0008 23.5843 27.2652 23.4027 27.624C23.4027 27.624 24.7037 26.102 24.9279 26.0229L25.1221 25.9834L24.83 26.2821L25.1126 26.1952L25.2579 26.102L25.4158 25.906L24.8821 25.9155L24.6974 25.8364C24.5611 25.9617 24.4566 26.1178 24.3927 26.2916Z",
    fill: "#272525"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5118 26.4292L31.2797 26.7785L31.046 26.7864L31.065 27.1973L31.1739 27.2558L31.3192 27.2226H31.4249L31.5828 27.1594L31.6949 27.1009C31.6023 26.8869 31.5407 26.6607 31.5118 26.4292Z",
    fill: "#272525"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7613 22.1616L28.7376 22.1142C28.7376 22.1142 29.9407 20.777 30.1286 20.7186C30.3165 20.6601 30.3623 20.728 30.3623 20.728C30.3623 20.728 29.4039 21.5642 29.1118 22.0747L29.1307 22.1995L28.7613 22.1616Z",
    fill: "#272525"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8119 22.5564L29.3761 22.3067L29.3461 22.0981C29.3461 22.0981 30.1861 20.8731 30.565 20.772C30.9439 20.6708 31.1476 20.6708 31.0734 20.7135C30.9992 20.7562 30.1261 21.3204 29.7345 22.136L29.8119 22.5564Z",
    fill: "#272525"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4673 20.6779C31.2051 20.764 30.9659 20.9089 30.7679 21.1014C30.4544 21.4191 30.1784 21.7718 29.9453 22.1525L30.0148 22.6851L30.2011 22.8037L30.2453 22.4133L30.3321 22.3548L30.4206 22.0308C30.8058 21.422 31.3524 20.9323 31.9994 20.6162L31.4673 20.6779Z",
    fill: "#272525"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8255 20.6889L28.1771 22.0308L28.3129 22.2647L28.4961 22.211C28.5013 22.1624 28.518 22.1158 28.545 22.0751C28.5876 22.0039 29.9865 20.6826 29.9865 20.6826L29.8255 20.6889Z",
    fill: "#272525"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1351 20.7257C32.1351 20.7257 30.9431 21.4544 30.7836 21.8321L30.6257 22.2099L30.4931 22.3426L30.422 22.6034L30.4047 22.8816L30.5247 23.0254L30.7268 22.7646C30.7268 22.7646 30.6968 22.5007 30.7994 22.4722C30.8904 22.4406 30.9786 22.4015 31.063 22.3553C31.0573 22.1882 31.0957 22.0226 31.1745 21.8752C31.2532 21.7279 31.3695 21.6039 31.5115 21.516C32.0214 21.1651 32.6467 20.7131 32.6467 20.7131L32.6719 20.623L32.3846 20.6104L32.1351 20.7257Z",
    fill: "#272525"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M32.311 22.1629L32.1247 22.106L32.3268 21.7251C32.3268 21.7251 32.0631 21.7552 32.1358 21.7109C32.2084 21.6667 32.7673 20.6551 33.0594 20.584L33.4178 20.6488C33.1422 20.815 32.9024 21.0345 32.7124 21.2945C32.5224 21.5545 32.3859 21.8497 32.311 22.1629Z",
    fill: "#272525"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7172 24.7772L34.5893 24.9353L34.6983 25.0412L34.9319 25.0934L34.9682 25.2182L34.6083 25.2356L34.7362 25.3684L34.6083 25.479H34.8609L34.9682 25.6371H34.6635L34.8609 25.7951H34.5372C34.5372 25.7951 34.3572 26.0101 34.3572 26.0638C34.3793 26.1586 34.4099 26.2512 34.4488 26.3404L35.6314 25.9421C35.6314 25.9421 35.3267 25.7619 35.363 25.6181C35.4214 25.2482 35.4989 24.8815 35.5951 24.5196C35.6952 24.2081 35.779 23.8916 35.8461 23.5713L35.5303 24.4532C35.5303 24.4532 34.8846 24.5196 34.6698 24.5591C34.5536 24.5741 34.4395 24.6032 34.3304 24.6461L35.404 24.5734L34.7172 24.7772Z",
    fill: "#272525"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6771 24.9236C30.7029 25.0941 30.7125 25.2666 30.7055 25.4389C30.6601 25.8978 30.5804 26.3527 30.4671 26.7997C30.3992 27.0115 30.1939 27.4762 30.2208 27.4477C30.2476 27.4193 31.0102 27.2739 31.0102 27.2739C30.9908 27.0742 30.9882 26.8733 31.0023 26.6733C31.075 26.2933 31.1277 25.9097 31.1602 25.5242C31.1602 25.3409 31.1507 25.0311 31.1507 25.0311C31.1507 25.0311 31.0686 25.1212 31.0576 24.9884C31.0553 24.9259 31.042 24.8644 31.0181 24.8066L30.6771 24.9236Z",
    fill: "#272525"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3243 25.1039C25.4941 25.1282 25.667 25.118 25.8327 25.0738C25.9409 25.032 26.0463 24.9834 26.1485 24.9284L26.1043 24.7546L26.1769 24.6819L26.2764 24.8399C26.2764 24.8399 26.3648 24.7799 26.5685 24.6487C26.7557 24.5086 26.9306 24.3526 27.0911 24.1824C27.0911 24.1824 27.7668 22.9954 27.7605 22.7599C27.7605 22.7599 27.8063 22.556 27.691 22.5845C27.5633 22.6255 27.4383 22.6746 27.3168 22.7315L27.8252 22.4375V22.7536C27.9962 22.663 28.1775 22.5934 28.3652 22.5466C28.6545 22.4925 28.9525 22.5071 29.2352 22.5892C29.5755 22.7975 29.8532 23.094 30.0388 23.4475C30.0388 23.4475 29.6362 22.7489 29.1404 22.6904C28.6988 22.6703 28.2607 22.7766 27.8773 22.997C27.7133 23.2022 27.5759 23.4274 27.4684 23.6672C27.4274 23.8126 26.8005 24.7135 26.5211 24.9047C26.2416 25.096 25.869 25.3789 25.5327 25.4437C25.396 25.481 25.2532 25.4907 25.1127 25.4721L25.3243 25.1039Z",
    fill: "#272525"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9163 24.439L26.2431 24.3047V24.1783L26.4579 24.1198L26.4279 23.8874L26.6994 23.821L26.6426 23.6709L26.3789 23.8084L25.7474 24.624L25.9589 24.6824C25.9589 24.6824 25.8832 24.7314 25.8721 24.7615C25.8611 24.7915 26.0774 24.9195 26.0774 24.9195L26.0016 24.6777L25.8579 24.5196L25.9163 24.439Z",
    fill: "#E4E4E5"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5286 23.124L28.6012 23.3263L28.7607 23.2994L28.5854 23.0513L28.5286 23.124Z",
    fill: "#909294"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3272 23.1143L28.3856 23.2139L28.5309 23.127L28.4472 22.9326L28.2704 22.9784L28.1378 22.833L28.0541 22.9531L28.1251 23.1143H28.3272Z",
    fill: "#909294"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5646 23.3571L29.552 23.5467L29.4178 23.5309L29.3483 23.5167L29.2457 23.3713L29.1573 23.5009L29.2141 23.2686L29.4052 23.3255L29.5646 23.3571Z",
    fill: "#909294"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M29.286 23.6182L29.2734 23.7794L29.1408 23.8237L29.0823 24.0702L29.4771 24.1303L29.7944 24.2583L29.9855 24.0402L29.8765 23.909V23.6466L29.5086 23.5312L29.4202 23.664L29.286 23.6182Z",
    fill: "#909294"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5638 23.3575L29.2732 23.2832L29.068 23.5013L29.4611 23.6467L29.5638 23.3575Z",
    fill: "#909294"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5861 25.9487C29.5028 26.2477 29.4499 26.5543 29.4282 26.8639C29.4246 27.0894 29.4014 27.3141 29.3588 27.5356L29.4282 27.4613L29.5624 27.4913C29.5624 27.4913 29.703 26.151 29.7914 25.9914L29.5861 25.9487Z",
    fill: "#909294"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0258 26.0996L29.868 26.0127C29.868 26.0127 29.6074 26.8282 29.6532 27.2234L29.8253 27.4241L30.0258 26.0996Z",
    fill: "#909294"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2452 26.1217C30.2894 26.1391 30.1016 26.0933 30.1016 26.0933L29.9437 27.3308L30.2452 26.1217Z",
    fill: "#909294"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2498 23.7234L35.0177 23.6649L34.8772 23.8956L35.0619 24.0126L34.8093 23.9351L35.0225 24.09L34.983 24.1485L34.7414 24.0221L34.9656 24.2165L34.9167 24.324L34.6625 24.1659L34.844 24.3477L35.3224 24.3635L35.6824 23.6538L35.2498 23.7234Z",
    fill: "#272525"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9639 23.5455L32.6475 23.3575L32.7328 23.182L32.6175 22.9386L32.3996 23.073L32.2244 22.9386L32.0223 22.9718L31.9339 23.1757L31.1776 23.4665C31.1776 23.4665 31.1618 22.9386 31.5407 22.7521C31.7333 22.6437 31.9514 22.5892 32.1723 22.5941L32.567 22.711L32.8149 23.0888L32.8575 23.672C32.8575 23.672 32.8149 24.1082 32.6807 24.2552C32.5465 24.4022 31.8912 24.6456 31.8912 24.6456L31.3844 24.3405L32.3996 24.1224L32.4407 24.0071L32.6333 23.9928L32.6901 23.6878L32.0949 23.7889L31.9639 23.5455Z",
    fill: "#D1D1D1"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5868 26.0904C32.5868 26.4681 32.3436 26.7669 32.0452 26.7669C31.7468 26.7669 31.5037 26.4681 31.5037 26.0904C31.5037 25.7126 31.7452 25.4092 32.0452 25.4092C32.3452 25.4092 32.5868 25.7126 32.5868 26.0904Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3623 25.6811C34.3623 26.0557 34.1192 26.3607 33.8176 26.3607C33.516 26.3607 33.2761 26.0557 33.2761 25.6811C33.2761 25.3065 33.5176 25.0015 33.8176 25.0015C34.1176 25.0015 34.3623 25.3097 34.3623 25.6811Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M33.202 21.6075C33.3496 21.4592 33.528 21.3454 33.7246 21.274C33.9709 21.2171 34.2772 21.1271 34.2772 21.1271C34.2772 21.1271 33.8683 20.8347 33.2604 21.244C32.9667 21.4479 32.9667 21.6391 32.9667 21.6391L33.202 21.6075Z",
    fill: "#D1D1D1"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0586 23.4429L33.6696 24.0403L34.178 24.0561L34.3091 23.9091L34.1638 24.1747C34.1638 24.1747 33.6996 24.2885 33.4091 24.0561C33.2271 23.8966 33.1038 23.6807 33.0586 23.4429Z",
    fill: "#D1D1D1"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M34.887 22.8465C34.846 22.8766 34.467 23.5451 34.467 23.5451C34.467 23.5451 34.246 23.8233 34.1512 23.8518C34.0565 23.8802 33.7328 23.9671 33.7328 23.9671L34.486 23.8518L34.8381 23.414L35.0102 22.7817L34.887 22.8465Z",
    fill: "#D1D1D1"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9011 22.7444L35.0195 22.6148L34.9753 21.7692L34.8159 21.7266L34.9011 22.7444Z",
    fill: "#D1D1D1"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7577 21.6399L34.3788 21.2748L34.172 21.1736L33.7236 21.2748L34.303 21.0566C34.303 21.0566 34.7262 21.3174 34.7767 21.5213C34.8272 21.7252 34.7577 21.6399 34.7577 21.6399Z",
    fill: "#D1D1D1"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3764 21.7163L33.1696 22.2379C33.1696 22.2379 33.1696 22.6472 33.1696 22.682C33.1696 22.7168 33.0401 22.7705 33.0401 22.7705L33.1064 23.0124L33.2312 23.0392L33.3069 23.3395L33.5185 23.4707L33.7332 23.5734L34.1201 23.4644L34.3143 23.6224L33.9274 23.8785L33.5754 23.7204L33.4427 23.7837L33.0401 23.3933L32.8286 22.81L32.8538 22.2268L33.3764 21.7163Z",
    fill: "#EDEDED"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2775 21.8374L33.1733 22.1377L32.7628 22.2578L33.2775 21.8374Z",
    fill: "#D1D1D1"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4244 23.6558C31.4513 23.6447 31.5539 23.6179 31.5539 23.6179L31.7513 23.0283L31.4244 23.6558Z",
    fill: "#EDEDED"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1518 22.9038L32.3555 23.1678L32.4881 23.3448L32.3555 23.4586L32.5607 23.4649L32.6618 23.2832L32.4376 22.877L32.1518 22.9038Z",
    fill: "#EDEDED"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4673 23.6466L32.0947 24.2109L31.9857 24.4653L32.472 24.056L32.6394 23.9042L32.4578 23.6182L32.4673 23.6466Z",
    fill: "#EDEDED"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5281 23.7855L31.7365 23.4868C31.7412 23.5674 31.7412 23.6481 31.7365 23.7286C31.7365 23.7492 31.5912 23.9768 31.5912 23.9768L31.5281 23.7855Z",
    fill: "#EDEDED"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2935 23.6045C31.2935 23.6045 31.2224 23.742 31.2129 23.7625C31.2035 23.7831 31.3582 24.2857 31.3582 24.2857L31.164 23.8384L31.2935 23.6045Z",
    fill: "#EDEDED"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3911 21.4415L34.6042 21.7829C34.6042 21.7829 34.6342 22.2444 34.6342 22.2649C34.6342 22.2855 34.7068 21.7165 34.7068 21.7165L34.4005 21.4004L34.3911 21.4415Z",
    fill: "#EDEDED"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M33.911 21.3628L33.4547 21.5461L33.5431 21.7184L34.1905 21.3691L34.4715 21.4039L34.0878 21.2964L33.911 21.3628Z",
    fill: "#EDEDED"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7786 22.6509L34.5087 23.3447L34.1534 23.6687L33.6797 23.8442L34.3902 23.3858L34.7786 22.6509Z",
    fill: "#EDEDED"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9609 22.7661L34.8725 23.3256L34.5978 23.7223L34.2394 24.0116L34.8362 23.5532L34.9609 22.7661Z",
    fill: "#EDEDED"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4015 21.9312L34.4157 22.3326L34.4062 22.6882L34.3541 22.9727L34.4583 23.0439L34.4362 23.1387L34.3194 23.2051L34.3131 23.3584L34.2562 23.4817L34.5546 23.096L34.6478 22.6313L34.662 22.2283L34.4015 21.9312Z",
    fill: "#EDEDED"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8151 22.5845L32.9098 22.8563L33.085 23.3653L33.3298 23.7288L32.9098 22.9638L32.8151 22.5845Z",
    fill: "#D1D1D1"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4179 21.8052L33.2174 22.2351C33.2174 22.2351 33.2174 22.744 33.2174 22.7646C33.2327 22.8724 33.2592 22.9783 33.2963 23.0807C33.2712 22.9936 33.2396 22.9085 33.2016 22.8262L33.181 22.6223L33.1716 22.3394L33.211 22.1276L33.4179 21.8052Z",
    fill: "#D1D1D1"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M34.603 22.7236C34.603 22.7236 34.5225 23.1377 34.5146 23.1614C34.5067 23.1851 34.4151 23.4586 34.3993 23.4775C34.3835 23.4965 34.2604 23.6593 34.232 23.6862C34.2035 23.7131 34.0472 23.8442 34.0472 23.8442L34.2383 23.751L34.3472 23.6198L34.472 23.4444L34.5588 23.2326L34.603 22.7236Z",
    fill: "#D1D1D1"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1374 21.4194L34.2763 21.5079C34.333 21.5644 34.3857 21.6246 34.4342 21.6881C34.4699 21.7581 34.4995 21.8311 34.5226 21.9062C34.5226 21.9442 34.5747 22.3377 34.5747 22.3377L34.6047 22.1101L34.5747 21.8051L34.4579 21.6012L34.1374 21.4194Z",
    fill: "#D1D1D1"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8354 23.04L28.9633 23.0211L28.9712 22.931C28.9712 22.931 29.1085 22.8962 29.1164 22.931C29.1243 22.9658 29.1875 23.0748 29.1875 23.0748L28.8717 23.1127L28.8354 23.04Z",
    fill: "url(#paint194_linear_49_3501)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8456 22.9646L28.4951 23.0515L28.4462 22.933L28.2362 22.9852L28.1367 22.8318L28.6988 22.6943L28.7209 22.7797L28.9419 22.7892L28.9135 22.8777L28.8456 22.9646Z",
    fill: "url(#paint195_linear_49_3501)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1573 23.1285L29.3025 23.2834L29.5615 23.3229V23.217L29.6688 23.2549L29.6752 23.1775L29.4352 23.1079L29.1573 23.1285Z",
    fill: "url(#paint196_linear_49_3501)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5231 23.3628C29.5231 23.3897 29.5483 23.5461 29.5483 23.5461C29.6048 23.5813 29.6646 23.6109 29.7267 23.6346C29.7711 23.6474 29.8136 23.666 29.8531 23.69L29.9509 23.5319L29.7346 23.3849L29.6589 23.456L29.5625 23.3628H29.5231Z",
    fill: "url(#paint197_linear_49_3501)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9203 23.7002C29.9124 23.7302 29.8113 23.9088 29.8113 23.9088L30.0576 24.0795L29.9519 24.2629C29.9519 24.2629 29.9992 24.3213 30.0261 24.3213C30.0529 24.3213 30.1334 24.304 30.1334 24.2724C30.1334 24.2407 30.2408 23.9562 30.2408 23.9562C30.2408 23.9562 30.1445 23.7618 30.1145 23.7618C30.0485 23.7455 29.9836 23.7249 29.9203 23.7002Z",
    fill: "url(#paint198_linear_49_3501)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7854 24.1387L29.6607 24.2461C29.6607 24.2461 29.6528 24.371 29.6796 24.371C29.7065 24.371 29.7854 24.439 29.7854 24.439V24.1387Z",
    fill: "url(#paint199_linear_49_3501)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2701 25.0464C29.2701 25.0464 29.1532 25.1191 29.1532 25.1602C29.1532 25.2013 29.1675 25.3072 29.1675 25.3072L29.3127 25.3657L29.3238 25.5395L29.2827 25.7577L29.0948 25.715L28.9369 25.5964L28.7901 25.6423L28.7191 25.5111L28.9227 25.3088L28.8501 25.1776L29.098 24.8726L29.2701 25.0464Z",
    fill: "url(#paint200_linear_49_3501)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8116 25.5405L29.6537 25.8913L29.8685 26.0067L30.1306 26.0225L30.2474 26.1221L30.1464 26.6042L30.0737 26.7796C30.115 26.88 30.1206 26.9916 30.0895 27.0957C30.2172 26.6234 30.309 26.142 30.3642 25.6558L30.4053 25.041L30.2316 25.0078H30.1574L30.0279 25.0536C30.0489 25.1726 30.0595 25.2932 30.0595 25.414C30.0453 25.464 30.0206 25.5104 29.9869 25.5499L29.8116 25.5405Z",
    fill: "url(#paint201_linear_49_3501)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M30.783 25.2488L30.9172 25.4384L30.8856 25.2188C31.0308 25.2188 31.0719 25.4084 31.0719 25.4084L31.1461 25.233L31.2061 25.5807L31.1887 26.1386C31.1887 26.1386 30.9787 26.3409 30.9787 26.4152V26.7866L30.7498 26.7203L30.5319 26.3868C30.5319 26.3868 30.6519 25.9758 30.783 25.2488Z",
    fill: "url(#paint202_linear_49_3501)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9691 26.1816L29.9533 26.6321L29.7954 26.7333C29.7639 26.8323 29.7495 26.936 29.7528 27.0399C29.7796 27.0984 29.8554 27.3022 29.8554 27.3022L29.9138 27.0114L30.0891 26.8976L30.1759 26.2243L29.9691 26.1816Z",
    fill: "url(#paint203_linear_49_3501)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6628 26.314C29.6517 26.3709 29.6217 27.1706 29.6217 27.2876C29.6214 27.3567 29.6315 27.4254 29.6517 27.4915L29.8806 27.4045L29.767 27.3018L29.6896 27.1121L29.6628 26.314Z",
    fill: "url(#paint204_linear_49_3501)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6748 22.249L32.1247 22.1052L32.1358 21.7101L32.0947 21.7686L32.5605 21.1016L32.0221 21.5204L31.4379 21.9582L31.8469 21.8839L31.6748 22.249Z",
    fill: "url(#paint205_linear_49_3501)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M35.505 22.9497L35.7181 22.9639V23.2263L35.4008 23.3116L35.505 22.9497Z",
    fill: "#CECFD1"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8615 22.7994L31.2704 22.6413L31.1614 22.7994L31.0036 22.9148L30.9436 23.0317L31.0241 23.1787L31.1393 23.1582L31.1472 23.0317L31.2056 22.8737L31.2656 22.8563L31.6383 22.3063L31.8467 21.8779L31.4377 21.9522C31.3621 22.0947 31.2997 22.2439 31.2514 22.3979C31.2514 22.3979 31.0478 22.5386 31.0399 22.5749C30.9856 22.6538 30.926 22.7288 30.8615 22.7994Z",
    fill: "#272525"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8045 22.371C31.7125 22.4976 31.6123 22.618 31.5045 22.7314C31.5623 22.5638 31.6331 22.4011 31.7161 22.2446L32.125 22.1055L32.3113 22.1624L31.8045 22.371Z",
    fill: "#272525"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9971 24.1094C33.1603 24.2485 33.3317 24.3778 33.5103 24.4966C33.5687 24.5061 33.4629 24.5551 33.4629 24.5551L33.2608 24.3702L33.0145 24.2026L32.9971 24.318L32.9103 24.1821L32.9971 24.1094Z",
    fill: "#272525"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9956 23.6787C33.0974 23.8302 33.2143 23.9711 33.3445 24.0991C33.4234 24.1386 33.6145 24.2572 33.6145 24.2572L33.9666 24.2193C33.8035 24.2055 33.6436 24.166 33.4929 24.1023C33.3445 24.0122 32.9877 23.7293 32.9956 23.6787Z",
    fill: "#272525"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5519 24.0307C38.5519 24.0307 38.4066 23.7873 38.3087 23.7494C38.284 23.7424 38.261 23.7302 38.2414 23.7136C38.2217 23.697 38.2059 23.6763 38.195 23.6529L37.8619 23.6893C37.7082 23.6841 37.5557 23.6613 37.4072 23.6213C37.3804 23.6213 38.2993 23.5534 38.6908 23.7415L38.8487 23.8284L38.5519 24.0307Z",
    fill: "#272525"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3597 23.6341C36.3597 23.6341 36.4891 23.6152 36.4891 23.6436C36.4891 23.6721 36.2823 24.4481 36.2823 24.4481L36.3597 23.6341Z",
    fill: "#272525"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M36.079 24.4385C36.079 24.4717 36.0001 25.1671 36.0001 25.1671L35.8154 25.205C35.8154 25.205 35.828 25.5211 35.8943 25.5211C35.9606 25.5211 36.2243 25.4722 36.2243 25.4722C36.2243 25.4722 35.9812 25.5117 36.079 25.1118C36.1325 24.8881 36.2 24.6679 36.2811 24.4527L36.079 24.4385Z",
    fill: "#272525"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5082 22.0318L36.6629 22.4174L36.655 22.0049L36.5082 22.0318Z",
    fill: "#272525"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2422 21.9472C39.2422 21.9472 39.2722 22.0231 39.3006 22.0231C39.329 22.0231 40.1737 22.0231 40.33 22.11C40.4863 22.197 40.4421 22.2681 40.4879 22.3013C40.5315 22.3266 40.5812 22.3397 40.6316 22.3392L40.8321 22.1622C40.7141 22.0859 40.5881 22.0228 40.4563 21.9741C40.3221 21.9346 39.2422 21.9472 39.2422 21.9472Z",
    fill: "#272525"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9503 20.6344L36.3923 21.2934L36.4618 21.2128L36.225 20.7007L40.2795 20.4731L35.9503 20.6344Z",
    fill: "#272525"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0722 20.5778L40.5991 20.4814L42.1164 20.4292L42.3532 20.7295C42.3532 20.7295 42.2522 20.9049 42.2238 20.9049C42.1623 20.8013 42.1116 20.6917 42.0722 20.5778Z",
    fill: "#272525"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6173 22.4111L36.4215 22.5139C36.4082 22.7787 36.3797 23.0426 36.3362 23.3041L36.5147 23.2836C36.5147 23.2836 36.6899 22.6229 36.6173 22.4111Z",
    fill: "#272525"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5635 25.0655L33.9487 24.8648L34.1208 24.8822L33.9392 24.7573L33.7482 24.8158L33.5635 25.0655Z",
    fill: "#272525"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2441 25.7961L29.5125 26.0964L29.7052 26.0585L29.852 26.049L29.6515 25.8909L29.7936 25.48L29.601 25.7123L29.3531 25.8072L29.2441 25.7961Z",
    fill: "#272525"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0144 25.7121L28.9386 25.5968L28.7934 25.6426L28.7208 25.5114L28.7665 25.3154L28.7081 25.5762L28.7539 25.7311L29.0144 25.7121Z",
    fill: "#272525"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3727 23.8074L26.6348 23.6714L26.9601 23.6461L27.0043 23.1372L26.3727 23.8074Z",
    fill: "#272525"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7574 24.6355C26.7574 24.6355 26.4511 25.4669 26.5664 26.1386C26.5664 26.1386 26.6074 24.694 27.089 24.1851L26.7574 24.6355Z",
    fill: "#272525"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M26.639 26.6445C26.639 26.6445 26.8443 27.8995 27.2074 27.988C26.9196 27.5886 26.7253 27.1294 26.639 26.6445Z",
    fill: "#272525"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M42.239 20.5757C42.239 20.5757 25.5567 27.3309 23.3842 27.9157C23.3842 27.9157 41.1117 20.8475 42.239 20.5757Z",
    fill: "url(#paint206_linear_49_3501)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92262 27.1271C1.92262 27.1271 1.66369 25.2304 2.1563 22.5562C2.1563 22.5562 0.177973 26.0792 1.92262 27.1271Z",
    fill: "url(#paint207_linear_49_3501)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15709 22.5564C2.15709 22.5564 3.2623 21.0106 3.78964 20.8652L1.92342 27.1273C1.92342 27.1273 1.80658 23.6897 2.15709 22.5564Z",
    fill: "url(#paint208_linear_49_3501)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5094 32.1472L4.30357 32.0713L11.4874 32.8299L11.549 36.7481L10.9743 36.8682L3.5094 35.8567V32.1472Z",
    fill: "url(#paint209_linear_49_3501)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54224 32.1472L10.9156 32.9058L11.495 32.8299L4.32062 32.0713L3.54224 32.1472Z",
    fill: "url(#paint210_linear_49_3501)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9941 36.8679L11.5546 36.7478L11.4961 32.8296L10.9167 32.9055L10.9941 36.8679Z",
    fill: "url(#paint211_linear_49_3501)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7395 36.4771L10.6827 33.1374L3.81616 32.4404L3.873 35.5841L10.7395 36.4771Z",
    fill: "url(#paint212_linear_49_3501)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64001 32.4399H3.81685L3.88948 35.5836L10.7734 36.4782V36.5557L3.71738 35.6231L3.64001 32.4399Z",
    fill: "url(#paint213_linear_49_3501)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1005 7.73096C69.1005 7.73096 71.7972 12.1565 72.0687 13.737L67.0764 13.8824L67.3669 11.9968L67.4521 11.6128C67.4521 11.6128 69.0073 7.83843 69.1005 7.73096Z",
    fill: "url(#paint214_linear_49_3501)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6963 11.0607C68.7358 10.9516 69.9752 10.9817 69.9752 10.9817C69.9752 10.9817 70.6715 11.2978 70.943 11.2978C70.943 11.2978 70.6715 9.90216 71.1009 9.40113C71.5304 8.9001 72.1082 7.88697 72.7319 7.80794C73.3555 7.72891 77.6548 7.77159 78.2358 8.70095C78.8168 9.63031 79.2447 11.538 78.2769 12.1592C77.309 12.7803 73.7345 12.8957 72.0324 13.0917L71.1372 13.1707L71.0614 13.3288C71.0614 13.3288 69.391 13.7571 69.1668 13.6449C68.9426 13.5327 67.8027 13.5469 68.6963 11.0607Z",
    fill: "url(#paint215_linear_49_3501)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3444 12.349C77.3444 12.349 75.4498 12.251 74.9998 12.1151C74.5498 11.9791 72.1278 11.8242 70.7684 11.9807C70.3982 12.0087 70.0471 12.1561 69.7678 12.401C69.4885 12.6458 69.2961 12.9747 69.2195 13.3384L69.2953 13.3194C70.3816 13.5534 71.0621 13.2404 71.0621 13.2404L71.0226 13.144C71.0226 13.144 71.7015 12.9686 73.3688 12.8279C75.0361 12.6872 77.3444 12.349 77.3444 12.349Z",
    fill: "url(#paint216_linear_49_3501)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2926 11.2164C71.2926 11.2164 71.2531 9.41298 71.411 9.16168C71.5689 8.91037 72.2825 7.95731 72.6331 7.91937C72.8128 7.89703 72.9935 7.88384 73.1746 7.87986C73.1746 7.87986 72.1657 7.43257 71.1016 9.31657C71.1016 9.31657 70.7858 10.4229 70.8647 11.1437L71.2926 11.2164Z",
    fill: "url(#paint217_linear_49_3501)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0085 9.48858C78.1363 10.0846 78.2317 10.6872 78.2943 11.2936C78.2943 11.2936 77.8885 12.2261 77.347 12.343C77.347 12.343 78.7253 12.4205 78.839 10.9822C78.839 10.9822 78.9669 8.44543 77.1022 8.13722C77.1007 8.13406 77.9469 8.63351 78.0085 9.48858Z",
    fill: "url(#paint218_linear_49_3501)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M67.419 12.2891L68.0979 12.5783C68.0979 12.5783 68.6979 13.5108 69.4541 13.4903C70.2104 13.4697 71.3946 13.3559 71.3946 13.3559L71.4909 13.141L72.0687 13.7289L67.0764 13.8743C67.155 13.3388 67.2694 12.8092 67.419 12.2891Z",
    fill: "url(#paint219_linear_49_3501)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M71.331 11.2423C71.331 11.2423 68.7748 11.4003 68.6169 11.2012C68.8638 10.9842 69.1821 10.8665 69.5106 10.8709C70.1106 10.8535 70.3805 11.1459 70.3805 11.1459C70.3805 11.1459 71.1573 11.2755 71.331 11.2423Z",
    fill: "url(#paint220_linear_49_3501)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3148 11.7401C69.5916 11.5654 69.903 11.4527 70.2274 11.4098C70.6552 11.3865 71.079 11.3143 71.4905 11.1948C71.4905 11.1948 71.4116 11.3134 70.2858 11.5267C69.9521 11.54 69.6234 11.6122 69.3148 11.7401Z",
    fill: "url(#paint221_linear_49_3501)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1388 11.6249L78.7214 11.4858C78.6539 11.7515 78.4966 11.9855 78.2762 12.1481C77.9241 12.3804 78.5477 11.9742 78.2935 11.9742C78.0393 11.9742 77.8199 12.1481 77.6146 12.2666C77.8641 12.1268 78.0514 11.8975 78.1388 11.6249Z",
    fill: "url(#paint222_linear_49_3501)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6734 8.4788C77.6734 8.4788 76.5903 8.24489 75.4046 8.10896C75.4046 8.10896 74.0089 7.81656 73.2305 7.83711C73.0651 7.81372 72.8985 7.8 72.7316 7.79602C72.5137 7.79602 75.8467 7.56525 77.6734 8.4788Z",
    fill: "url(#paint223_linear_49_3501)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3487 10.0295C71.3487 10.0295 72.1081 9.77976 74.5696 9.81612C77.031 9.85247 77.9247 10.0121 77.9247 10.0121C77.9247 10.0121 73.2528 11.041 73.117 11.079C72.9812 11.1169 70.9429 11.4298 71.3487 10.0295Z",
    fill: "url(#paint224_linear_49_3501)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6963 11.061C68.6963 11.061 68.3268 11.1401 68.4595 11.6616C68.5164 11.9081 68.5957 12.1488 68.6963 12.3808C68.6963 12.3808 68.4042 11.4103 68.6363 11.3724C68.8684 11.3345 70.8467 11.3724 71.2162 11.2365C71.2162 11.2365 68.8479 11.2934 68.7326 11.1954L68.6963 11.061Z",
    fill: "url(#paint225_linear_49_3501)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0608 13.2345C70.8768 13.085 70.672 12.963 70.4529 12.8725C70.1624 12.7698 69.2482 13.2803 69.2482 13.2803C69.2482 13.2803 69.8166 13.6439 71.0608 13.2345Z",
    fill: "url(#paint226_linear_49_3501)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3307 11.0659C71.3307 11.0659 72.0112 11.1244 74.7474 10.9252L78.2351 10.6328L78.4893 10.6613L78.5083 10.7008L78.1388 10.6834L74.899 10.9473L73.3754 11.0501C73.3754 11.0501 71.6639 11.1323 71.3307 11.0659Z",
    fill: "#231F20"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3082 9.46435C78.3082 9.46435 76.4356 9.41536 75.1378 10.0175C75.1378 10.0175 74.8647 10.0855 74.7289 10.8805C74.7289 10.8805 74.7415 10.2989 75.0715 9.99541C75.4015 9.69195 77.8503 9.33949 78.3066 9.43907L78.3082 9.46435Z",
    fill: "#231F20"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5931 8.02783C76.5931 8.02783 77.6526 8.14163 77.9873 8.79281C77.9873 8.79281 78.2525 8.97932 78.4609 10.5693C78.4609 10.5693 78.7167 11.9286 77.4442 12.4043C77.4442 12.4043 78.9267 12.2194 78.3915 9.87548C78.3915 9.87548 78.2336 8.67111 77.6747 8.37871C77.336 8.20279 76.9705 8.08423 76.5931 8.02783Z",
    fill: "#231F20"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3778 11.061C73.3447 11.4229 73.3484 11.7873 73.3888 12.1484C73.3888 12.1484 73.6793 12.896 74.2335 12.885C74.2335 12.885 73.643 12.934 73.362 12.1484C73.362 12.1484 73.2609 11.3882 73.3778 11.061Z",
    fill: "#231F20"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5715 14.0194C68.5715 14.0194 70.7945 15.3518 71.584 15.5794C72.3734 15.807 73.3412 15.9429 73.4786 15.8876C73.616 15.8323 73.5307 13.8013 72.3323 13.8329C71.134 13.8645 68.5715 14.0194 68.5715 14.0194Z",
    fill: "url(#paint227_linear_49_3501)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7652 17.2266C83.6401 17.2703 83.5362 17.3598 83.4744 17.4771C83.4126 17.5944 83.3975 17.7308 83.432 17.8588C83.5062 18.3661 83.3862 19.3445 83.9262 19.8977C83.9262 19.8977 84.0257 20.1016 84.7156 20.0842C85.4056 20.0668 85.4703 19.9546 85.513 19.3445C85.5556 18.7344 85.5272 17.8145 84.9035 17.3198C84.9004 17.3135 84.7393 17.1523 83.7652 17.2266Z",
    fill: "url(#paint228_linear_49_3501)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7751 17.4712C83.6654 17.506 83.573 17.5811 83.5164 17.6814C83.4599 17.7817 83.4434 17.8997 83.4703 18.0117C83.5382 18.4511 83.4309 19.2919 83.9188 19.7708C83.9188 19.7708 84.0087 19.9479 84.6261 19.9289C85.2434 19.9099 85.3097 19.8151 85.3492 19.2856C85.3887 18.7561 85.365 17.9659 84.7998 17.547C84.7998 17.547 84.6577 17.4064 83.7751 17.4712Z",
    fill: "url(#paint229_linear_49_3501)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3375 17.8174C83.3375 17.8174 82.7154 18.1335 82.736 18.2141C82.7565 18.2947 82.8449 18.8969 82.9428 18.9538C83.1477 19.0733 83.3647 19.1708 83.5901 19.2446C83.5901 19.2446 84.2991 18.8969 84.9006 18.9649L85.3743 19.0407C85.3743 19.0407 85.3364 19.2746 85.3932 19.3126C85.3932 19.3126 86.2284 19.0992 86.2853 18.9238C86.3421 18.7483 86.2458 18.2742 86.1495 18.1856C86.0532 18.0971 85.6079 17.9328 84.6259 17.9249C83.6438 17.917 83.3265 17.8932 83.3375 17.8174Z",
    fill: "url(#paint230_linear_49_3501)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9411 18.9531C83.6115 18.8062 84.2996 18.7567 84.9842 18.8061C86.1573 18.8836 86.2788 18.9563 86.2788 18.9563C86.2788 18.9563 86.1888 19.0511 85.4405 19.3024C85.4405 19.3024 85.6078 19.0985 85.4894 19.0511C85.371 19.0037 84.0447 18.9405 83.5948 19.244C83.3717 19.159 83.1535 19.0619 82.9411 18.9531Z",
    fill: "#F0EFEF"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7355 18.2141C82.9067 18.0734 83.0889 17.9466 83.2802 17.8348C83.2981 17.8261 83.3173 17.8203 83.337 17.8174C83.4444 17.8174 83.2912 17.9249 83.9307 17.9154C84.5701 17.9059 85.8585 17.9328 86.1506 18.1856C86.1506 18.1856 85.8995 17.8932 83.2423 18.0023C83.0578 18.0276 82.8831 18.1006 82.7355 18.2141Z",
    fill: "#F0EFEF"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8072 18.1765C82.8072 18.1765 85.4155 17.8478 86.0628 18.2144C86.0628 18.2144 86.2081 18.7123 86.1197 18.7992C86.1197 18.7992 83.494 18.6728 82.9256 18.8972C82.9256 18.8972 82.7283 18.3425 82.8072 18.1765Z",
    fill: "url(#paint231_linear_49_3501)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0948 17.3669C96.0948 17.3669 95.809 17.4665 95.8595 17.9059C95.91 18.3453 95.8263 19.1846 96.2116 19.6635C96.2116 19.6635 96.2826 19.8389 96.7689 19.8215C97.2552 19.8041 97.3026 19.7093 97.3357 19.1798C97.3689 18.6503 97.3452 17.8664 96.9047 17.4412C96.9047 17.4444 96.7895 17.3037 96.0948 17.3669Z",
    fill: "url(#paint232_linear_49_3501)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1023 17.5771C96.1023 17.5771 95.8418 17.6624 95.8876 18.0512C95.9334 18.44 95.8592 19.1576 96.2034 19.5622C96.2034 19.5622 96.2681 19.7203 96.7039 19.7045C97.1396 19.6887 97.1949 19.6081 97.2217 19.156C97.2486 18.704 97.2296 18.018 96.8286 17.6513C96.8318 17.645 96.7307 17.5249 96.1023 17.5771Z",
    fill: "url(#paint233_linear_49_3501)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7945 17.8809C95.7945 17.8809 95.3524 18.148 95.365 18.2223C95.3776 18.2965 95.4408 18.8071 95.5134 18.8545C95.6556 18.9565 95.8099 19.0404 95.9729 19.1042C95.9729 19.1042 96.4781 18.8039 96.906 18.8608L97.2407 18.9272C97.2407 18.9272 97.2139 19.1311 97.2565 19.1643C97.2565 19.1643 97.8502 18.9793 97.888 18.8292C97.9176 18.6134 97.8835 18.3937 97.7902 18.197C97.7254 18.1195 97.4065 17.9773 96.7086 17.9694C96.0108 17.9615 95.7882 17.9457 95.7945 17.8809Z",
    fill: "url(#paint234_linear_49_3501)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5131 18.8556C95.9858 18.7297 96.4767 18.6869 96.964 18.7291C97.8008 18.7955 97.8845 18.8603 97.8845 18.8603C97.8845 18.8603 97.8198 18.9393 97.2861 19.1559C97.2861 19.1559 97.4061 18.9804 97.324 18.9393C97.2419 18.8983 96.2962 18.8477 95.9725 19.1053C95.8149 19.0306 95.6615 18.9472 95.5131 18.8556Z",
    fill: "#F0EFEF"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3647 18.2203C95.485 18.1007 95.6149 17.9913 95.7532 17.8931C95.7657 17.8856 95.7797 17.8807 95.7942 17.8789C95.87 17.8789 95.7579 17.969 96.2158 17.9595C96.6736 17.95 97.5894 17.9769 97.7946 18.1966C97.7946 18.1966 97.6178 17.9453 95.7326 18.0385C95.5944 18.0602 95.466 18.1236 95.3647 18.2203Z",
    fill: "#F0EFEF"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4136 18.188C95.4136 18.188 97.2703 17.9035 97.7314 18.2211C97.7314 18.2211 97.834 18.6463 97.7708 18.7238C97.7708 18.7238 95.903 18.6131 95.4988 18.8059C95.4988 18.8059 95.3615 18.3302 95.4136 18.188Z",
    fill: "url(#paint235_linear_49_3501)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_3501",
    x1: 47.4991,
    y1: 39.2687,
    x2: 66.0917,
    y2: 31.2381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#434244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_49_3501",
    x1: 37.8765,
    y1: 50.0056,
    x2: 69.7873,
    y2: 25.1085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#434244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_49_3501",
    x1: 93.5838,
    y1: 41.2025,
    x2: 108.689,
    y2: 11.3257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#434244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_49_3501",
    x1: 93.5136,
    y1: 40.1138,
    x2: 110.42,
    y2: 20.3099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#434244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_49_3501",
    x1: 44.6535,
    y1: 17.5362,
    x2: 62.303,
    y2: 51.2654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_49_3501",
    x1: 51.6023,
    y1: 32.0225,
    x2: 49.853,
    y2: 28.4076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#353333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#464545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5F5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_49_3501",
    x1: 49.8193,
    y1: 26.606,
    x2: 54.6026,
    y2: 38.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4F4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B4B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_49_3501",
    x1: 49.6077,
    y1: 35.2474,
    x2: 44.5385,
    y2: 33.6368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4C4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_49_3501",
    x1: 49.3196,
    y1: 32.3835,
    x2: 53.0678,
    y2: 39.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#777676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C3C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_49_3501",
    x1: 49.1372,
    y1: 35.3015,
    x2: 51.541,
    y2: 39.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#777676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C3C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_49_3501",
    x1: 47.1896,
    y1: 39.6234,
    x2: 48.7316,
    y2: 42.5935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#777676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C3C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_49_3501",
    x1: 51.9157,
    y1: 37.6178,
    x2: 52.3712,
    y2: 38.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#777676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C3C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_49_3501",
    x1: 50.0131,
    y1: 38.581,
    x2: 51.6136,
    y2: 41.6617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6A6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_49_3501",
    x1: 49.8738,
    y1: 43.2427,
    x2: 52.4991,
    y2: 48.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#777676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C3C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_49_3501",
    x1: 50.494,
    y1: 46.8834,
    x2: 54.2331,
    y2: 38.3087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2F2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#454343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#686767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9A9999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_49_3501",
    x1: 51.8442,
    y1: 39.1375,
    x2: 53.198,
    y2: 41.7426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#777676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C3C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_49_3501",
    x1: 54.5516,
    y1: 39.847,
    x2: 55.3411,
    y2: 49.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_49_3501",
    x1: 56.6658,
    y1: 37.9334,
    x2: 60.7113,
    y2: 45.7219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#363434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#737171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A5A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_49_3501",
    x1: 56.0102,
    y1: 41.3227,
    x2: 63.4712,
    y2: 46.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#363434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#737171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A5A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_49_3501",
    x1: 55.5533,
    y1: 50.9834,
    x2: 59.9832,
    y2: 42.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#363434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#737171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_49_3501",
    x1: 57.0263,
    y1: 35.8147,
    x2: 59.4512,
    y2: 42.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#363434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5E5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9F9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_49_3501",
    x1: 58.2224,
    y1: 35.0386,
    x2: 60.8845,
    y2: 41.8804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#363434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5E5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9F9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_49_3501",
    x1: 60.0584,
    y1: 37.1549,
    x2: 62.2255,
    y2: 42.7216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#363434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5E5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9F9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_49_3501",
    x1: 59.5981,
    y1: 37.7827,
    x2: 60.563,
    y2: 40.2618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#363434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5E5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9F9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_49_3501",
    x1: 59.4885,
    y1: 29.1832,
    x2: 63.4486,
    y2: 36.7506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_49_3501",
    x1: 61.2016,
    y1: 29.5764,
    x2: 57.3179,
    y2: 42.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2E2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#434141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#656363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_49_3501",
    x1: 56.0964,
    y1: 29.2897,
    x2: 60.8662,
    y2: 38.4053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_49_3501",
    x1: 54.1393,
    y1: 27.6705,
    x2: 61.4284,
    y2: 41.6014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_49_3501",
    x1: 53.9085,
    y1: 32.7271,
    x2: 55.6086,
    y2: 35.9784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_49_3501",
    x1: 52.6564,
    y1: 33.5787,
    x2: 53.8601,
    y2: 36.6709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4F4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B4B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_49_3501",
    x1: 51.4776,
    y1: 35.4789,
    x2: 54.7012,
    y2: 38.0787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2B2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#373535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4B4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#676666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_49_3501",
    x1: 54.0872,
    y1: 37.848,
    x2: 53.0164,
    y2: 40.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2B2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#373535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4B4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#676666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_49_3501",
    x1: 55.2304,
    y1: 37.5537,
    x2: 56.6757,
    y2: 39.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2B2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#373535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4B4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#676666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_49_3501",
    x1: 55.7863,
    y1: 37.4003,
    x2: 57.1369,
    y2: 35.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2B2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#373535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4B4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#676666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_49_3501",
    x1: 54.0773,
    y1: 36.4463,
    x2: 55.2637,
    y2: 33.2702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2B2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#373535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4B4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#676666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_49_3501",
    x1: 55.5962,
    y1: 34.7372,
    x2: 56.203,
    y2: 35.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2B2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#373535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4B4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#676666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_49_3501",
    x1: 59.0598,
    y1: 32.3104,
    x2: 60.6935,
    y2: 35.4338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_49_3501",
    x1: 58.8771,
    y1: 31.2505,
    x2: 62.5572,
    y2: 38.2823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4C4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_49_3501",
    x1: 54.5311,
    y1: 43.4856,
    x2: 55.3348,
    y2: 47.6152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_49_3501",
    x1: 54.4474,
    y1: 44.1722,
    x2: 55.5484,
    y2: 47.8431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3A3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#757474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A6A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_49_3501",
    x1: 49.6644,
    y1: 42.4466,
    x2: 50.0931,
    y2: 46.0596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_49_3501",
    x1: 50.2297,
    y1: 41.3123,
    x2: 51.2913,
    y2: 50.2468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_49_3501",
    x1: 50.2765,
    y1: 38.5163,
    x2: 52.9769,
    y2: 34.9754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4C4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_49_3501",
    x1: 58.2143,
    y1: 30.8813,
    x2: 60.4177,
    y2: 28.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#3A3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#504F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9A9999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_49_3501",
    x1: 53.5939,
    y1: 28.4585,
    x2: 57.3341,
    y2: 35.6056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2D2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3F3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5D5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#858484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_49_3501",
    x1: 56.4642,
    y1: 30.6102,
    x2: 58.8986,
    y2: 37.2753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_49_3501",
    x1: 57.9761,
    y1: 30.056,
    x2: 60.4136,
    y2: 36.7305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_49_3501",
    x1: 57.7881,
    y1: 30.1302,
    x2: 60.2146,
    y2: 36.7763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_49_3501",
    x1: 50.6004,
    y1: 48.1863,
    x2: 55.504,
    y2: 34.3883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#646262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_49_3501",
    x1: 51.6878,
    y1: 31.529,
    x2: 54.4381,
    y2: 36.8467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#5A5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#858484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#ABAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_49_3501",
    x1: 50.6415,
    y1: 33.0181,
    x2: 52.8525,
    y2: 37.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#7E7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_49_3501",
    x1: 50.2161,
    y1: 40.8741,
    x2: 52.7983,
    y2: 36.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#383636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_49_3501",
    x1: 59.5272,
    y1: 40.7533,
    x2: 60.9711,
    y2: 43.5338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#454343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#878585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E0DFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_49_3501",
    x1: 58.7626,
    y1: 41.0084,
    x2: 60.798,
    y2: 42.7022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#454343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#878585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E0DFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_49_3501",
    x1: 59.2118,
    y1: 38.0085,
    x2: 60.199,
    y2: 34.3437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#8C8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_49_3501",
    x1: 48.0324,
    y1: 32.4678,
    x2: 52.0733,
    y2: 34.7591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#777676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C3C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_49_3501",
    x1: 46.6418,
    y1: 36.3355,
    x2: 50.5569,
    y2: 37.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#777676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C3C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_49_3501",
    x1: 62.0277,
    y1: 36.9566,
    x2: 61.9913,
    y2: 42.5422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_49_3501",
    x1: 54.1138,
    y1: 47.7379,
    x2: 55.2635,
    y2: 45.4739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#363434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#737171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_49_3501",
    x1: 61.3584,
    y1: 35.2317,
    x2: 57.8641,
    y2: 38.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6A6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_49_3501",
    x1: 60.6269,
    y1: 34.455,
    x2: 57.1294,
    y2: 37.7404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6A6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_49_3501",
    x1: 60.2632,
    y1: 38.9807,
    x2: 58.512,
    y2: 44.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2E2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#434141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#656363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_49_3501",
    x1: 57.78,
    y1: 34.0807,
    x2: 56.8862,
    y2: 37.1069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2E2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#434141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#656363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_49_3501",
    x1: 59.6858,
    y1: 39.354,
    x2: 58.3949,
    y2: 43.7218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#323030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#504E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#807F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_49_3501",
    x1: 58.9707,
    y1: 38.9509,
    x2: 57.6292,
    y2: 43.4926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2D2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3E3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#595858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#807F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B2B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_49_3501",
    x1: 57.0534,
    y1: 37.8843,
    x2: 57.9536,
    y2: 44.0449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2B2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#363434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4A4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#656363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#888686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_49_3501",
    x1: 58.3843,
    y1: 27.4543,
    x2: 60.1112,
    y2: 30.7562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_49_3501",
    x1: 54.1191,
    y1: 26.109,
    x2: 55.7733,
    y2: 29.2702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_49_3501",
    x1: 51.6064,
    y1: 38.2825,
    x2: 53.6655,
    y2: 34.5163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#302E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A2A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_49_3501",
    x1: 52.2124,
    y1: 35.5802,
    x2: 53.1945,
    y2: 37.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#706E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ADACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_49_3501",
    x1: 52.9285,
    y1: 38.12,
    x2: 53.8805,
    y2: 39.9384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#706E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ADACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_49_3501",
    x1: 53.047,
    y1: 38.0689,
    x2: 54.3442,
    y2: 43.2871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#706E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ADACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_49_3501",
    x1: 53.1957,
    y1: 38.0622,
    x2: 54.4914,
    y2: 43.2789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#706E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ADACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_49_3501",
    x1: 55.1614,
    y1: 37.8967,
    x2: 56.1514,
    y2: 39.7878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#706E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ADACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_49_3501",
    x1: 55.1918,
    y1: 37.9645,
    x2: 56.0727,
    y2: 39.6486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3C3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#555353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#787777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A6A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_49_3501",
    x1: 55.8524,
    y1: 35.3857,
    x2: 56.8392,
    y2: 37.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3C3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#555353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#787777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A6A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_49_3501",
    x1: 56.046,
    y1: 35.8229,
    x2: 56.9032,
    y2: 37.4612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3C3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#555353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#787777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A6A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_49_3501",
    x1: 53.884,
    y1: 35.8808,
    x2: 54.893,
    y2: 33.8886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#323030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#504F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#818080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_49_3501",
    x1: 54.0053,
    y1: 35.8247,
    x2: 54.7978,
    y2: 33.8259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#343232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#454343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5C5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_49_3501",
    x1: 98.346,
    y1: 23.8589,
    x2: 103.512,
    y2: 31.8815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_49_3501",
    x1: 101.357,
    y1: 24.9132,
    x2: 103.077,
    y2: 34.5776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_49_3501",
    x1: 101.177,
    y1: 24.9378,
    x2: 102.9,
    y2: 34.6148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_49_3501",
    x1: 95.5879,
    y1: 41.8677,
    x2: 105.339,
    y2: 28.0809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_49_3501",
    x1: 94.9293,
    y1: 41.3743,
    x2: 104.658,
    y2: 27.6175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#434141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#858484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BAB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F7F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_49_3501",
    x1: 99.6104,
    y1: 28.9092,
    x2: 102.364,
    y2: 25.5834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_49_3501",
    x1: 98.4614,
    y1: 30.4495,
    x2: 102.41,
    y2: 27.8233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_49_3501",
    x1: 98.5033,
    y1: 33.2349,
    x2: 102.487,
    y2: 31.4221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_49_3501",
    x1: 99.0985,
    y1: 35.6732,
    x2: 102.555,
    y2: 31.9752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_49_3501",
    x1: 100.019,
    y1: 35.0931,
    x2: 104.407,
    y2: 32.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_49_3501",
    x1: 100.668,
    y1: 36.7596,
    x2: 101.544,
    y2: 36.1772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_49_3501",
    x1: 101.1,
    y1: 33.5963,
    x2: 103.365,
    y2: 32.0891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_49_3501",
    x1: 101.827,
    y1: 32.4555,
    x2: 105.145,
    y2: 30.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_49_3501",
    x1: 101.235,
    y1: 30.712,
    x2: 106.557,
    y2: 27.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_49_3501",
    x1: 100.435,
    y1: 29.1331,
    x2: 107.295,
    y2: 24.5704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_49_3501",
    x1: 100.054,
    y1: 28.1758,
    x2: 104.808,
    y2: 25.0131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_49_3501",
    x1: 100.902,
    y1: 25.6955,
    x2: 102.901,
    y2: 24.3667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_49_3501",
    x1: 98.9124,
    y1: 32.5232,
    x2: 104.797,
    y2: 37.3488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_49_3501",
    x1: 104.462,
    y1: 25.5215,
    x2: 99.0771,
    y2: 30.9308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#636262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#898888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A9A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C4C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_49_3501",
    x1: 101.489,
    y1: 23.5312,
    x2: 100.074,
    y2: 29.5223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_49_3501",
    x1: 99.8206,
    y1: 27.5944,
    x2: 99.8887,
    y2: 31.8381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#636262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#898888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A9A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C4C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_49_3501",
    x1: 96.9643,
    y1: 32.6751,
    x2: 100.916,
    y2: 30.9191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_49_3501",
    x1: 101.313,
    y1: 32.0555,
    x2: 99.3268,
    y2: 33.6751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#484747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7F7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ADACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_49_3501",
    x1: 101.022,
    y1: 32.1708,
    x2: 100.053,
    y2: 39.0127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#656464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A09F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_49_3501",
    x1: 101.091,
    y1: 32.972,
    x2: 101.652,
    y2: 36.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#484747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#7F7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ADACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_49_3501",
    x1: 100.991,
    y1: 32.6693,
    x2: 104.614,
    y2: 34.2407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5F5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D5D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#89898A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#575657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_49_3501",
    x1: 99.7017,
    y1: 30.7047,
    x2: 104.271,
    y2: 31.2125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_49_3501",
    x1: 102.693,
    y1: 29.0445,
    x2: 103.705,
    y2: 29.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#838282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_49_3501",
    x1: 97.7442,
    y1: 32.1913,
    x2: 101.949,
    y2: 28.9649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#292727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#302E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3B3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4C4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#626060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#9D9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_49_3501",
    x1: 96.5718,
    y1: 34.9188,
    x2: 103.172,
    y2: 29.8536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#353333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#605F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#818080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#A9A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_49_3501",
    x1: 98.6196,
    y1: 36.645,
    x2: 101.506,
    y2: 31.6026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#353333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#605F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#818080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A9A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_49_3501",
    x1: 100.908,
    y1: 34.6967,
    x2: 102.489,
    y2: 31.9338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#353333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#474545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#605F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#818080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A9A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_49_3501",
    x1: 28.2596,
    y1: 3.44311,
    x2: 100.354,
    y2: 80.0991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#B9B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7B7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#312F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_49_3501",
    x1: 90.0527,
    y1: -6.04727,
    x2: 60.7552,
    y2: 34.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_49_3501",
    x1: 12.6142,
    y1: 42.3554,
    x2: 58.3844,
    y2: -10.8088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EFECEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_49_3501",
    x1: 112.372,
    y1: 30.5202,
    x2: 12.4264,
    y2: 31.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_49_3501",
    x1: 116.075,
    y1: 18.5127,
    x2: 90.3846,
    y2: 29.8536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ECEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_49_3501",
    x1: 106.285,
    y1: 23.6444,
    x2: 64.9081,
    y2: 51.6868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F2F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_49_3501",
    x1: 16.7083,
    y1: 54.4954,
    x2: -25.2514,
    y2: -10.8244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F3F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_49_3501",
    x1: 42.0799,
    y1: 4.94143,
    x2: 6.68193,
    y2: 45.3409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_49_3501",
    x1: 47.672,
    y1: 5.27639,
    x2: 77.0377,
    y2: 42.4679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_49_3501",
    x1: 55.4397,
    y1: 11.7771,
    x2: 5.35874,
    y2: 38.0511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_49_3501",
    x1: 72.6812,
    y1: 6.79311,
    x2: 31.5529,
    y2: 25.1472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_49_3501",
    x1: 18.4161,
    y1: 11.9338,
    x2: 63.0524,
    y2: 83.5405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_49_3501",
    x1: 59.5549,
    y1: -6.26975,
    x2: 72.9274,
    y2: 43.9797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_49_3501",
    x1: 4.76069,
    y1: 27.5446,
    x2: 40.6216,
    y2: 27.5446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_49_3501",
    x1: 63.6606,
    y1: 4.8986,
    x2: 13.5885,
    y2: 38.5183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_49_3501",
    x1: -0.82302,
    y1: 27.0332,
    x2: 2.32683,
    y2: 27.0332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_49_3501",
    x1: 56.7806,
    y1: 32.5769,
    x2: 14.7337,
    y2: 33.1084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EFEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_49_3501",
    x1: 98.3439,
    y1: 31.2823,
    x2: 54.75,
    y2: 47.1545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EFEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_49_3501",
    x1: 85.9677,
    y1: 1.32655,
    x2: 97.9491,
    y2: 24.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F1F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_49_3501",
    x1: 72.1144,
    y1: 27.7584,
    x2: 117.1,
    y2: 50.3946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_49_3501",
    x1: 105.384,
    y1: 23.6845,
    x2: 32.4569,
    y2: 47.3694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EDECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_49_3501",
    x1: 58.1541,
    y1: 21.9018,
    x2: 141.31,
    y2: 35.1131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EEEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_49_3501",
    x1: 66.8281,
    y1: -15.29,
    x2: 107.245,
    y2: 93.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_49_3501",
    x1: 15.628,
    y1: 32.2632,
    x2: 74.2323,
    y2: 17.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_49_3501",
    x1: 49.6797,
    y1: 24.4399,
    x2: 41.6276,
    y2: 42.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_49_3501",
    x1: 93.3035,
    y1: 13.1178,
    x2: 102.278,
    y2: 34.7392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_49_3501",
    x1: 81.9981,
    y1: 19.8172,
    x2: 81.9981,
    y2: -1.67816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2B2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#383637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#696A6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8E9091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A4A6A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_49_3501",
    x1: -17.0188,
    y1: 44.6955,
    x2: 27.3566,
    y2: 14.5366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#2E2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_49_3501",
    x1: 81.1477,
    y1: 18.3852,
    x2: 83.9324,
    y2: -59.0516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#282727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#191818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#100F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0D0C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_49_3501",
    x1: 83.5771,
    y1: 17.9846,
    x2: 71.7443,
    y2: -10.3172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#272525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A4A6A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_49_3501",
    x1: 86.7517,
    y1: 3.5033,
    x2: 86.4574,
    y2: 13.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_49_3501",
    x1: 80.1065,
    y1: 4.65299,
    x2: 80.1872,
    y2: 15.4592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_49_3501",
    x1: 71.369,
    y1: 5.05924,
    x2: 71.8832,
    y2: 12.4024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_49_3501",
    x1: 91.3758,
    y1: 7.93443,
    x2: 93.7047,
    y2: 21.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_49_3501",
    x1: 62.8285,
    y1: -3.88359,
    x2: 57.2015,
    y2: 16.6651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_49_3501",
    x1: 64.2768,
    y1: 9.13601,
    x2: 64.734,
    y2: 11.8196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_49_3501",
    x1: 49.1295,
    y1: -3.02131,
    x2: 42.0886,
    y2: 18.2009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_49_3501",
    x1: 54.51,
    y1: -4.88016,
    x2: 23.9139,
    y2: 21.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#9D9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#7D7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#626060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4C4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#3B3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#302E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#292727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_49_3501",
    x1: 54.9967,
    y1: -10.3369,
    x2: 53.4493,
    y2: 8.96283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3A3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_49_3501",
    x1: 57.9904,
    y1: -10.7595,
    x2: 56.4462,
    y2: 8.51967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3A3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_49_3501",
    x1: 55.6148,
    y1: -32.7865,
    x2: 51.5977,
    y2: 17.3349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3A3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_49_3501",
    x1: 18.8117,
    y1: 19.1881,
    x2: 32.6242,
    y2: 30.3656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3A3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_49_3501",
    x1: 22.0895,
    y1: 22.4041,
    x2: -5.97727,
    y2: 50.0482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#2E2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_49_3501",
    x1: 2.56106,
    y1: 24.9228,
    x2: 6.40999,
    y2: 38.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#2E2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_49_3501",
    x1: 21.1807,
    y1: 38.8421,
    x2: -0.493934,
    y2: 20.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#7D7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_49_3501",
    x1: -14.6243,
    y1: 34.2308,
    x2: 28.1152,
    y2: 14.9694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#2E2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_49_3501",
    x1: 18.4991,
    y1: 22.2108,
    x2: 1.43778,
    y2: 22.2108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DDDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B4B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7B7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#333131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_49_3501",
    x1: 2.72884,
    y1: 35.401,
    x2: 10.5959,
    y2: 24.9221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_49_3501",
    x1: -6.60741,
    y1: 42.8475,
    x2: 4.57031,
    y2: 35.4425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3A3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_49_3501",
    x1: 0.949445,
    y1: 58.9601,
    x2: 11.1079,
    y2: 38.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3A3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_49_3501",
    x1: 14.3453,
    y1: 48.8862,
    x2: 20.8013,
    y2: 35.6198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D0CFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A3A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7D7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#5E5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#464444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#343333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_49_3501",
    x1: 15.8007,
    y1: 62.9625,
    x2: 29.2868,
    y2: 35.2479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3A3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2C2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_49_3501",
    x1: 7.48678,
    y1: 42.4869,
    x2: 10.7409,
    y2: 31.1989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_49_3501",
    x1: 7.72608,
    y1: 44.1529,
    x2: 11.045,
    y2: 32.6358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_49_3501",
    x1: 8.03088,
    y1: 45.3485,
    x2: 11.1631,
    y2: 34.4825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_49_3501",
    x1: -0.0288195,
    y1: 26.9427,
    x2: 22.5319,
    y2: 48.1219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_49_3501",
    x1: -0.673645,
    y1: 27.6313,
    x2: 21.8839,
    y2: 48.8088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_49_3501",
    x1: -1.36499,
    y1: 28.3653,
    x2: 21.1958,
    y2: 49.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_49_3501",
    x1: -13.8516,
    y1: 29.7022,
    x2: 11.6287,
    y2: 24.6658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_49_3501",
    x1: -5.52278,
    y1: 28.9349,
    x2: 13.3861,
    y2: 24.7344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_49_3501",
    x1: -1.24754,
    y1: 26.9753,
    x2: 17.677,
    y2: 25.5021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_49_3501",
    x1: 1.43867,
    y1: 27.3198,
    x2: 21.2523,
    y2: 25.4996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_49_3501",
    x1: 3.71549,
    y1: 26.897,
    x2: 24.8204,
    y2: 25.8497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_49_3501",
    x1: 5.88655,
    y1: 19.3617,
    x2: 3.64622,
    y2: 35.4447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_49_3501",
    x1: 8.32561,
    y1: 19.2783,
    x2: 6.00935,
    y2: 35.9081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_49_3501",
    x1: 11.1924,
    y1: 19.1595,
    x2: 8.78909,
    y2: 36.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_49_3501",
    x1: 14.6238,
    y1: 18.887,
    x2: 12.0908,
    y2: 37.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_49_3501",
    x1: 18.9374,
    y1: 18.7217,
    x2: 16.311,
    y2: 37.5721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_49_3501",
    x1: 23.0277,
    y1: 54.8271,
    x2: 31.2902,
    y2: 26.1576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_49_3501",
    x1: 23.1132,
    y1: 54.0414,
    x2: 30.1055,
    y2: 29.7776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_49_3501",
    x1: 36.1228,
    y1: 29.8263,
    x2: 22.6937,
    y2: 42.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_49_3501",
    x1: 33.7095,
    y1: 33.2813,
    x2: 22.6273,
    y2: 43.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_49_3501",
    x1: 4.22113,
    y1: 23.6371,
    x2: 0.173589,
    y2: 27.4799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_49_3501",
    x1: 4.2246,
    y1: 25.9054,
    x2: -1.10469,
    y2: 30.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#727171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_49_3501",
    x1: 4.81177,
    y1: 29.6776,
    x2: 26.1313,
    y2: 15.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B2B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#8C8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#535252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3F3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#323030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#292727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_49_3501",
    x1: 4.2763,
    y1: 31.6285,
    x2: 23.0001,
    y2: 18.8383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B2B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#8C8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#535252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3F3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#323030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#292727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_49_3501",
    x1: 78.0273,
    y1: 7.53763,
    x2: 86.7979,
    y2: 7.53763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_49_3501",
    x1: 71.0638,
    y1: 6.25581,
    x2: 84.9204,
    y2: 7.88511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_49_3501",
    x1: 47.8911,
    y1: 14.0334,
    x2: 22.7458,
    y2: 32.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BDBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_49_3501",
    x1: 25.8046,
    y1: 25.2473,
    x2: 46.0476,
    y2: 29.5771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_49_3501",
    x1: 37.6175,
    y1: 21.8936,
    x2: 15.4128,
    y2: 34.9758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EAEAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BCBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9B9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#868788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_49_3501",
    x1: 38.0962,
    y1: 22.7073,
    x2: 15.8804,
    y2: 35.7957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EAEAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BCBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9B9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#868788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_49_3501",
    x1: 38.4842,
    y1: 23.369,
    x2: 16.2795,
    y2: 36.4511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EAEAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BCBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9B9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#868788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_49_3501",
    x1: 28.758,
    y1: 22.9626,
    x2: 31.4124,
    y2: 23.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_49_3501",
    x1: 27.9504,
    y1: 22.7338,
    x2: 33.8512,
    y2: 23.9957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_49_3501",
    x1: 29.0183,
    y1: 23.1206,
    x2: 33.0164,
    y2: 23.9755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_49_3501",
    x1: 29.3841,
    y1: 23.4466,
    x2: 32.8217,
    y2: 24.1816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_49_3501",
    x1: 29.6882,
    y1: 23.9499,
    x2: 32.9615,
    y2: 24.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_49_3501",
    x1: 29.6165,
    y1: 24.2525,
    x2: 30.8418,
    y2: 24.5143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_49_3501",
    x1: 28.6259,
    y1: 25.1918,
    x2: 33.2129,
    y2: 26.1729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_49_3501",
    x1: 29.4643,
    y1: 25.904,
    x2: 34.7224,
    y2: 27.0286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_49_3501",
    x1: 30.4861,
    y1: 25.8873,
    x2: 34.939,
    y2: 26.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_49_3501",
    x1: 29.7101,
    y1: 26.6985,
    x2: 32.175,
    y2: 27.2253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_49_3501",
    x1: 29.4307,
    y1: 26.8529,
    x2: 32.775,
    y2: 27.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_49_3501",
    x1: 31.2895,
    y1: 21.4983,
    x2: 38.2656,
    y2: 22.9889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_49_3501",
    x1: 20.2233,
    y1: 21.5477,
    x2: 148.485,
    y2: 48.9762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#929394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#848586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7F8081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_49_3501",
    x1: 1.3937,
    y1: 17.2013,
    x2: 2.12152,
    y2: 34.7832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_49_3501",
    x1: 2.48865,
    y1: 15.1152,
    x2: 3.47753,
    y2: 38.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_49_3501",
    x1: 6.79661,
    y1: 17.3865,
    x2: 7.6067,
    y2: 36.9472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_49_3501",
    x1: 7.42942,
    y1: 30.3248,
    x2: 7.60662,
    y2: 34.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_49_3501",
    x1: 10.9198,
    y1: 26.9958,
    x2: 11.5622,
    y2: 42.4803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_49_3501",
    x1: 5.3524,
    y1: 31.1586,
    x2: 19.8847,
    y2: 55.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_49_3501",
    x1: -2.44969,
    y1: 19.9363,
    x2: 12.4432,
    y2: 44.6389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_49_3501",
    x1: 67.4442,
    y1: 8.58129,
    x2: 75.8368,
    y2: 28.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_49_3501",
    x1: 68.7579,
    y1: -0.135857,
    x2: 76.5478,
    y2: 18.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_49_3501",
    x1: 72.9362,
    y1: 6.33028,
    x2: 73.4567,
    y2: 16.1154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E8E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_49_3501",
    x1: 71.5531,
    y1: 0.738983,
    x2: 72.2271,
    y2: 13.4212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_49_3501",
    x1: 77.4133,
    y1: -1.02833,
    x2: 78.2408,
    y2: 14.5415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_49_3501",
    x1: 66.8553,
    y1: 7.28981,
    x2: 70.778,
    y2: 16.6705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_49_3501",
    x1: 67.7044,
    y1: 5.93167,
    x2: 72.1157,
    y2: 16.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_49_3501",
    x1: 73.1357,
    y1: 10.2576,
    x2: 67.0139,
    y2: 12.9445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_49_3501",
    x1: 79.825,
    y1: 11.1871,
    x2: 76.1498,
    y2: 12.7996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_49_3501",
    x1: 80.4743,
    y1: 5.8156,
    x2: 68.6698,
    y2: 10.9953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_49_3501",
    x1: 77.2963,
    y1: 4.05189,
    x2: 74.2469,
    y2: 10.8806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_49_3501",
    x1: 69.4857,
    y1: 5.0044,
    x2: 69.973,
    y2: 14.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_49_3501",
    x1: 69.9619,
    y1: 9.60398,
    x2: 70.166,
    y2: 13.4526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_49_3501",
    x1: 73.3997,
    y1: 24.3308,
    x2: 67.6585,
    y2: 0.775668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_49_3501",
    x1: 85.8556,
    y1: 15.322,
    x2: 82.9342,
    y2: 22.2347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_49_3501",
    x1: 82.4693,
    y1: 14.0224,
    x2: 85.8985,
    y2: 22.2229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_49_3501",
    x1: 86.4447,
    y1: 16.9054,
    x2: 80.9485,
    y2: 21.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_49_3501",
    x1: 86.276,
    y1: 17.3262,
    x2: 79.0656,
    y2: 21.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_49_3501",
    x1: 97.7715,
    y1: 15.7801,
    x2: 95.2993,
    y2: 21.6262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_49_3501",
    x1: 94.9355,
    y1: 14.7416,
    x2: 97.7905,
    y2: 21.5689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_49_3501",
    x1: 98.0444,
    y1: 17.304,
    x2: 94.0099,
    y2: 20.7627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F0EFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_49_3501",
    x1: 97.9114,
    y1: 17.6111,
    x2: 92.6537,
    y2: 20.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F0EFEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCar);
export default __webpack_public_path__ + "static/media/whiteCar.4fd79d3a41b12d9f6afca6e12e609b8a.svg";
export { ForwardRef as ReactComponent };